/* tslint:disable */
/* eslint-disable */
/**
 * Backbone API
 * <strong>Using API Key Authentication</strong>        <br /><br /> <p>To authenticate with the api key:</p>        <pre>       curl --location --request POST \'https://prod-api.backboneapp.co/api/v2/users/login\'       --header \'x-api-key: {API-KEY}\'       --header \'Content-Type: application/json\'       </pre>       <p>Each following request:</p>       <pre>       curl --location --request GET \'https://prod-api.backboneapp.co/api/v2/products\'       --header \'x-api-key: {API-KEY}\'       --header \'Content-Type: application/json\'       --header \'authentication: {\'token\' from the login route response}\'        </pre>
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AddColorwayDTO
 */
export interface AddColorwayDTO {
    /**
     * 
     * @type {Array<Colorway>}
     * @memberof AddColorwayDTO
     */
    'colorways': Array<Colorway>;
}
/**
 * 
 * @export
 * @interface BomDivider
 */
export interface BomDivider {
    /**
     * 
     * @type {string}
     * @memberof BomDivider
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof BomDivider
     */
    'position': number;
    /**
     * 
     * @type {number}
     * @memberof BomDivider
     */
    'identifier': number;
}
/**
 * 
 * @export
 * @interface BomItem
 */
export interface BomItem {
    /**
     * 
     * @type {string}
     * @memberof BomItem
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof BomItem
     */
    'component': string;
    /**
     * 
     * @type {string}
     * @memberof BomItem
     */
    'product': string;
    /**
     * 
     * @type {boolean}
     * @memberof BomItem
     */
    'isFactory': boolean;
    /**
     * 
     * @type {object}
     * @memberof BomItem
     */
    'factory_supplied_component': object;
    /**
     * 
     * @type {number}
     * @memberof BomItem
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof BomItem
     */
    'bom_template': string;
    /**
     * 
     * @type {Array<ComponentVariant>}
     * @memberof BomItem
     */
    'component_variants': Array<ComponentVariant>;
    /**
     * 
     * @type {BomStatus}
     * @memberof BomItem
     */
    'status': BomStatus;
    /**
     * 
     * @type {string}
     * @memberof BomItem
     */
    'quantity_unit': string;
    /**
     * 
     * @type {boolean}
     * @memberof BomItem
     */
    'hidden': boolean;
    /**
     * 
     * @type {string}
     * @memberof BomItem
     */
    'notes': string;
    /**
     * 
     * @type {string}
     * @memberof BomItem
     */
    'placement': string;
    /**
     * 
     * @type {string}
     * @memberof BomItem
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof BomItem
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof BomItem
     */
    '__copiedFrom': string;
}
/**
 * 
 * @export
 * @interface BomItemQueryDTO
 */
export interface BomItemQueryDTO {
    /**
     * 
     * @type {string}
     * @memberof BomItemQueryDTO
     */
    'component_id': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BomItemQueryDTO
     */
    'color_ids'?: Array<string>;
    /**
     * 
     * @type {Array<ComponentVariantFields>}
     * @memberof BomItemQueryDTO
     */
    'fields_to_match'?: Array<ComponentVariantFields>;
}
/**
 * 
 * @export
 * @interface BomItemWithComponentVariantTypes
 */
export interface BomItemWithComponentVariantTypes {
    /**
     * 
     * @type {string}
     * @memberof BomItemWithComponentVariantTypes
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof BomItemWithComponentVariantTypes
     */
    'product': string;
    /**
     * 
     * @type {boolean}
     * @memberof BomItemWithComponentVariantTypes
     */
    'isFactory': boolean;
    /**
     * 
     * @type {object}
     * @memberof BomItemWithComponentVariantTypes
     */
    'factory_supplied_component': object;
    /**
     * 
     * @type {number}
     * @memberof BomItemWithComponentVariantTypes
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof BomItemWithComponentVariantTypes
     */
    'bom_template': string;
    /**
     * 
     * @type {Array<ComponentVariant>}
     * @memberof BomItemWithComponentVariantTypes
     */
    'component_variants': Array<ComponentVariant>;
    /**
     * 
     * @type {BomStatus}
     * @memberof BomItemWithComponentVariantTypes
     */
    'status': BomStatus;
    /**
     * 
     * @type {string}
     * @memberof BomItemWithComponentVariantTypes
     */
    'quantity_unit': string;
    /**
     * 
     * @type {boolean}
     * @memberof BomItemWithComponentVariantTypes
     */
    'hidden': boolean;
    /**
     * 
     * @type {string}
     * @memberof BomItemWithComponentVariantTypes
     */
    'notes': string;
    /**
     * 
     * @type {string}
     * @memberof BomItemWithComponentVariantTypes
     */
    'placement': string;
    /**
     * 
     * @type {string}
     * @memberof BomItemWithComponentVariantTypes
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof BomItemWithComponentVariantTypes
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof BomItemWithComponentVariantTypes
     */
    '__copiedFrom': string;
    /**
     * 
     * @type {Component}
     * @memberof BomItemWithComponentVariantTypes
     */
    'component': Component;
}
/**
 * 
 * @export
 * @interface BomStatus
 */
export interface BomStatus {
    /**
     * 
     * @type {string}
     * @memberof BomStatus
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof BomStatus
     */
    'color': string;
    /**
     * 
     * @type {number}
     * @memberof BomStatus
     */
    'position': number;
}
/**
 * 
 * @export
 * @interface BomTemplate
 */
export interface BomTemplate {
    /**
     * 
     * @type {string}
     * @memberof BomTemplate
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof BomTemplate
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BomTemplate
     */
    'company': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BomTemplate
     */
    'bom_items': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BomTemplate
     */
    'image': string;
    /**
     * 
     * @type {Array<BomDivider>}
     * @memberof BomTemplate
     */
    'bom_dividers': Array<BomDivider>;
    /**
     * 
     * @type {string}
     * @memberof BomTemplate
     */
    '__copiedFrom': string;
    /**
     * 
     * @type {string}
     * @memberof BomTemplate
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof BomTemplate
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof BomTemplate
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface Brand
 */
export interface Brand {
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'logo': string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface BulkDeletePomsDTO
 */
export interface BulkDeletePomsDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkDeletePomsDTO
     */
    'pomIds': Array<string>;
}
/**
 * 
 * @export
 * @interface BulkEditVariantsDTO
 */
export interface BulkEditVariantsDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkEditVariantsDTO
     */
    'updates': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof BulkEditVariantsDTO
     */
    'reorder'?: boolean;
}
/**
 * 
 * @export
 * @interface Category
 */
export interface Category {
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    'company': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Category
     */
    'children': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    'parent': string;
    /**
     * 
     * @type {number}
     * @memberof Category
     */
    'order': number;
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface Colorway
 */
export interface Colorway {
    /**
     * 
     * @type {string}
     * @memberof Colorway
     */
    'custom_color': string;
}
/**
 * 
 * @export
 * @interface CommentMarker
 */
export interface CommentMarker {
    /**
     * 
     * @type {string}
     * @memberof CommentMarker
     */
    'marker_id': string;
    /**
     * 
     * @type {string}
     * @memberof CommentMarker
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof CommentMarker
     */
    'marker_color': string;
    /**
     * 
     * @type {string}
     * @memberof CommentMarker
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof CommentMarker
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof CommentMarker
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof CommentMarker
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface Company
 */
export interface Company {
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'logo'?: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'currency': string;
    /**
     * 
     * @type {Array<TechpackSection>}
     * @memberof Company
     */
    'techpack_sections': Array<TechpackSection>;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'status'?: string;
    /**
     * 
     * @type {number}
     * @memberof Company
     */
    'tier': number;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface Component
 */
export interface Component {
    /**
     * 
     * @type {string}
     * @memberof Component
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof Component
     */
    'brand': string;
    /**
     * 
     * @type {string}
     * @memberof Component
     */
    'year': string;
    /**
     * 
     * @type {string}
     * @memberof Component
     */
    'division': string;
    /**
     * 
     * @type {string}
     * @memberof Component
     */
    'season': string;
    /**
     * 
     * @type {string}
     * @memberof Component
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof Component
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Component
     */
    'code': string;
    /**
     * 
     * @type {Array<Colorway>}
     * @memberof Component
     */
    'colorways': Array<Colorway>;
    /**
     * 
     * @type {string}
     * @memberof Component
     */
    'component_type': string;
    /**
     * 
     * @type {Array<TechpackImage>}
     * @memberof Component
     */
    'techpack_images': Array<TechpackImage>;
    /**
     * 
     * @type {string}
     * @memberof Component
     */
    'price': string;
    /**
     * 
     * @type {string}
     * @memberof Component
     */
    'price_unit': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Component
     */
    'files': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof Component
     */
    'canceled': boolean;
    /**
     * 
     * @type {Array<CustomFieldValue>}
     * @memberof Component
     */
    'custom_fields'?: Array<CustomFieldValue>;
    /**
     * 
     * @type {string}
     * @memberof Component
     */
    '__copiedFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof Component
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Component
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ComponentColorSelection
 */
export interface ComponentColorSelection {
    /**
     * product variant id
     * @type {string}
     * @memberof ComponentColorSelection
     */
    'productVariant': string;
    /**
     * 
     * @type {ComponentColorSelectionComponentColorVariant}
     * @memberof ComponentColorSelection
     */
    'componentColorVariant'?: ComponentColorSelectionComponentColorVariant;
}
/**
 * @type ComponentColorSelectionComponentColorVariant
 * component variant color value
 * @export
 */
export type ComponentColorSelectionComponentColorVariant = NotUsedComponentColor | SelectedComponentColor | UndefinedComponentColor;

/**
 * 
 * @export
 * @interface ComponentMarker
 */
export interface ComponentMarker {
    /**
     * 
     * @type {string}
     * @memberof ComponentMarker
     */
    'marker_id': string;
    /**
     * 
     * @type {string}
     * @memberof ComponentMarker
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof ComponentMarker
     */
    'component': string;
    /**
     * 
     * @type {string}
     * @memberof ComponentMarker
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof ComponentMarker
     */
    'marker_color': string;
    /**
     * 
     * @type {string}
     * @memberof ComponentMarker
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ComponentMarker
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ComponentSourceFileDTO
 */
export interface ComponentSourceFileDTO {
    /**
     * 
     * @type {string}
     * @memberof ComponentSourceFileDTO
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof ComponentSourceFileDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ComponentSourceFileDTO
     */
    'caption': string;
    /**
     * 
     * @type {Array<TechpackImageDTO>}
     * @memberof ComponentSourceFileDTO
     */
    'images'?: Array<TechpackImageDTO>;
}
/**
 * 
 * @export
 * @interface ComponentType
 */
export interface ComponentType {
    /**
     * 
     * @type {string}
     * @memberof ComponentType
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ComponentType
     */
    'company': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ComponentType
     */
    'children': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ComponentType
     */
    'parent': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ComponentType
     */
    'miscellaneous': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ComponentType
     */
    'order': number;
    /**
     * 
     * @type {string}
     * @memberof ComponentType
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ComponentType
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ComponentUtilizationReport
 */
export interface ComponentUtilizationReport {
    /**
     * 
     * @type {string}
     * @memberof ComponentUtilizationReport
     */
    '__copiedFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ComponentUtilizationReport
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ComponentUtilizationReport
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof ComponentUtilizationReport
     */
    'updated_by': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ComponentUtilizationReport
     */
    'component_types'?: Array<string>;
    /**
     * 
     * @type {Array<CustomFields>}
     * @memberof ComponentUtilizationReport
     */
    'component_custom_fields'?: Array<CustomFields>;
    /**
     * 
     * @type {ProductTaxonomySet}
     * @memberof ComponentUtilizationReport
     */
    'product_taxonomy_set'?: ProductTaxonomySet;
    /**
     * 
     * @type {Array<CustomFields>}
     * @memberof ComponentUtilizationReport
     */
    'product_custom_fields'?: Array<CustomFields>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ComponentUtilizationReport
     */
    'custom_field_columns'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ComponentUtilizationReport
     */
    'product_taxonomy_columns'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ComponentUtilizationReport
     */
    'component_taxonomy_columns'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ComponentUtilizationReport
     */
    'shared_users'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ComponentUtilizationReport
     */
    'display_component_types': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ComponentUtilizationReport
     */
    'display_bom_notes': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ComponentUtilizationReport
     */
    'display_bom_placement': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ComponentUtilizationReport
     */
    'brands'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ComponentUtilizationReport
     */
    'company': string;
}
/**
 * 
 * @export
 * @interface ComponentVariant
 */
export interface ComponentVariant {
    /**
     * 
     * @type {boolean}
     * @memberof ComponentVariant
     */
    'inherit_component_price': boolean;
    /**
     * 
     * @type {string}
     * @memberof ComponentVariant
     */
    'variant': string;
    /**
     * 
     * @type {ComponentVariantData}
     * @memberof ComponentVariant
     */
    'data': ComponentVariantData;
}
/**
 * 
 * @export
 * @interface ComponentVariantData
 */
export interface ComponentVariantData {
    /**
     * 
     * @type {ComponentVariantDataComponentColor}
     * @memberof ComponentVariantData
     */
    'component_color'?: ComponentVariantDataComponentColor | null;
    /**
     * 
     * @type {number}
     * @memberof ComponentVariantData
     */
    'price'?: number;
    /**
     * 
     * @type {string}
     * @memberof ComponentVariantData
     */
    'factory_supplied_component_description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ComponentVariantData
     */
    'code'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ComponentVariantData
     */
    'images': Array<string>;
    /**
     * 
     * @type {Array<ComponentVariantFields>}
     * @memberof ComponentVariantData
     */
    'fields': Array<ComponentVariantFields>;
}
/**
 * @type ComponentVariantDataComponentColor
 * @export
 */
export type ComponentVariantDataComponentColor = NotUsedComponentColor | SelectedComponentColor | UndefinedComponentColor;

/**
 * 
 * @export
 * @interface ComponentVariantFields
 */
export interface ComponentVariantFields {
    /**
     * 
     * @type {string}
     * @memberof ComponentVariantFields
     */
    'key': string;
    /**
     * variant value reference or null. Null here corresponds to an \"Undefined\" state in user land.
     * @type {string}
     * @memberof ComponentVariantFields
     */
    'value': string | null;
}
/**
 * 
 * @export
 * @interface ComponentVariantSelection
 */
export interface ComponentVariantSelection {
    /**
     * reference to a custom variant type
     * @type {string}
     * @memberof ComponentVariantSelection
     */
    'key': string | null;
    /**
     * reference to a custom variant value
     * @type {string}
     * @memberof ComponentVariantSelection
     */
    'value': string | null;
}
/**
 * 
 * @export
 * @interface ComponentsControllerQueryComponents200Response
 */
export interface ComponentsControllerQueryComponents200Response {
    /**
     * 
     * @type {number}
     * @memberof ComponentsControllerQueryComponents200Response
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof ComponentsControllerQueryComponents200Response
     */
    'limit': number;
    /**
     * 
     * @type {number}
     * @memberof ComponentsControllerQueryComponents200Response
     */
    'skip': number;
    /**
     * 
     * @type {Array<Component>}
     * @memberof ComponentsControllerQueryComponents200Response
     */
    'results'?: Array<Component>;
}
/**
 * 
 * @export
 * @interface ComponentsControllerQueryComponents200ResponseAllOf
 */
export interface ComponentsControllerQueryComponents200ResponseAllOf {
    /**
     * 
     * @type {Array<Component>}
     * @memberof ComponentsControllerQueryComponents200ResponseAllOf
     */
    'results'?: Array<Component>;
}
/**
 * 
 * @export
 * @interface ConstructionDetail
 */
export interface ConstructionDetail {
    /**
     * 
     * @type {string}
     * @memberof ConstructionDetail
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof ConstructionDetail
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof ConstructionDetail
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConstructionDetail
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConstructionDetail
     */
    'description'?: string;
    /**
     * 
     * @type {Array<TechpackImage>}
     * @memberof ConstructionDetail
     */
    'techpack_images': Array<TechpackImage>;
    /**
     * 
     * @type {string}
     * @memberof ConstructionDetail
     */
    'removed_from_search'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConstructionDetail
     */
    'created_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConstructionDetail
     */
    'updated_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConstructionDetail
     */
    '__copiedFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConstructionDetail
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ConstructionDetail
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ConstructionDetailMarker
 */
export interface ConstructionDetailMarker {
    /**
     * 
     * @type {string}
     * @memberof ConstructionDetailMarker
     */
    'marker_id': string;
    /**
     * 
     * @type {string}
     * @memberof ConstructionDetailMarker
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof ConstructionDetailMarker
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof ConstructionDetailMarker
     */
    'marker_color': string;
    /**
     * 
     * @type {string}
     * @memberof ConstructionDetailMarker
     */
    'construction_detail': string;
    /**
     * 
     * @type {string}
     * @memberof ConstructionDetailMarker
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ConstructionDetailMarker
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface Contact
 */
export interface Contact {
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'authentication_key'?: string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'updated_by': string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'created_by': string;
}
/**
 * 
 * @export
 * @interface ConvertImageDTO
 */
export interface ConvertImageDTO {
    /**
     * 
     * @type {string}
     * @memberof ConvertImageDTO
     */
    'file_name': string;
    /**
     * 
     * @type {string}
     * @memberof ConvertImageDTO
     */
    'file_url': string;
    /**
     * 
     * @type {string}
     * @memberof ConvertImageDTO
     */
    'file_type': string;
    /**
     * 
     * @type {object}
     * @memberof ConvertImageDTO
     */
    'source_file_id'?: object;
}
/**
 * 
 * @export
 * @interface CopyProductImageAnnotationDTO
 */
export interface CopyProductImageAnnotationDTO {
    /**
     * 
     * @type {string}
     * @memberof CopyProductImageAnnotationDTO
     */
    'sourceImageId': string;
    /**
     * 
     * @type {string}
     * @memberof CopyProductImageAnnotationDTO
     */
    'destinationImageId': string;
}
/**
 * 
 * @export
 * @interface CopyRevisionImageDTO
 */
export interface CopyRevisionImageDTO {
    /**
     * 
     * @type {string}
     * @memberof CopyRevisionImageDTO
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CopyRevisionImageDTO
     */
    'caption'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CopyRevisionImageDTO
     */
    'front_page'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CopyRevisionImageDTO
     */
    'is_archived'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CopyRevisionImageDTO
     */
    'position'?: number;
}
/**
 * 
 * @export
 * @interface CreateBomItemDTO
 */
export interface CreateBomItemDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateBomItemDTO
     */
    'component': string;
    /**
     * 
     * @type {number}
     * @memberof CreateBomItemDTO
     */
    'position': number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBomItemDTO
     */
    'isFactory': boolean;
    /**
     * 
     * @type {FactorySuppliedComponent}
     * @memberof CreateBomItemDTO
     */
    'factory_supplied_component': FactorySuppliedComponent;
}
/**
 * 
 * @export
 * @interface CreateBomTemplateDTO
 */
export interface CreateBomTemplateDTO {
    /**
     * 
     * @type {CreateBomTemplateImageDTO}
     * @memberof CreateBomTemplateDTO
     */
    'image'?: CreateBomTemplateImageDTO;
    /**
     * 
     * @type {object}
     * @memberof CreateBomTemplateDTO
     */
    'productId'?: object;
    /**
     * 
     * @type {string}
     * @memberof CreateBomTemplateDTO
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface CreateBomTemplateImageDTO
 */
export interface CreateBomTemplateImageDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateBomTemplateImageDTO
     */
    'file_name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBomTemplateImageDTO
     */
    'file_url': string;
}
/**
 * 
 * @export
 * @interface CreateCompanyDto
 */
export interface CreateCompanyDto {
    /**
     * 
     * @type {User}
     * @memberof CreateCompanyDto
     */
    'user': User;
    /**
     * 
     * @type {Company}
     * @memberof CreateCompanyDto
     */
    'company': Company;
}
/**
 * 
 * @export
 * @interface CreateComponentDTO
 */
export interface CreateComponentDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateComponentDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateComponentDTO
     */
    'code': string;
    /**
     * 
     * @type {object}
     * @memberof CreateComponentDTO
     */
    'component_type': object;
    /**
     * 
     * @type {string}
     * @memberof CreateComponentDTO
     */
    'price'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateComponentDTO
     */
    'canceled'?: boolean;
    /**
     * 
     * @type {object}
     * @memberof CreateComponentDTO
     */
    'price_unit'?: object;
    /**
     * 
     * @type {object}
     * @memberof CreateComponentDTO
     */
    'brand'?: object;
    /**
     * 
     * @type {object}
     * @memberof CreateComponentDTO
     */
    'year'?: object;
    /**
     * 
     * @type {object}
     * @memberof CreateComponentDTO
     */
    'division'?: object;
    /**
     * 
     * @type {object}
     * @memberof CreateComponentDTO
     */
    'season'?: object;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateComponentDTO
     */
    'colorways'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateComponentDTO
     */
    'files'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateComponentDTO
     */
    'custom_fields'?: Array<string>;
    /**
     * 
     * @type {Array<ComponentSourceFileDTO>}
     * @memberof CreateComponentDTO
     */
    'source_files'?: Array<ComponentSourceFileDTO>;
}
/**
 * 
 * @export
 * @interface CreateConstructionDetailDTO
 */
export interface CreateConstructionDetailDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateConstructionDetailDTO
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CreateContactDTO
 */
export interface CreateContactDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateContactDTO
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface CreateCustomFieldDTO
 */
export interface CreateCustomFieldDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateCustomFieldDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomFieldDTO
     */
    'location': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomFieldDTO
     */
    'type': CreateCustomFieldDTOTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof CreateCustomFieldDTO
     */
    'position': number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCustomFieldDTO
     */
    'on_reports': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCustomFieldDTO
     */
    'on_bom': boolean;
    /**
     * 
     * @type {Array<DropdownDTO>}
     * @memberof CreateCustomFieldDTO
     */
    'dropdown_options'?: Array<DropdownDTO>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCustomFieldDTO
     */
    'assigned_taxonomies': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomFieldDTO
     */
    'divider': string;
}

export const CreateCustomFieldDTOTypeEnum = {
    TextArea: 'Text-Area',
    Checkbox: 'Checkbox',
    Dropdown: 'Dropdown',
    Number: 'Number',
    Date: 'Date'
} as const;

export type CreateCustomFieldDTOTypeEnum = typeof CreateCustomFieldDTOTypeEnum[keyof typeof CreateCustomFieldDTOTypeEnum];

/**
 * 
 * @export
 * @interface CreateFileDto
 */
export interface CreateFileDto {
    /**
     * 
     * @type {string}
     * @memberof CreateFileDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFileDto
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFileDto
     */
    'caption'?: string;
}
/**
 * 
 * @export
 * @interface CreateFilesSignedUrlDto
 */
export interface CreateFilesSignedUrlDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateFilesSignedUrlDto
     */
    'files': Array<string>;
}
/**
 * 
 * @export
 * @interface CreateImageDTO
 */
export interface CreateImageDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateImageDTO
     */
    'file_name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateImageDTO
     */
    'file_url': string;
    /**
     * 
     * @type {string}
     * @memberof CreateImageDTO
     */
    'file_type': string;
    /**
     * 
     * @type {object}
     * @memberof CreateImageDTO
     */
    'sectionId'?: object;
    /**
     * 
     * @type {object}
     * @memberof CreateImageDTO
     */
    'colorwayId'?: object;
    /**
     * 
     * @type {object}
     * @memberof CreateImageDTO
     */
    'revision'?: object;
}
/**
 * 
 * @export
 * @interface CreateLineSheetDTO
 */
export interface CreateLineSheetDTO {
    /**
     * 
     * @type {FilterDTO}
     * @memberof CreateLineSheetDTO
     */
    'filters': FilterDTO;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateLineSheetDTO
     */
    'selected_items': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateLineSheetDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLineSheetDTO
     */
    'image': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateLineSheetDTO
     */
    'visible_fields': Array<string>;
    /**
     * 
     * @type {Array<SortDTO>}
     * @memberof CreateLineSheetDTO
     */
    'sort_preference': Array<SortDTO>;
    /**
     * 
     * @type {string}
     * @memberof CreateLineSheetDTO
     */
    'report_mode': string;
}
/**
 * 
 * @export
 * @interface CreatePaletteDto
 */
export interface CreatePaletteDto {
    /**
     * 
     * @type {string}
     * @memberof CreatePaletteDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CreateProductDTO
 */
export interface CreateProductDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateProductDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductDTO
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductDTO
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductDTO
     */
    'price'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductDTO
     */
    'price_unit'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductDTO
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductDTO
     */
    'brand'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductDTO
     */
    'year'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductDTO
     */
    'division'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductDTO
     */
    'season'?: string;
    /**
     * 
     * @type {Array<CreateVariantDTO>}
     * @memberof CreateProductDTO
     */
    'variants'?: Array<CreateVariantDTO>;
    /**
     * 
     * @type {Array<ProductFileDTO>}
     * @memberof CreateProductDTO
     */
    'files'?: Array<ProductFileDTO>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateProductDTO
     */
    'custom_fields'?: Array<string>;
    /**
     * 
     * @type {Array<ProductSourceFileDTO>}
     * @memberof CreateProductDTO
     */
    'source_files'?: Array<ProductSourceFileDTO>;
}
/**
 * 
 * @export
 * @interface CreateSourceFileDto
 */
export interface CreateSourceFileDto {
    /**
     * 
     * @type {string}
     * @memberof CreateSourceFileDto
     */
    'file_name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSourceFileDto
     */
    'file_url': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSourceFileDto
     */
    'file_type': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSourceFileDto
     */
    'caption'?: string;
    /**
     * 
     * @type {object}
     * @memberof CreateSourceFileDto
     */
    'revision'?: object;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSourceFileDto
     */
    'artboards': Array<string>;
}
/**
 * 
 * @export
 * @interface CreateUserDto
 */
export interface CreateUserDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'locale'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'status': CreateUserDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'role': CreateUserDtoRoleEnum;
}

export const CreateUserDtoStatusEnum = {
    Enabled: 'ENABLED',
    Disabled: 'DISABLED',
    Invited: 'INVITED',
    Archived: 'ARCHIVED'
} as const;

export type CreateUserDtoStatusEnum = typeof CreateUserDtoStatusEnum[keyof typeof CreateUserDtoStatusEnum];
export const CreateUserDtoRoleEnum = {
    Admin: 'Admin',
    Manager: 'Manager',
    Contributor: 'Contributor',
    ReadOnly: 'Read Only'
} as const;

export type CreateUserDtoRoleEnum = typeof CreateUserDtoRoleEnum[keyof typeof CreateUserDtoRoleEnum];

/**
 * 
 * @export
 * @interface CreateVariantDTO
 */
export interface CreateVariantDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateVariantDTO
     */
    'images'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateVariantDTO
     */
    'color'?: string;
    /**
     * 
     * @type {Array<CustomFieldDTO>}
     * @memberof CreateVariantDTO
     */
    'custom_fields'?: Array<CustomFieldDTO>;
}
/**
 * 
 * @export
 * @interface CreateVariantTypeDTO
 */
export interface CreateVariantTypeDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateVariantTypeDTO
     */
    'name': string;
    /**
     * 
     * @type {Array<object>}
     * @memberof CreateVariantTypeDTO
     */
    'options': Array<object>;
}
/**
 * 
 * @export
 * @interface CreateVariantsControllerDTO
 */
export interface CreateVariantsControllerDTO {
    /**
     * 
     * @type {Array<CreateVariantDTO>}
     * @memberof CreateVariantsControllerDTO
     */
    'variants': Array<CreateVariantDTO>;
}
/**
 * 
 * @export
 * @interface CustomField
 */
export interface CustomField {
    /**
     * 
     * @type {string}
     * @memberof CustomField
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CustomField
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof CustomField
     */
    'location': string;
    /**
     * 
     * @type {number}
     * @memberof CustomField
     */
    'position': number;
    /**
     * 
     * @type {string}
     * @memberof CustomField
     */
    'company': string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomField
     */
    'on_reports': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomField
     */
    'on_bom': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomField
     */
    'assigned_taxonomies': Array<string>;
    /**
     * 
     * @type {Array<DropdownOption>}
     * @memberof CustomField
     */
    'dropdown_options': Array<DropdownOption>;
    /**
     * 
     * @type {string}
     * @memberof CustomField
     */
    '__copiedFrom': string;
    /**
     * 
     * @type {string}
     * @memberof CustomField
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof CustomField
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface CustomFieldDTO
 */
export interface CustomFieldDTO {
    /**
     * 
     * @type {object}
     * @memberof CustomFieldDTO
     */
    'field_info': object;
    /**
     * 
     * @type {CustomFieldDTOValue}
     * @memberof CustomFieldDTO
     */
    'value': CustomFieldDTOValue;
}
/**
 * @type CustomFieldDTOValue
 * @export
 */
export type CustomFieldDTOValue = boolean | number | string;

/**
 * 
 * @export
 * @interface CustomFieldDivider
 */
export interface CustomFieldDivider {
    /**
     * 
     * @type {string}
     * @memberof CustomFieldDivider
     */
    'company'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomFieldDivider
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CustomFieldDivider
     */
    'location': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomFieldDivider
     */
    'custom_fields'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CustomFieldDivider
     */
    'position': number;
    /**
     * 
     * @type {string}
     * @memberof CustomFieldDivider
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomFieldDivider
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomFieldDivider
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomFieldDivider
     */
    'updatedBy'?: string;
}
/**
 * 
 * @export
 * @interface CustomFieldValue
 */
export interface CustomFieldValue {
    /**
     * 
     * @type {string}
     * @memberof CustomFieldValue
     */
    'field_info': string;
    /**
     * 
     * @type {number}
     * @memberof CustomFieldValue
     */
    'value': CustomFieldValueValueEnum;
}

export const CustomFieldValueValueEnum = {
    NUMBER_null: null,
    NUMBER_null: null,
    NUMBER_null: null
} as const;

export type CustomFieldValueValueEnum = typeof CustomFieldValueValueEnum[keyof typeof CustomFieldValueValueEnum];

/**
 * 
 * @export
 * @interface CustomFields
 */
export interface CustomFields {
    /**
     * 
     * @type {string}
     * @memberof CustomFields
     */
    'field_id': string;
    /**
     * 
     * @type {CustomFieldsFieldValue}
     * @memberof CustomFields
     */
    'field_value': CustomFieldsFieldValue;
}
/**
 * @type CustomFieldsFieldValue
 * @export
 */
export type CustomFieldsFieldValue = boolean | number | string;

/**
 * 
 * @export
 * @interface DateFilter
 */
export interface DateFilter {
    /**
     * 
     * @type {string}
     * @memberof DateFilter
     */
    'start_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof DateFilter
     */
    'end_date'?: string;
}
/**
 * 
 * @export
 * @interface DeleteBomItemsRequestDTO
 */
export interface DeleteBomItemsRequestDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeleteBomItemsRequestDTO
     */
    'bom_items': Array<string>;
}
/**
 * 
 * @export
 * @interface DeleteBomItemsResponseDTO
 */
export interface DeleteBomItemsResponseDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeleteBomItemsResponseDTO
     */
    'bom_items': Array<string>;
    /**
     * 
     * @type {Array<BomDivider>}
     * @memberof DeleteBomItemsResponseDTO
     */
    'bom_dividers': Array<BomDivider>;
}
/**
 * 
 * @export
 * @interface DeleteComponentImagesDTO
 */
export interface DeleteComponentImagesDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeleteComponentImagesDTO
     */
    'ids': Array<string>;
}
/**
 * 
 * @export
 * @interface DeleteProductImagesDTO
 */
export interface DeleteProductImagesDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeleteProductImagesDTO
     */
    'ids': Array<string>;
}
/**
 * 
 * @export
 * @interface Division
 */
export interface Division {
    /**
     * 
     * @type {string}
     * @memberof Division
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Division
     */
    'company': string;
    /**
     * 
     * @type {number}
     * @memberof Division
     */
    'order': number;
    /**
     * 
     * @type {string}
     * @memberof Division
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Division
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface DropdownDTO
 */
export interface DropdownDTO {
    /**
     * 
     * @type {string}
     * @memberof DropdownDTO
     */
    'title': string;
}
/**
 * 
 * @export
 * @interface DropdownOption
 */
export interface DropdownOption {
    /**
     * 
     * @type {string}
     * @memberof DropdownOption
     */
    'title': string;
}
/**
 * 
 * @export
 * @interface EditCustomFieldDTO
 */
export interface EditCustomFieldDTO {
    /**
     * 
     * @type {object}
     * @memberof EditCustomFieldDTO
     */
    'field_info': object;
    /**
     * 
     * @type {CustomFieldDTOValue}
     * @memberof EditCustomFieldDTO
     */
    'value': CustomFieldDTOValue;
}
/**
 * 
 * @export
 * @interface EditVariantDTO
 */
export interface EditVariantDTO {
    /**
     * 
     * @type {string}
     * @memberof EditVariantDTO
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof EditVariantDTO
     */
    'images'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditVariantDTO
     */
    'color'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditVariantDTO
     */
    'deactivatedAt'?: string;
    /**
     * 
     * @type {Array<EditCustomFieldDTO>}
     * @memberof EditVariantDTO
     */
    'custom_fields'?: Array<EditCustomFieldDTO>;
}
/**
 * 
 * @export
 * @interface EmailContentDto
 */
export interface EmailContentDto {
    /**
     * 
     * @type {string}
     * @memberof EmailContentDto
     */
    'email_body': string;
    /**
     * 
     * @type {Array<SignedUrlDto>}
     * @memberof EmailContentDto
     */
    'report_urls': Array<SignedUrlDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof EmailContentDto
     */
    'files'?: Array<string>;
}
/**
 * 
 * @export
 * @interface EmailProductTechpackDto
 */
export interface EmailProductTechpackDto {
    /**
     * 
     * @type {EmailContentDto}
     * @memberof EmailProductTechpackDto
     */
    'content': EmailContentDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof EmailProductTechpackDto
     */
    'receiver_emails': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof EmailProductTechpackDto
     */
    'email_subject'?: string;
}
/**
 * 
 * @export
 * @interface FactorySuppliedComponent
 */
export interface FactorySuppliedComponent {
    /**
     * 
     * @type {string}
     * @memberof FactorySuppliedComponent
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof FactorySuppliedComponent
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof FactorySuppliedComponent
     */
    'price_unit': string;
}
/**
 * 
 * @export
 * @interface Filter
 */
export interface Filter {
    /**
     * 
     * @type {Array<string>}
     * @memberof Filter
     */
    'season'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Filter
     */
    'year'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Filter
     */
    'division'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Filter
     */
    'brand'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Filter
     */
    'category'?: Array<string>;
    /**
     * 
     * @type {Array<Array<FilterCustomFieldsInnerInner>>}
     * @memberof Filter
     */
    'custom_fields'?: Array<Array<FilterCustomFieldsInnerInner>>;
    /**
     * 
     * @type {boolean}
     * @memberof Filter
     */
    'canceled'?: boolean;
}
/**
 * @type FilterCustomFieldsInnerInner
 * @export
 */
export type FilterCustomFieldsInnerInner = DateFilter | boolean | number | string;

/**
 * 
 * @export
 * @interface FilterDTO
 */
export interface FilterDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof FilterDTO
     */
    'season'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FilterDTO
     */
    'year'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FilterDTO
     */
    'division'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FilterDTO
     */
    'brand'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FilterDTO
     */
    'category'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FilterDTO
     */
    'custom_fields'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof FilterDTO
     */
    'canceled'?: boolean;
}
/**
 * 
 * @export
 * @interface FlexData
 */
export interface FlexData {
    /**
     * 
     * @type {number}
     * @memberof FlexData
     */
    'measurement': number;
    /**
     * 
     * @type {string}
     * @memberof FlexData
     */
    'notes': string;
    /**
     * 
     * @type {string}
     * @memberof FlexData
     */
    'point_of_measure': string;
}
/**
 * 
 * @export
 * @interface GenerateCsvDto
 */
export interface GenerateCsvDto {
    /**
     * 
     * @type {boolean}
     * @memberof GenerateCsvDto
     */
    'hideUnused': boolean;
}
/**
 * 
 * @export
 * @interface GetSharedFolderResponse
 */
export interface GetSharedFolderResponse {
    /**
     * 
     * @type {string}
     * @memberof GetSharedFolderResponse
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSharedFolderResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetSharedFolderResponse
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof GetSharedFolderResponse
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof GetSharedFolderResponse
     */
    'updated_at': string;
    /**
     * 
     * @type {Array<SharedTechpack>}
     * @memberof GetSharedFolderResponse
     */
    'techpacks': Array<SharedTechpack>;
    /**
     * 
     * @type {string}
     * @memberof GetSharedFolderResponse
     */
    'updated_by': string;
    /**
     * 
     * @type {string}
     * @memberof GetSharedFolderResponse
     */
    'created_by': string;
    /**
     * 
     * @type {Array<PopulatedContact>}
     * @memberof GetSharedFolderResponse
     */
    'contacts': Array<PopulatedContact>;
}
/**
 * 
 * @export
 * @interface HealthCheckDTO
 */
export interface HealthCheckDTO {
    /**
     * 
     * @type {number}
     * @memberof HealthCheckDTO
     */
    'uptime': number;
    /**
     * 
     * @type {string}
     * @memberof HealthCheckDTO
     */
    'message': string;
    /**
     * 
     * @type {number}
     * @memberof HealthCheckDTO
     */
    'timestamp': number;
}
/**
 * 
 * @export
 * @interface HomePageDto
 */
export interface HomePageDto {
    /**
     * 
     * @type {string}
     * @memberof HomePageDto
     */
    'homepage'?: string;
}
/**
 * 
 * @export
 * @interface Image
 */
export interface Image {
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'caption'?: string;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'url_hi'?: string;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'url_med'?: string;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'url_lo'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Image
     */
    'thumbnailing_failed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'annotations'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Image
     */
    'front_page': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Image
     */
    'is_archived': boolean;
    /**
     * 
     * @type {number}
     * @memberof Image
     */
    'sort': number;
    /**
     * 
     * @type {Array<ComponentMarker>}
     * @memberof Image
     */
    'component_markers': Array<ComponentMarker>;
    /**
     * 
     * @type {Array<CommentMarker>}
     * @memberof Image
     */
    'comment_markers': Array<CommentMarker>;
    /**
     * 
     * @type {Array<ConstructionDetailMarker>}
     * @memberof Image
     */
    'construction_detail_markers': Array<ConstructionDetailMarker>;
    /**
     * 
     * @type {Array<PointOfMeasureMarker>}
     * @memberof Image
     */
    'point_of_measure_markers': Array<PointOfMeasureMarker>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Image
     */
    'sections': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'createdBy': string;
    /**
     * 
     * @type {number}
     * @memberof Image
     */
    'position': number;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    '__copiedFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'source_file'?: string;
}
/**
 * 
 * @export
 * @interface ImportBoMItemsDTO
 */
export interface ImportBoMItemsDTO {
    /**
     * 
     * @type {object}
     * @memberof ImportBoMItemsDTO
     */
    'sourceId': object;
    /**
     * 
     * @type {string}
     * @memberof ImportBoMItemsDTO
     */
    'sourceModel': string;
    /**
     * 
     * @type {boolean}
     * @memberof ImportBoMItemsDTO
     */
    'replace': boolean;
    /**
     * 
     * @type {object}
     * @memberof ImportBoMItemsDTO
     */
    'featureFlagEnabled': object;
}
/**
 * 
 * @export
 * @interface ImportSizeSpecDTO
 */
export interface ImportSizeSpecDTO {
    /**
     * 
     * @type {string}
     * @memberof ImportSizeSpecDTO
     */
    'source': string;
    /**
     * 
     * @type {boolean}
     * @memberof ImportSizeSpecDTO
     */
    'replace': boolean;
    /**
     * 
     * @type {string}
     * @memberof ImportSizeSpecDTO
     */
    'resource': string;
}
/**
 * 
 * @export
 * @interface ItemMasterSortPreference
 */
export interface ItemMasterSortPreference {
    /**
     * 
     * @type {string}
     * @memberof ItemMasterSortPreference
     */
    'itemMaster': string;
    /**
     * 
     * @type {string}
     * @memberof ItemMasterSortPreference
     */
    'user': string;
    /**
     * 
     * @type {string}
     * @memberof ItemMasterSortPreference
     */
    'sortPref': string;
    /**
     * 
     * @type {string}
     * @memberof ItemMasterSortPreference
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ItemMasterSortPreference
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ItemViewDTO
 */
export interface ItemViewDTO {
    /**
     * 
     * @type {object}
     * @memberof ItemViewDTO
     */
    '_id': object;
    /**
     * 
     * @type {Array<string>}
     * @memberof ItemViewDTO
     */
    'sortedColumns': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ItemViewDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ItemViewDTO
     */
    'location': string;
    /**
     * 
     * @type {object}
     * @memberof ItemViewDTO
     */
    'image': object;
    /**
     * 
     * @type {boolean}
     * @memberof ItemViewDTO
     */
    'archived': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ItemViewDTO
     */
    'selected_items': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ItemViewDTO
     */
    'sharedWith': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ItemViewDTO
     */
    'report_mode': string;
    /**
     * 
     * @type {string}
     * @memberof ItemViewDTO
     */
    'variant_status': string;
    /**
     * 
     * @type {object}
     * @memberof ItemViewDTO
     */
    'createdBy': object;
    /**
     * 
     * @type {object}
     * @memberof ItemViewDTO
     */
    'updatedBy': object;
    /**
     * 
     * @type {object}
     * @memberof ItemViewDTO
     */
    'company': object;
    /**
     * 
     * @type {string}
     * @memberof ItemViewDTO
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ItemViewDTO
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ItemViewDTO
     */
    '__copiedFrom': string;
    /**
     * 
     * @type {ItemViewFilters}
     * @memberof ItemViewDTO
     */
    'filters': ItemViewFilters;
}
/**
 * 
 * @export
 * @interface ItemViewFilters
 */
export interface ItemViewFilters {
    /**
     * 
     * @type {Array<string>}
     * @memberof ItemViewFilters
     */
    'division'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ItemViewFilters
     */
    'season'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ItemViewFilters
     */
    'year'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ItemViewFilters
     */
    'brand'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ItemViewFilters
     */
    'custom_fields'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ItemViewFilters
     */
    'canceled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ItemViewFilters
     */
    'updatedAtStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemViewFilters
     */
    'updatedAtEnd'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ItemViewFilters
     */
    'category'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ItemViewFilters
     */
    'component_type'?: Array<string>;
}
/**
 * 
 * @export
 * @interface Job
 */
export interface Job {
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'queue': string;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'status': string;
    /**
     * 
     * @type {number}
     * @memberof Job
     */
    'progress': number;
    /**
     * 
     * @type {object}
     * @memberof Job
     */
    'metadata': object;
    /**
     * 
     * @type {object}
     * @memberof Job
     */
    'result': object;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface LineSheet
 */
export interface LineSheet {
    /**
     * 
     * @type {string}
     * @memberof LineSheet
     */
    'company': string;
    /**
     * 
     * @type {Filter}
     * @memberof LineSheet
     */
    'filters': Filter;
    /**
     * 
     * @type {Array<string>}
     * @memberof LineSheet
     */
    'sort_preference': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LineSheet
     */
    'report_mode': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LineSheet
     */
    'selected_items': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LineSheet
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof LineSheet
     */
    'image': string;
    /**
     * 
     * @type {string}
     * @memberof LineSheet
     */
    'created_by': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LineSheet
     */
    'visible_fields': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LineSheet
     */
    '__copiedFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof LineSheet
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof LineSheet
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface LineSheetsControllerGetLineSheets200Response
 */
export interface LineSheetsControllerGetLineSheets200Response {
    /**
     * 
     * @type {number}
     * @memberof LineSheetsControllerGetLineSheets200Response
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof LineSheetsControllerGetLineSheets200Response
     */
    'limit': number;
    /**
     * 
     * @type {number}
     * @memberof LineSheetsControllerGetLineSheets200Response
     */
    'skip': number;
    /**
     * 
     * @type {Array<LineSheet>}
     * @memberof LineSheetsControllerGetLineSheets200Response
     */
    'results'?: Array<LineSheet>;
}
/**
 * 
 * @export
 * @interface LineSheetsControllerGetLineSheets200ResponseAllOf
 */
export interface LineSheetsControllerGetLineSheets200ResponseAllOf {
    /**
     * 
     * @type {Array<LineSheet>}
     * @memberof LineSheetsControllerGetLineSheets200ResponseAllOf
     */
    'results'?: Array<LineSheet>;
}
/**
 * 
 * @export
 * @interface LoginDTO
 */
export interface LoginDTO {
    /**
     * email if authenticating with email/password
     * @type {string}
     * @memberof LoginDTO
     */
    'email': string;
    /**
     * password if authenticating with email/password
     * @type {string}
     * @memberof LoginDTO
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface Measurement
 */
export interface Measurement {
    /**
     * 
     * @type {string}
     * @memberof Measurement
     */
    'pom_cell': string;
    /**
     * 
     * @type {number}
     * @memberof Measurement
     */
    'received': number;
    /**
     * 
     * @type {number}
     * @memberof Measurement
     */
    'expected_measurement': number;
    /**
     * 
     * @type {number}
     * @memberof Measurement
     */
    'update_by': number;
    /**
     * 
     * @type {string}
     * @memberof Measurement
     */
    'user': string;
    /**
     * 
     * @type {string}
     * @memberof Measurement
     */
    'measurement_status': string;
    /**
     * 
     * @type {string}
     * @memberof Measurement
     */
    'notes': string;
}
/**
 * 
 * @export
 * @interface MeasurementSet
 */
export interface MeasurementSet {
    /**
     * 
     * @type {string}
     * @memberof MeasurementSet
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof MeasurementSet
     */
    'measurement_set': string;
    /**
     * 
     * @type {Array<Measurement>}
     * @memberof MeasurementSet
     */
    'measurements': Array<Measurement>;
}
/**
 * 
 * @export
 * @interface NotUsedComponentColor
 */
export interface NotUsedComponentColor {
    /**
     * 
     * @type {boolean}
     * @memberof NotUsedComponentColor
     */
    'not_used': boolean;
}
/**
 * 
 * @export
 * @interface PaginatedDto
 */
export interface PaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof PaginatedDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedDto
     */
    'limit': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedDto
     */
    'skip': number;
}
/**
 * 
 * @export
 * @interface Palette
 */
export interface Palette {
    /**
     * 
     * @type {string}
     * @memberof Palette
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof Palette
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Palette
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof Palette
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof Palette
     */
    'updated_by': string;
}
/**
 * 
 * @export
 * @interface PatchBomItemDTO
 */
export interface PatchBomItemDTO {
    /**
     * 
     * @type {string}
     * @memberof PatchBomItemDTO
     */
    'notes'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchBomItemDTO
     */
    'placement'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchBomItemDTO
     */
    'quantity'?: number;
    /**
     * 
     * @type {ComponentColorSelection}
     * @memberof PatchBomItemDTO
     */
    'component_color'?: ComponentColorSelection;
    /**
     * 
     * @type {ComponentVariantSelection}
     * @memberof PatchBomItemDTO
     */
    'custom_variant'?: ComponentVariantSelection;
    /**
     * 
     * @type {Array<ComponentVariant>}
     * @memberof PatchBomItemDTO
     */
    'component_variants'?: Array<ComponentVariant>;
    /**
     * 
     * @type {boolean}
     * @memberof PatchBomItemDTO
     */
    'hidden'?: boolean;
}
/**
 * 
 * @export
 * @interface PatchFolderDTO
 */
export interface PatchFolderDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchFolderDTO
     */
    'techpacks'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchFolderDTO
     */
    'contacts'?: Array<string>;
    /**
     * specifies whether to send a notification email to existing folder collaborators
     * @type {boolean}
     * @memberof PatchFolderDTO
     */
    'email'?: boolean;
    /**
     * specifies email subject of notification email
     * @type {string}
     * @memberof PatchFolderDTO
     */
    'emailSubject'?: string;
    /**
     * specifies email body of notification email
     * @type {string}
     * @memberof PatchFolderDTO
     */
    'emailBody'?: string;
}
/**
 * 
 * @export
 * @interface PatchImageDto
 */
export interface PatchImageDto {
    /**
     * 
     * @type {string}
     * @memberof PatchImageDto
     */
    'caption'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchImageDto
     */
    'front_page'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PatchImageDto
     */
    'position'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PatchImageDto
     */
    'is_archived'?: boolean;
}
/**
 * 
 * @export
 * @interface PatchSourceFileVersionDTO
 */
export interface PatchSourceFileVersionDTO {
    /**
     * 
     * @type {string}
     * @memberof PatchSourceFileVersionDTO
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PatchTemplateDto
 */
export interface PatchTemplateDto {
    /**
     * 
     * @type {string}
     * @memberof PatchTemplateDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchTemplateDto
     */
    'type'?: string;
}
/**
 * 
 * @export
 * @interface PatchUserDto
 */
export interface PatchUserDto {
    /**
     * 
     * @type {string}
     * @memberof PatchUserDto
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchUserDto
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchUserDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof PatchUserDto
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchUserDto
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchUserDto
     */
    'locale'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchUserDto
     */
    'objects_sort_pref'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchUserDto
     */
    'components_sort_pref'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchUserDto
     */
    'details_sort_pref'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchUserDto
     */
    'pom_sort_pref'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchUserDto
     */
    'preset_sort_pref'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchUserDto
     */
    'file_sort_pref'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchUserDto
     */
    'item_master_sort_pref'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchUserDto
     */
    'component_master_sort_pref'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchUserDto
     */
    'bom_template_sort_pref'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchUserDto
     */
    'palette_library_sort_pref'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchUserDto
     */
    'color_book_library_sort_pref'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchUserDto
     */
    'size_spec_uom_pref'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchUserDto
     */
    'utilization_report_library_sort_pref'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchUserDto
     */
    'feature_tutorials'?: Array<string>;
    /**
     * 
     * @type {object}
     * @memberof PatchUserDto
     */
    'view_preference'?: object;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchUserDto
     */
    'hidden_pom_fields'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchUserDto
     */
    'hidden_sample_fields'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PatchUserDto
     */
    'size_spec_view'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchUserDto
     */
    'homepage'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchUserDto
     */
    'role'?: PatchUserDtoRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof PatchUserDto
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchUserDto
     */
    'avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchUserDto
     */
    'password'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchUserDto
     */
    'show_dense_item_view'?: boolean;
}

export const PatchUserDtoRoleEnum = {
    Admin: 'Admin',
    Manager: 'Manager',
    Contributor: 'Contributor',
    ReadOnly: 'Read Only'
} as const;

export type PatchUserDtoRoleEnum = typeof PatchUserDtoRoleEnum[keyof typeof PatchUserDtoRoleEnum];

/**
 * 
 * @export
 * @interface PointOfMeasureMarker
 */
export interface PointOfMeasureMarker {
    /**
     * 
     * @type {string}
     * @memberof PointOfMeasureMarker
     */
    'marker_id': string;
    /**
     * 
     * @type {string}
     * @memberof PointOfMeasureMarker
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof PointOfMeasureMarker
     */
    'marker_color': string;
    /**
     * 
     * @type {string}
     * @memberof PointOfMeasureMarker
     */
    'point_of_measure': string;
    /**
     * 
     * @type {string}
     * @memberof PointOfMeasureMarker
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof PointOfMeasureMarker
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface PomDuplicateDTO
 */
export interface PomDuplicateDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof PomDuplicateDTO
     */
    'ids': Array<string>;
}
/**
 * 
 * @export
 * @interface PopulatedContact
 */
export interface PopulatedContact {
    /**
     * 
     * @type {string}
     * @memberof PopulatedContact
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof PopulatedContact
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof PopulatedContact
     */
    'updated_at': string;
    /**
     * 
     * @type {Contact}
     * @memberof PopulatedContact
     */
    'contact': Contact;
}
/**
 * 
 * @export
 * @interface PopulatedProductTechpack
 */
export interface PopulatedProductTechpack {
    /**
     * 
     * @type {string}
     * @memberof PopulatedProductTechpack
     */
    '_id': string;
    /**
     * 
     * @type {Array<ProductTechpackAttachment>}
     * @memberof PopulatedProductTechpack
     */
    'attachments': Array<ProductTechpackAttachment>;
    /**
     * 
     * @type {ProductNameCode}
     * @memberof PopulatedProductTechpack
     */
    'product': ProductNameCode;
    /**
     * 
     * @type {Array<string>}
     * @memberof PopulatedProductTechpack
     */
    'folders'?: Array<string>;
    /**
     * 
     * @type {ProductTechpackShare}
     * @memberof PopulatedProductTechpack
     */
    'share'?: ProductTechpackShare;
}
/**
 * 
 * @export
 * @interface PopulatedSharedTechpack
 */
export interface PopulatedSharedTechpack {
    /**
     * 
     * @type {string}
     * @memberof PopulatedSharedTechpack
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof PopulatedSharedTechpack
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof PopulatedSharedTechpack
     */
    'updated_at': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PopulatedSharedTechpack
     */
    'folders': Array<string>;
    /**
     * 
     * @type {PopulatedProductTechpack}
     * @memberof PopulatedSharedTechpack
     */
    'techpack': PopulatedProductTechpack;
}
/**
 * 
 * @export
 * @interface PopulatedVariant
 */
export interface PopulatedVariant {
    /**
     * 
     * @type {string}
     * @memberof PopulatedVariant
     */
    '_id': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PopulatedVariant
     */
    'images': Array<string>;
    /**
     * 
     * @type {Array<CustomFieldValue>}
     * @memberof PopulatedVariant
     */
    'custom_fields': Array<CustomFieldValue>;
    /**
     * 
     * @type {string}
     * @memberof PopulatedVariant
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof PopulatedVariant
     */
    'updated_by': string;
    /**
     * 
     * @type {string}
     * @memberof PopulatedVariant
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof PopulatedVariant
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof PopulatedVariant
     */
    'deactivatedAt': string;
    /**
     * 
     * @type {SwatchWithImage}
     * @memberof PopulatedVariant
     */
    'color': SwatchWithImage;
}
/**
 * 
 * @export
 * @interface Product
 */
export interface Product {
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'brand': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'year': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'division': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'season': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'code': string;
    /**
     * 
     * @type {Array<Variant>}
     * @memberof Product
     */
    'variants': Array<Variant>;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'category': string;
    /**
     * 
     * @type {Array<TechpackImage>}
     * @memberof Product
     */
    'techpack_images': Array<TechpackImage>;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'price_unit': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Product
     */
    'files': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'canceled': boolean;
    /**
     * 
     * @type {Array<CustomFieldValue>}
     * @memberof Product
     */
    'custom_fields': Array<CustomFieldValue>;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    '__copiedFrom'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Product
     */
    'bom_items'?: Array<string>;
    /**
     * 
     * @type {Array<BomDivider>}
     * @memberof Product
     */
    'bom_dividers'?: Array<BomDivider>;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'hide_bom_pricing': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'hide_bom_quantity': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'hide_bom_notes': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'hide_bom_placement': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'hide_bom_component_variant_1': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'hide_bom_component_variant_2': boolean;
    /**
     * 
     * @type {Sample}
     * @memberof Product
     */
    'samples': Sample;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'size_spec': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ProductBomResponse
 */
export interface ProductBomResponse {
    /**
     * 
     * @type {string}
     * @memberof ProductBomResponse
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof ProductBomResponse
     */
    'brand': string;
    /**
     * 
     * @type {string}
     * @memberof ProductBomResponse
     */
    'year': string;
    /**
     * 
     * @type {string}
     * @memberof ProductBomResponse
     */
    'division': string;
    /**
     * 
     * @type {string}
     * @memberof ProductBomResponse
     */
    'season': string;
    /**
     * 
     * @type {string}
     * @memberof ProductBomResponse
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof ProductBomResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ProductBomResponse
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof ProductBomResponse
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ProductBomResponse
     */
    'category': string;
    /**
     * 
     * @type {Array<TechpackImage>}
     * @memberof ProductBomResponse
     */
    'techpack_images': Array<TechpackImage>;
    /**
     * 
     * @type {number}
     * @memberof ProductBomResponse
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof ProductBomResponse
     */
    'price_unit': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductBomResponse
     */
    'files': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ProductBomResponse
     */
    'canceled': boolean;
    /**
     * 
     * @type {Array<CustomFieldValue>}
     * @memberof ProductBomResponse
     */
    'custom_fields': Array<CustomFieldValue>;
    /**
     * 
     * @type {string}
     * @memberof ProductBomResponse
     */
    '__copiedFrom'?: string;
    /**
     * 
     * @type {Array<BomDivider>}
     * @memberof ProductBomResponse
     */
    'bom_dividers'?: Array<BomDivider>;
    /**
     * 
     * @type {boolean}
     * @memberof ProductBomResponse
     */
    'hide_bom_pricing': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductBomResponse
     */
    'hide_bom_quantity': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductBomResponse
     */
    'hide_bom_notes': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductBomResponse
     */
    'hide_bom_placement': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductBomResponse
     */
    'hide_bom_component_variant_1': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductBomResponse
     */
    'hide_bom_component_variant_2': boolean;
    /**
     * 
     * @type {Sample}
     * @memberof ProductBomResponse
     */
    'samples': Sample;
    /**
     * 
     * @type {string}
     * @memberof ProductBomResponse
     */
    'size_spec': string;
    /**
     * 
     * @type {string}
     * @memberof ProductBomResponse
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ProductBomResponse
     */
    'updatedAt': string;
    /**
     * 
     * @type {Array<PopulatedVariant>}
     * @memberof ProductBomResponse
     */
    'variants': Array<PopulatedVariant>;
    /**
     * 
     * @type {Array<BomItemWithComponentVariantTypes>}
     * @memberof ProductBomResponse
     */
    'bom_items': Array<BomItemWithComponentVariantTypes>;
}
/**
 * 
 * @export
 * @interface ProductFileDTO
 */
export interface ProductFileDTO {
    /**
     * 
     * @type {string}
     * @memberof ProductFileDTO
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof ProductFileDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ProductFileDTO
     */
    'caption': string;
}
/**
 * 
 * @export
 * @interface ProductNameCode
 */
export interface ProductNameCode {
    /**
     * 
     * @type {string}
     * @memberof ProductNameCode
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ProductNameCode
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface ProductSourceFileDTO
 */
export interface ProductSourceFileDTO {
    /**
     * 
     * @type {string}
     * @memberof ProductSourceFileDTO
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof ProductSourceFileDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ProductSourceFileDTO
     */
    'caption': string;
    /**
     * 
     * @type {Array<TechpackImageDTO>}
     * @memberof ProductSourceFileDTO
     */
    'images'?: Array<TechpackImageDTO>;
}
/**
 * 
 * @export
 * @interface ProductTaxonomySet
 */
export interface ProductTaxonomySet {
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductTaxonomySet
     */
    'seasons': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductTaxonomySet
     */
    'divisions': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductTaxonomySet
     */
    'categories': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductTaxonomySet
     */
    'years': Array<string>;
}
/**
 * 
 * @export
 * @interface ProductTechpack
 */
export interface ProductTechpack {
    /**
     * 
     * @type {string}
     * @memberof ProductTechpack
     */
    'product': string;
    /**
     * 
     * @type {string}
     * @memberof ProductTechpack
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof ProductTechpack
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof ProductTechpack
     */
    'job': string;
    /**
     * 
     * @type {string}
     * @memberof ProductTechpack
     */
    'link': string;
    /**
     * 
     * @type {string}
     * @memberof ProductTechpack
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof ProductTechpack
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface ProductTechpackAttachment
 */
export interface ProductTechpackAttachment {
    /**
     * 
     * @type {string}
     * @memberof ProductTechpackAttachment
     */
    'kind': string;
    /**
     * 
     * @type {string}
     * @memberof ProductTechpackAttachment
     */
    'techpack': string;
    /**
     * 
     * @type {string}
     * @memberof ProductTechpackAttachment
     */
    'link': string;
    /**
     * 
     * @type {string}
     * @memberof ProductTechpackAttachment
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ProductTechpackAttachment
     */
    'company': string;
}
/**
 * 
 * @export
 * @interface ProductTechpackShare
 */
export interface ProductTechpackShare {
    /**
     * 
     * @type {string}
     * @memberof ProductTechpackShare
     */
    'productTechpack': string;
    /**
     * 
     * @type {string}
     * @memberof ProductTechpackShare
     */
    'createdBy': string;
    /**
     * 
     * @type {string}
     * @memberof ProductTechpackShare
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof ProductTechpackShare
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof ProductTechpackShare
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ProductTechpackShare
     */
    'share_id': string;
}
/**
 * 
 * @export
 * @interface ProductsControllerQueryProducts200Response
 */
export interface ProductsControllerQueryProducts200Response {
    /**
     * 
     * @type {number}
     * @memberof ProductsControllerQueryProducts200Response
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof ProductsControllerQueryProducts200Response
     */
    'limit': number;
    /**
     * 
     * @type {number}
     * @memberof ProductsControllerQueryProducts200Response
     */
    'skip': number;
    /**
     * 
     * @type {Array<Product>}
     * @memberof ProductsControllerQueryProducts200Response
     */
    'results'?: Array<Product>;
}
/**
 * 
 * @export
 * @interface ProductsControllerQueryProducts200ResponseAllOf
 */
export interface ProductsControllerQueryProducts200ResponseAllOf {
    /**
     * 
     * @type {Array<Product>}
     * @memberof ProductsControllerQueryProducts200ResponseAllOf
     */
    'results'?: Array<Product>;
}
/**
 * 
 * @export
 * @interface QueryFoldersResponse
 */
export interface QueryFoldersResponse {
    /**
     * 
     * @type {string}
     * @memberof QueryFoldersResponse
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof QueryFoldersResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof QueryFoldersResponse
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof QueryFoldersResponse
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof QueryFoldersResponse
     */
    'updated_at': string;
    /**
     * 
     * @type {Array<SharedContact>}
     * @memberof QueryFoldersResponse
     */
    'contacts': Array<SharedContact>;
    /**
     * 
     * @type {Array<SharedTechpack>}
     * @memberof QueryFoldersResponse
     */
    'techpacks': Array<SharedTechpack>;
    /**
     * 
     * @type {string}
     * @memberof QueryFoldersResponse
     */
    'updated_by': string;
    /**
     * 
     * @type {User}
     * @memberof QueryFoldersResponse
     */
    'created_by': User;
}
/**
 * 
 * @export
 * @interface RemoveColorwaysFromComponentDTO
 */
export interface RemoveColorwaysFromComponentDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof RemoveColorwaysFromComponentDTO
     */
    'colorways': Array<string>;
}
/**
 * 
 * @export
 * @interface ResetPasswordEmailDto
 */
export interface ResetPasswordEmailDto {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordEmailDto
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface Revision
 */
export interface Revision {
    /**
     * 
     * @type {string}
     * @memberof Revision
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof Revision
     */
    '__copiedFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof Revision
     */
    'product'?: string;
    /**
     * 
     * @type {string}
     * @memberof Revision
     */
    'component'?: string;
    /**
     * 
     * @type {string}
     * @memberof Revision
     */
    'sample'?: string;
    /**
     * 
     * @type {string}
     * @memberof Revision
     */
    'dev_stage'?: string;
    /**
     * 
     * @type {string}
     * @memberof Revision
     */
    'created_by': string;
    /**
     * 
     * @type {Array<RevisionImage>}
     * @memberof Revision
     */
    'revision_images'?: Array<RevisionImage>;
    /**
     * 
     * @type {string}
     * @memberof Revision
     */
    'notes': string;
    /**
     * 
     * @type {string}
     * @memberof Revision
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Revision
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Revision
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface RevisionImage
 */
export interface RevisionImage {
    /**
     * 
     * @type {string}
     * @memberof RevisionImage
     */
    'image': string;
}
/**
 * 
 * @export
 * @interface Sample
 */
export interface Sample {
    /**
     * 
     * @type {string}
     * @memberof Sample
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof Sample
     */
    'product': string;
    /**
     * 
     * @type {string}
     * @memberof Sample
     */
    'sample_size': string;
    /**
     * 
     * @type {boolean}
     * @memberof Sample
     */
    'completed': boolean;
    /**
     * 
     * @type {string}
     * @memberof Sample
     */
    'status': string;
    /**
     * 
     * @type {boolean}
     * @memberof Sample
     */
    'is_flex': boolean;
    /**
     * 
     * @type {string}
     * @memberof Sample
     */
    'flex_type': string;
    /**
     * 
     * @type {boolean}
     * @memberof Sample
     */
    'hide': boolean;
    /**
     * 
     * @type {string}
     * @memberof Sample
     */
    'name': string;
    /**
     * 
     * @type {Array<MeasurementSet>}
     * @memberof Sample
     */
    'received_measurements': Array<MeasurementSet>;
    /**
     * 
     * @type {Array<FlexData>}
     * @memberof Sample
     */
    'flex_data': Array<FlexData>;
    /**
     * 
     * @type {string}
     * @memberof Sample
     */
    'current_measurement_set': string;
    /**
     * 
     * @type {string}
     * @memberof Sample
     */
    'fit_status': string;
    /**
     * 
     * @type {string}
     * @memberof Sample
     */
    'image': string;
    /**
     * 
     * @type {string}
     * @memberof Sample
     */
    'factory': string;
    /**
     * 
     * @type {string}
     * @memberof Sample
     */
    'dev_stage': string;
    /**
     * 
     * @type {string}
     * @memberof Sample
     */
    'arrival_date': string;
    /**
     * 
     * @type {string}
     * @memberof Sample
     */
    'review_date': string;
    /**
     * 
     * @type {string}
     * @memberof Sample
     */
    '__copiedFrom': string;
    /**
     * 
     * @type {string}
     * @memberof Sample
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Sample
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface Season
 */
export interface Season {
    /**
     * 
     * @type {string}
     * @memberof Season
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Season
     */
    'company': string;
    /**
     * 
     * @type {number}
     * @memberof Season
     */
    'order': number;
    /**
     * 
     * @type {string}
     * @memberof Season
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Season
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface SelectedComponentColor
 */
export interface SelectedComponentColor {
    /**
     * 
     * @type {string}
     * @memberof SelectedComponentColor
     */
    'custom_color': string;
}
/**
 * 
 * @export
 * @interface SharedContact
 */
export interface SharedContact {
    /**
     * 
     * @type {string}
     * @memberof SharedContact
     */
    'contact': string;
    /**
     * 
     * @type {string}
     * @memberof SharedContact
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof SharedContact
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof SharedContact
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface SharedFolder
 */
export interface SharedFolder {
    /**
     * 
     * @type {string}
     * @memberof SharedFolder
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof SharedFolder
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SharedFolder
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof SharedFolder
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof SharedFolder
     */
    'updated_at': string;
    /**
     * 
     * @type {Array<SharedContact>}
     * @memberof SharedFolder
     */
    'contacts': Array<SharedContact>;
    /**
     * 
     * @type {Array<SharedTechpack>}
     * @memberof SharedFolder
     */
    'techpacks': Array<SharedTechpack>;
    /**
     * 
     * @type {string}
     * @memberof SharedFolder
     */
    'updated_by': string;
    /**
     * 
     * @type {string}
     * @memberof SharedFolder
     */
    'created_by': string;
}
/**
 * 
 * @export
 * @interface SharedFolderDTO
 */
export interface SharedFolderDTO {
    /**
     * 
     * @type {string}
     * @memberof SharedFolderDTO
     */
    'name': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SharedFolderDTO
     */
    'contacts'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SharedFolderDTO
     */
    'techpacks': Array<string>;
    /**
     * specifies whether to send a notification email to the newly added folder collaborators
     * @type {boolean}
     * @memberof SharedFolderDTO
     */
    'email'?: boolean;
    /**
     * specifies email subject of notification email
     * @type {string}
     * @memberof SharedFolderDTO
     */
    'emailSubject'?: string;
    /**
     * specifies email body of notification email
     * @type {string}
     * @memberof SharedFolderDTO
     */
    'emailBody'?: string;
}
/**
 * 
 * @export
 * @interface SharedTechpack
 */
export interface SharedTechpack {
    /**
     * 
     * @type {string}
     * @memberof SharedTechpack
     */
    'techpack': string;
    /**
     * 
     * @type {string}
     * @memberof SharedTechpack
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof SharedTechpack
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof SharedTechpack
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface SignedUrlDto
 */
export interface SignedUrlDto {
    /**
     * 
     * @type {string}
     * @memberof SignedUrlDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SignedUrlDto
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface SizeSpec
 */
export interface SizeSpec {
    /**
     * 
     * @type {string}
     * @memberof SizeSpec
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof SizeSpec
     */
    '__copiedFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof SizeSpec
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SizeSpec
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof SizeSpec
     */
    'unit_of_measure': string;
    /**
     * 
     * @type {string}
     * @memberof SizeSpec
     */
    'current_unit_of_measure': string;
    /**
     * 
     * @type {string}
     * @memberof SizeSpec
     */
    'format': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SizeSpec
     */
    'sizes': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SizeSpec
     */
    'points_of_measure': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SizeSpec
     */
    'pom_cells': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SizeSpec
     */
    'sample_size': string;
    /**
     * 
     * @type {string}
     * @memberof SizeSpec
     */
    'product': string;
    /**
     * 
     * @type {boolean}
     * @memberof SizeSpec
     */
    'show_critical_poms': boolean;
}
/**
 * 
 * @export
 * @interface SizeSpecBlock
 */
export interface SizeSpecBlock {
    /**
     * 
     * @type {string}
     * @memberof SizeSpecBlock
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SizeSpecBlock
     */
    '__copiedFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof SizeSpecBlock
     */
    'unit_of_measure': string;
    /**
     * 
     * @type {string}
     * @memberof SizeSpecBlock
     */
    'current_unit_of_measure': string;
    /**
     * 
     * @type {string}
     * @memberof SizeSpecBlock
     */
    'format': string;
    /**
     * 
     * @type {string}
     * @memberof SizeSpecBlock
     */
    'code': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SizeSpecBlock
     */
    'images': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SizeSpecBlock
     */
    'sample_size': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SizeSpecBlock
     */
    'sizes': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SizeSpecBlock
     */
    'points_of_measure': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SizeSpecBlock
     */
    'pom_cells': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SizeSpecBlock
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof SizeSpecBlock
     */
    'created_by': string;
}
/**
 * 
 * @export
 * @interface SortDTO
 */
export interface SortDTO {
    /**
     * 
     * @type {string}
     * @memberof SortDTO
     */
    'field': string;
    /**
     * 
     * @type {number}
     * @memberof SortDTO
     */
    'direction': number;
}
/**
 * 
 * @export
 * @interface SourceFile
 */
export interface SourceFile {
    /**
     * 
     * @type {string}
     * @memberof SourceFile
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SourceFile
     */
    'caption'?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceFile
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof SourceFile
     */
    'product'?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceFile
     */
    'component'?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceFile
     */
    'revision'?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceFile
     */
    'createdBy': string;
    /**
     * 
     * @type {string}
     * @memberof SourceFile
     */
    'updatedBy': string;
    /**
     * 
     * @type {string}
     * @memberof SourceFile
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof SourceFile
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof SourceFile
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {Array<VersionData>}
     * @memberof SourceFile
     */
    'versions': Array<VersionData>;
    /**
     * 
     * @type {number}
     * @memberof SourceFile
     */
    'parser_version': number;
}
/**
 * 
 * @export
 * @interface Subsection
 */
export interface Subsection {
    /**
     * 
     * @type {string}
     * @memberof Subsection
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Subsection
     */
    'display_name': string;
    /**
     * 
     * @type {string}
     * @memberof Subsection
     */
    'section_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Subsection
     */
    'tag'?: string;
}
/**
 * 
 * @export
 * @interface Swatch
 */
export interface Swatch {
    /**
     * 
     * @type {string}
     * @memberof Swatch
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Swatch
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof Swatch
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof Swatch
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Swatch
     */
    'updated_by': string;
    /**
     * 
     * @type {string}
     * @memberof Swatch
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof Swatch
     */
    'hex'?: string;
    /**
     * 
     * @type {string}
     * @memberof Swatch
     */
    '__copiedFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof Swatch
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof Swatch
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof Swatch
     */
    'external_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof Swatch
     */
    'internal_code'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Swatch
     */
    'palettes'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Swatch
     */
    'colorbook_card'?: string;
}
/**
 * 
 * @export
 * @interface SwatchCreateDto
 */
export interface SwatchCreateDto {
    /**
     * 
     * @type {string}
     * @memberof SwatchCreateDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SwatchCreateDto
     */
    'image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof SwatchCreateDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof SwatchCreateDto
     */
    'internal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof SwatchCreateDto
     */
    'hex'?: string;
    /**
     * 
     * @type {string}
     * @memberof SwatchCreateDto
     */
    'external_code'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SwatchCreateDto
     */
    'palettes'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SwatchCreateDto
     */
    'colorbook_card'?: string;
}
/**
 * 
 * @export
 * @interface SwatchUpdateDto
 */
export interface SwatchUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof SwatchUpdateDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SwatchUpdateDto
     */
    'image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof SwatchUpdateDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof SwatchUpdateDto
     */
    'internal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof SwatchUpdateDto
     */
    'hex'?: string;
    /**
     * 
     * @type {string}
     * @memberof SwatchUpdateDto
     */
    'external_code'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SwatchUpdateDto
     */
    'palettes'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SwatchUpdateDto
     */
    'colorbook_card'?: string;
}
/**
 * 
 * @export
 * @interface SwatchWithImage
 */
export interface SwatchWithImage {
    /**
     * 
     * @type {string}
     * @memberof SwatchWithImage
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SwatchWithImage
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof SwatchWithImage
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof SwatchWithImage
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof SwatchWithImage
     */
    'updated_by': string;
    /**
     * 
     * @type {string}
     * @memberof SwatchWithImage
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof SwatchWithImage
     */
    'hex'?: string;
    /**
     * 
     * @type {string}
     * @memberof SwatchWithImage
     */
    '__copiedFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof SwatchWithImage
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof SwatchWithImage
     */
    'external_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof SwatchWithImage
     */
    'internal_code'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SwatchWithImage
     */
    'palettes'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SwatchWithImage
     */
    'colorbook_card'?: string;
    /**
     * 
     * @type {Image}
     * @memberof SwatchWithImage
     */
    'image': Image;
}
/**
 * 
 * @export
 * @interface TechpackImage
 */
export interface TechpackImage {
    /**
     * 
     * @type {string}
     * @memberof TechpackImage
     */
    'image': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TechpackImage
     */
    'sections': Array<string>;
}
/**
 * 
 * @export
 * @interface TechpackImageDTO
 */
export interface TechpackImageDTO {
    /**
     * 
     * @type {string}
     * @memberof TechpackImageDTO
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof TechpackImageDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TechpackImageDTO
     */
    'caption': string;
    /**
     * 
     * @type {boolean}
     * @memberof TechpackImageDTO
     */
    'front_page': boolean;
    /**
     * 
     * @type {number}
     * @memberof TechpackImageDTO
     */
    'position': number;
}
/**
 * 
 * @export
 * @interface TechpackSection
 */
export interface TechpackSection {
    /**
     * 
     * @type {string}
     * @memberof TechpackSection
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TechpackSection
     */
    'display_name': string;
    /**
     * 
     * @type {Array<Subsection>}
     * @memberof TechpackSection
     */
    'subsections'?: Array<Subsection>;
}
/**
 * 
 * @export
 * @interface UndefinedComponentColor
 */
export interface UndefinedComponentColor {
    /**
     * 
     * @type {Nullable}
     * @memberof UndefinedComponentColor
     */
    'custom_color': Nullable;
}
/**
 * 
 * @export
 * @interface UpdateAnnotationDataDTO
 */
export interface UpdateAnnotationDataDTO {
    /**
     * 
     * @type {object}
     * @memberof UpdateAnnotationDataDTO
     */
    'annotation_data': object;
}
/**
 * 
 * @export
 * @interface UpdateContactDTO
 */
export interface UpdateContactDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateContactDTO
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface UpdateLineSheetDTO
 */
export interface UpdateLineSheetDTO {
    /**
     * 
     * @type {FilterDTO}
     * @memberof UpdateLineSheetDTO
     */
    'filters': FilterDTO;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateLineSheetDTO
     */
    'selected_items': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateLineSheetDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLineSheetDTO
     */
    'image': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateLineSheetDTO
     */
    'visible_fields': Array<string>;
    /**
     * 
     * @type {Array<SortDTO>}
     * @memberof UpdateLineSheetDTO
     */
    'sort_preference': Array<SortDTO>;
    /**
     * 
     * @type {string}
     * @memberof UpdateLineSheetDTO
     */
    'report_mode': string;
}
/**
 * 
 * @export
 * @interface UpdatePasswordDto
 */
export interface UpdatePasswordDto {
    /**
     * 
     * @type {string}
     * @memberof UpdatePasswordDto
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface UpdateSharedFolderDTO
 */
export interface UpdateSharedFolderDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateSharedFolderDTO
     */
    'name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateSharedFolderDTO
     */
    'contacts'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateSharedFolderDTO
     */
    'techpacks'?: Array<string>;
    /**
     * specifies whether to send a notification email to the newly added folder collaborators
     * @type {boolean}
     * @memberof UpdateSharedFolderDTO
     */
    'email'?: boolean;
    /**
     * specifies email subject of notification email
     * @type {string}
     * @memberof UpdateSharedFolderDTO
     */
    'emailSubject'?: string;
    /**
     * specifies email body of notification email
     * @type {string}
     * @memberof UpdateSharedFolderDTO
     */
    'emailBody'?: string;
}
/**
 * 
 * @export
 * @interface UpdateSourceFileDto
 */
export interface UpdateSourceFileDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateSourceFileDto
     */
    'url': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateSourceFileDto
     */
    'artboards': Array<string>;
    /**
     * 
     * @type {object}
     * @memberof UpdateSourceFileDto
     */
    'revision'?: object;
}
/**
 * 
 * @export
 * @interface UpdateSourceFilesImagesDTO
 */
export interface UpdateSourceFilesImagesDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateSourceFilesImagesDTO
     */
    'url': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateSourceFilesImagesDTO
     */
    'artboards': Array<string>;
    /**
     * 
     * @type {object}
     * @memberof UpdateSourceFilesImagesDTO
     */
    'revision'?: object;
}
/**
 * 
 * @export
 * @interface UpdateVariantMatrixPropertiesDTO
 */
export interface UpdateVariantMatrixPropertiesDTO {
    /**
     * 
     * @type {Array<object>}
     * @memberof UpdateVariantMatrixPropertiesDTO
     */
    'updatedRows'?: Array<object>;
    /**
     * 
     * @type {string}
     * @memberof UpdateVariantMatrixPropertiesDTO
     */
    'code'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateVariantMatrixPropertiesDTO
     */
    'price'?: number;
    /**
     * 
     * @type {object}
     * @memberof UpdateVariantMatrixPropertiesDTO
     */
    'status'?: object;
    /**
     * 
     * @type {Array<object>}
     * @memberof UpdateVariantMatrixPropertiesDTO
     */
    'images'?: Array<object>;
}
/**
 * 
 * @export
 * @interface UpdateVariantTypeDto
 */
export interface UpdateVariantTypeDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateVariantTypeDto
     */
    'name': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateVariantTypeDto
     */
    'options': Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateVariantValueDTO
 */
export interface UpdateVariantValueDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateVariantValueDTO
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'avatar': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'locale': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'status': string;
    /**
     * 
     * @type {object}
     * @memberof User
     */
    'company': object;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    'verification_code': number;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    'setup_code': number;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'objects_sort_pref': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'components_sort_pref': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'details_sort_pref': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'pom_sort_pref': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'preset_sort_pref': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'file_sort_pref': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'item_master_sort_pref': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'component_master_sort_pref': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'bom_template_sort_pref': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'utilization_report_library_sort_pref': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'palette_library_sort_pref': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'color_book_library_sort_pref': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'size_spec_uom_pref': string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'phone_verified': boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'role': string;
    /**
     * 
     * @type {object}
     * @memberof User
     */
    'created_by': object;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'last_active': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof User
     */
    'feature_tutorials': Array<string>;
    /**
     * 
     * @type {object}
     * @memberof User
     */
    'view_preference': object;
    /**
     * 
     * @type {Array<string>}
     * @memberof User
     */
    'hidden_pom_fields': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof User
     */
    'hidden_sample_fields': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'size_spec_view': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'api_key': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'password_reset_token': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'token_expires': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'homepage': string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'show_dense_item_view': boolean;
}
/**
 * 
 * @export
 * @interface Variant
 */
export interface Variant {
    /**
     * 
     * @type {string}
     * @memberof Variant
     */
    '_id': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Variant
     */
    'images': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Variant
     */
    'color': string;
    /**
     * 
     * @type {Array<CustomFieldValue>}
     * @memberof Variant
     */
    'custom_fields': Array<CustomFieldValue>;
    /**
     * 
     * @type {string}
     * @memberof Variant
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof Variant
     */
    'updated_by': string;
    /**
     * 
     * @type {string}
     * @memberof Variant
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Variant
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof Variant
     */
    'deactivatedAt': string;
}
/**
 * 
 * @export
 * @interface VariantFields
 */
export interface VariantFields {
    /**
     * 
     * @type {string}
     * @memberof VariantFields
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof VariantFields
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface VariantMatrix
 */
export interface VariantMatrix {
    /**
     * 
     * @type {string}
     * @memberof VariantMatrix
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof VariantMatrix
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof VariantMatrix
     */
    'component': string;
    /**
     * 
     * @type {VariantRow}
     * @memberof VariantMatrix
     */
    'rows': VariantRow;
    /**
     * 
     * @type {string}
     * @memberof VariantMatrix
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof VariantMatrix
     */
    'updated_by': string;
    /**
     * 
     * @type {string}
     * @memberof VariantMatrix
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof VariantMatrix
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof VariantMatrix
     */
    '__copiedFrom'?: string;
}
/**
 * 
 * @export
 * @interface VariantRow
 */
export interface VariantRow {
    /**
     * 
     * @type {string}
     * @memberof VariantRow
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof VariantRow
     */
    'custom_color': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof VariantRow
     */
    'images': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof VariantRow
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof VariantRow
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof VariantRow
     */
    'status': string;
    /**
     * 
     * @type {Array<VariantFields>}
     * @memberof VariantRow
     */
    'fields': Array<VariantFields>;
}
/**
 * 
 * @export
 * @interface VariantType
 */
export interface VariantType {
    /**
     * 
     * @type {string}
     * @memberof VariantType
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof VariantType
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof VariantType
     */
    'component': string;
    /**
     * 
     * @type {string}
     * @memberof VariantType
     */
    'name': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof VariantType
     */
    'options': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof VariantType
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof VariantType
     */
    'updated_by': string;
    /**
     * 
     * @type {string}
     * @memberof VariantType
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof VariantType
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof VariantType
     */
    '__copiedFrom'?: string;
}
/**
 * 
 * @export
 * @interface VariantValue
 */
export interface VariantValue {
    /**
     * 
     * @type {string}
     * @memberof VariantValue
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof VariantValue
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof VariantValue
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof VariantValue
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof VariantValue
     */
    'updated_by': string;
    /**
     * 
     * @type {string}
     * @memberof VariantValue
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof VariantValue
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof VariantValue
     */
    '__copiedFrom'?: string;
}
/**
 * 
 * @export
 * @interface VersionData
 */
export interface VersionData {
    /**
     * 
     * @type {string}
     * @memberof VersionData
     */
    's3Url': string;
    /**
     * 
     * @type {string}
     * @memberof VersionData
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof VersionData
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof VersionData
     */
    'updatedBy': string;
    /**
     * 
     * @type {string}
     * @memberof VersionData
     */
    'sourceProduct': string;
    /**
     * 
     * @type {string}
     * @memberof VersionData
     */
    'sourceComponent': string;
}
/**
 * 
 * @export
 * @interface Year
 */
export interface Year {
    /**
     * 
     * @type {string}
     * @memberof Year
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Year
     */
    'company': string;
    /**
     * 
     * @type {number}
     * @memberof Year
     */
    'order': number;
    /**
     * 
     * @type {string}
     * @memberof Year
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Year
     */
    'updatedAt': string;
}

/**
 * AdminApi - axios parameter creator
 * @export
 */
export const AdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCategoriesControllerDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminCategoriesControllerDelete', 'id', id)
            const localVarPath = `/admin/categories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCategoriesControllerQueryCategories: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminComponentTypesControllerDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminComponentTypesControllerDelete', 'id', id)
            const localVarPath = `/admin/component-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminComponentTypesControllerQueryComponentTypes: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/component-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminApi - functional programming interface
 * @export
 */
export const AdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCategoriesControllerDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCategoriesControllerDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCategoriesControllerQueryCategories(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Category>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCategoriesControllerQueryCategories(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminComponentTypesControllerDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminComponentTypesControllerDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminComponentTypesControllerQueryComponentTypes(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ComponentType>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminComponentTypesControllerQueryComponentTypes(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminApi - factory interface
 * @export
 */
export const AdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCategoriesControllerDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.adminCategoriesControllerDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCategoriesControllerQueryCategories(options?: any): AxiosPromise<Array<Category>> {
            return localVarFp.adminCategoriesControllerQueryCategories(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminComponentTypesControllerDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.adminComponentTypesControllerDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminComponentTypesControllerQueryComponentTypes(options?: any): AxiosPromise<Array<ComponentType>> {
            return localVarFp.adminComponentTypesControllerQueryComponentTypes(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
export class AdminApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminCategoriesControllerDelete(id: string, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminCategoriesControllerDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminCategoriesControllerQueryCategories(options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminCategoriesControllerQueryCategories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminComponentTypesControllerDelete(id: string, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminComponentTypesControllerDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminComponentTypesControllerQueryComponentTypes(options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminComponentTypesControllerQueryComponentTypes(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AnnotationsApi - axios parameter creator
 * @export
 */
export const AnnotationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {UpdateAnnotationDataDTO} updateAnnotationDataDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        annotationsControllerUpdate: async (id: string, updateAnnotationDataDTO: UpdateAnnotationDataDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('annotationsControllerUpdate', 'id', id)
            // verify required parameter 'updateAnnotationDataDTO' is not null or undefined
            assertParamExists('annotationsControllerUpdate', 'updateAnnotationDataDTO', updateAnnotationDataDTO)
            const localVarPath = `/annotations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAnnotationDataDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnnotationsApi - functional programming interface
 * @export
 */
export const AnnotationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnnotationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {UpdateAnnotationDataDTO} updateAnnotationDataDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async annotationsControllerUpdate(id: string, updateAnnotationDataDTO: UpdateAnnotationDataDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.annotationsControllerUpdate(id, updateAnnotationDataDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AnnotationsApi - factory interface
 * @export
 */
export const AnnotationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnnotationsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {UpdateAnnotationDataDTO} updateAnnotationDataDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        annotationsControllerUpdate(id: string, updateAnnotationDataDTO: UpdateAnnotationDataDTO, options?: any): AxiosPromise<void> {
            return localVarFp.annotationsControllerUpdate(id, updateAnnotationDataDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnnotationsApi - object-oriented interface
 * @export
 * @class AnnotationsApi
 * @extends {BaseAPI}
 */
export class AnnotationsApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {UpdateAnnotationDataDTO} updateAnnotationDataDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnotationsApi
     */
    public annotationsControllerUpdate(id: string, updateAnnotationDataDTO: UpdateAnnotationDataDTO, options?: AxiosRequestConfig) {
        return AnnotationsApiFp(this.configuration).annotationsControllerUpdate(id, updateAnnotationDataDTO, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BomItemsApi - axios parameter creator
 * @export
 */
export const BomItemsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bomItemControllerCopy: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('bomItemControllerCopy', 'id', id)
            const localVarPath = `/bom-items/{id}/copy`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BomItemQueryDTO} bomItemQueryDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bomItemControllerQueryByVariants: async (bomItemQueryDTO: BomItemQueryDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bomItemQueryDTO' is not null or undefined
            assertParamExists('bomItemControllerQueryByVariants', 'bomItemQueryDTO', bomItemQueryDTO)
            const localVarPath = `/bom-items/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bomItemQueryDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {PatchBomItemDTO} patchBomItemDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bomItemControllerUpdate: async (id: string, patchBomItemDTO: PatchBomItemDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('bomItemControllerUpdate', 'id', id)
            // verify required parameter 'patchBomItemDTO' is not null or undefined
            assertParamExists('bomItemControllerUpdate', 'patchBomItemDTO', patchBomItemDTO)
            const localVarPath = `/bom-items/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchBomItemDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BomItemsApi - functional programming interface
 * @export
 */
export const BomItemsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BomItemsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bomItemControllerCopy(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bomItemControllerCopy(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BomItemQueryDTO} bomItemQueryDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bomItemControllerQueryByVariants(bomItemQueryDTO: BomItemQueryDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BomItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bomItemControllerQueryByVariants(bomItemQueryDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {PatchBomItemDTO} patchBomItemDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bomItemControllerUpdate(id: string, patchBomItemDTO: PatchBomItemDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BomItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bomItemControllerUpdate(id, patchBomItemDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BomItemsApi - factory interface
 * @export
 */
export const BomItemsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BomItemsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bomItemControllerCopy(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.bomItemControllerCopy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BomItemQueryDTO} bomItemQueryDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bomItemControllerQueryByVariants(bomItemQueryDTO: BomItemQueryDTO, options?: any): AxiosPromise<Array<BomItem>> {
            return localVarFp.bomItemControllerQueryByVariants(bomItemQueryDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {PatchBomItemDTO} patchBomItemDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bomItemControllerUpdate(id: string, patchBomItemDTO: PatchBomItemDTO, options?: any): AxiosPromise<BomItem> {
            return localVarFp.bomItemControllerUpdate(id, patchBomItemDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BomItemsApi - object-oriented interface
 * @export
 * @class BomItemsApi
 * @extends {BaseAPI}
 */
export class BomItemsApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BomItemsApi
     */
    public bomItemControllerCopy(id: string, options?: AxiosRequestConfig) {
        return BomItemsApiFp(this.configuration).bomItemControllerCopy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BomItemQueryDTO} bomItemQueryDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BomItemsApi
     */
    public bomItemControllerQueryByVariants(bomItemQueryDTO: BomItemQueryDTO, options?: AxiosRequestConfig) {
        return BomItemsApiFp(this.configuration).bomItemControllerQueryByVariants(bomItemQueryDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {PatchBomItemDTO} patchBomItemDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BomItemsApi
     */
    public bomItemControllerUpdate(id: string, patchBomItemDTO: PatchBomItemDTO, options?: AxiosRequestConfig) {
        return BomItemsApiFp(this.configuration).bomItemControllerUpdate(id, patchBomItemDTO, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BomTemplatesApi - axios parameter creator
 * @export
 */
export const BomTemplatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateBomTemplateDTO} createBomTemplateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bomTemplatesControllerCreateBomTemplate: async (createBomTemplateDTO: CreateBomTemplateDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBomTemplateDTO' is not null or undefined
            assertParamExists('bomTemplatesControllerCreateBomTemplate', 'createBomTemplateDTO', createBomTemplateDTO)
            const localVarPath = `/bom-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBomTemplateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BomTemplatesApi - functional programming interface
 * @export
 */
export const BomTemplatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BomTemplatesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateBomTemplateDTO} createBomTemplateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bomTemplatesControllerCreateBomTemplate(createBomTemplateDTO: CreateBomTemplateDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bomTemplatesControllerCreateBomTemplate(createBomTemplateDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BomTemplatesApi - factory interface
 * @export
 */
export const BomTemplatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BomTemplatesApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateBomTemplateDTO} createBomTemplateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bomTemplatesControllerCreateBomTemplate(createBomTemplateDTO: CreateBomTemplateDTO, options?: any): AxiosPromise<object> {
            return localVarFp.bomTemplatesControllerCreateBomTemplate(createBomTemplateDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BomTemplatesApi - object-oriented interface
 * @export
 * @class BomTemplatesApi
 * @extends {BaseAPI}
 */
export class BomTemplatesApi extends BaseAPI {
    /**
     * 
     * @param {CreateBomTemplateDTO} createBomTemplateDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BomTemplatesApi
     */
    public bomTemplatesControllerCreateBomTemplate(createBomTemplateDTO: CreateBomTemplateDTO, options?: AxiosRequestConfig) {
        return BomTemplatesApiFp(this.configuration).bomTemplatesControllerCreateBomTemplate(createBomTemplateDTO, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BomTemplatesBomItemsApi - axios parameter creator
 * @export
 */
export const BomTemplatesBomItemsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {CreateBomItemDTO} createBomItemDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bomTemplatesBomItemsControllerCreateBomItem: async (id: string, createBomItemDTO: CreateBomItemDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('bomTemplatesBomItemsControllerCreateBomItem', 'id', id)
            // verify required parameter 'createBomItemDTO' is not null or undefined
            assertParamExists('bomTemplatesBomItemsControllerCreateBomItem', 'createBomItemDTO', createBomItemDTO)
            const localVarPath = `/bom-templates/{id}/bom-items`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBomItemDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id BoM Template Id
         * @param {DeleteBomItemsRequestDTO} deleteBomItemsRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bomTemplatesBomItemsControllerDeleteBomItems: async (id: string, deleteBomItemsRequestDTO: DeleteBomItemsRequestDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('bomTemplatesBomItemsControllerDeleteBomItems', 'id', id)
            // verify required parameter 'deleteBomItemsRequestDTO' is not null or undefined
            assertParamExists('bomTemplatesBomItemsControllerDeleteBomItems', 'deleteBomItemsRequestDTO', deleteBomItemsRequestDTO)
            const localVarPath = `/bom-templates/{id}/bom-items`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteBomItemsRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BomTemplatesBomItemsApi - functional programming interface
 * @export
 */
export const BomTemplatesBomItemsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BomTemplatesBomItemsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {CreateBomItemDTO} createBomItemDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bomTemplatesBomItemsControllerCreateBomItem(id: string, createBomItemDTO: CreateBomItemDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BomTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bomTemplatesBomItemsControllerCreateBomItem(id, createBomItemDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id BoM Template Id
         * @param {DeleteBomItemsRequestDTO} deleteBomItemsRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bomTemplatesBomItemsControllerDeleteBomItems(id: string, deleteBomItemsRequestDTO: DeleteBomItemsRequestDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteBomItemsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bomTemplatesBomItemsControllerDeleteBomItems(id, deleteBomItemsRequestDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BomTemplatesBomItemsApi - factory interface
 * @export
 */
export const BomTemplatesBomItemsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BomTemplatesBomItemsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {CreateBomItemDTO} createBomItemDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bomTemplatesBomItemsControllerCreateBomItem(id: string, createBomItemDTO: CreateBomItemDTO, options?: any): AxiosPromise<BomTemplate> {
            return localVarFp.bomTemplatesBomItemsControllerCreateBomItem(id, createBomItemDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id BoM Template Id
         * @param {DeleteBomItemsRequestDTO} deleteBomItemsRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bomTemplatesBomItemsControllerDeleteBomItems(id: string, deleteBomItemsRequestDTO: DeleteBomItemsRequestDTO, options?: any): AxiosPromise<DeleteBomItemsResponseDTO> {
            return localVarFp.bomTemplatesBomItemsControllerDeleteBomItems(id, deleteBomItemsRequestDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BomTemplatesBomItemsApi - object-oriented interface
 * @export
 * @class BomTemplatesBomItemsApi
 * @extends {BaseAPI}
 */
export class BomTemplatesBomItemsApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {CreateBomItemDTO} createBomItemDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BomTemplatesBomItemsApi
     */
    public bomTemplatesBomItemsControllerCreateBomItem(id: string, createBomItemDTO: CreateBomItemDTO, options?: AxiosRequestConfig) {
        return BomTemplatesBomItemsApiFp(this.configuration).bomTemplatesBomItemsControllerCreateBomItem(id, createBomItemDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id BoM Template Id
     * @param {DeleteBomItemsRequestDTO} deleteBomItemsRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BomTemplatesBomItemsApi
     */
    public bomTemplatesBomItemsControllerDeleteBomItems(id: string, deleteBomItemsRequestDTO: DeleteBomItemsRequestDTO, options?: AxiosRequestConfig) {
        return BomTemplatesBomItemsApiFp(this.configuration).bomTemplatesBomItemsControllerDeleteBomItems(id, deleteBomItemsRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BrandsApi - axios parameter creator
 * @export
 */
export const BrandsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brandsControllerQueryBrands: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/brands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BrandsApi - functional programming interface
 * @export
 */
export const BrandsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BrandsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async brandsControllerQueryBrands(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Brand>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.brandsControllerQueryBrands(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BrandsApi - factory interface
 * @export
 */
export const BrandsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BrandsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brandsControllerQueryBrands(options?: any): AxiosPromise<Array<Brand>> {
            return localVarFp.brandsControllerQueryBrands(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BrandsApi - object-oriented interface
 * @export
 * @class BrandsApi
 * @extends {BaseAPI}
 */
export class BrandsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsApi
     */
    public brandsControllerQueryBrands(options?: AxiosRequestConfig) {
        return BrandsApiFp(this.configuration).brandsControllerQueryBrands(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CategoriesApi - axios parameter creator
 * @export
 */
export const CategoriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCategoriesControllerDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminCategoriesControllerDelete', 'id', id)
            const localVarPath = `/admin/categories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCategoriesControllerQueryCategories: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CategoriesApi - functional programming interface
 * @export
 */
export const CategoriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CategoriesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCategoriesControllerDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCategoriesControllerDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCategoriesControllerQueryCategories(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Category>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCategoriesControllerQueryCategories(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CategoriesApi - factory interface
 * @export
 */
export const CategoriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CategoriesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCategoriesControllerDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.adminCategoriesControllerDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCategoriesControllerQueryCategories(options?: any): AxiosPromise<Array<Category>> {
            return localVarFp.adminCategoriesControllerQueryCategories(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CategoriesApi - object-oriented interface
 * @export
 * @class CategoriesApi
 * @extends {BaseAPI}
 */
export class CategoriesApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApi
     */
    public adminCategoriesControllerDelete(id: string, options?: AxiosRequestConfig) {
        return CategoriesApiFp(this.configuration).adminCategoriesControllerDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApi
     */
    public adminCategoriesControllerQueryCategories(options?: AxiosRequestConfig) {
        return CategoriesApiFp(this.configuration).adminCategoriesControllerQueryCategories(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ColorbooksApi - axios parameter creator
 * @export
 */
export const ColorbooksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        colorbooksControllerGetColorbooks: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/colorbooks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        colorbooksControllerListCards: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/colorbooks/cards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        colorbooksControllerListCardsByColorbook: async (slug: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('colorbooksControllerListCardsByColorbook', 'slug', slug)
            const localVarPath = `/colorbooks/{slug}`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ColorbooksApi - functional programming interface
 * @export
 */
export const ColorbooksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ColorbooksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async colorbooksControllerGetColorbooks(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.colorbooksControllerGetColorbooks(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async colorbooksControllerListCards(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.colorbooksControllerListCards(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async colorbooksControllerListCardsByColorbook(slug: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.colorbooksControllerListCardsByColorbook(slug, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ColorbooksApi - factory interface
 * @export
 */
export const ColorbooksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ColorbooksApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        colorbooksControllerGetColorbooks(options?: any): AxiosPromise<void> {
            return localVarFp.colorbooksControllerGetColorbooks(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        colorbooksControllerListCards(options?: any): AxiosPromise<void> {
            return localVarFp.colorbooksControllerListCards(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        colorbooksControllerListCardsByColorbook(slug: string, options?: any): AxiosPromise<void> {
            return localVarFp.colorbooksControllerListCardsByColorbook(slug, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ColorbooksApi - object-oriented interface
 * @export
 * @class ColorbooksApi
 * @extends {BaseAPI}
 */
export class ColorbooksApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ColorbooksApi
     */
    public colorbooksControllerGetColorbooks(options?: AxiosRequestConfig) {
        return ColorbooksApiFp(this.configuration).colorbooksControllerGetColorbooks(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ColorbooksApi
     */
    public colorbooksControllerListCards(options?: AxiosRequestConfig) {
        return ColorbooksApiFp(this.configuration).colorbooksControllerListCards(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ColorbooksApi
     */
    public colorbooksControllerListCardsByColorbook(slug: string, options?: AxiosRequestConfig) {
        return ColorbooksApiFp(this.configuration).colorbooksControllerListCardsByColorbook(slug, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CompaniesApi - axios parameter creator
 * @export
 */
export const CompaniesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateCompanyDto} createCompanyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyControllerCreateCompany: async (createCompanyDto: CreateCompanyDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCompanyDto' is not null or undefined
            assertParamExists('companyControllerCreateCompany', 'createCompanyDto', createCompanyDto)
            const localVarPath = `/companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCompanyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompaniesApi - functional programming interface
 * @export
 */
export const CompaniesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompaniesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateCompanyDto} createCompanyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyControllerCreateCompany(createCompanyDto: CreateCompanyDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyControllerCreateCompany(createCompanyDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CompaniesApi - factory interface
 * @export
 */
export const CompaniesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompaniesApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateCompanyDto} createCompanyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyControllerCreateCompany(createCompanyDto: CreateCompanyDto, options?: any): AxiosPromise<void> {
            return localVarFp.companyControllerCreateCompany(createCompanyDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompaniesApi - object-oriented interface
 * @export
 * @class CompaniesApi
 * @extends {BaseAPI}
 */
export class CompaniesApi extends BaseAPI {
    /**
     * 
     * @param {CreateCompanyDto} createCompanyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    public companyControllerCreateCompany(createCompanyDto: CreateCompanyDto, options?: AxiosRequestConfig) {
        return CompaniesApiFp(this.configuration).companyControllerCreateCompany(createCompanyDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CompaniesTechpackSectionsApi - axios parameter creator
 * @export
 */
export const CompaniesTechpackSectionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        techpackSectionsControllerUpdateTechpackSectionOrder: async (id: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('techpackSectionsControllerUpdateTechpackSectionOrder', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('techpackSectionsControllerUpdateTechpackSectionOrder', 'body', body)
            const localVarPath = `/companies/{id}/techpack-sections`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompaniesTechpackSectionsApi - functional programming interface
 * @export
 */
export const CompaniesTechpackSectionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompaniesTechpackSectionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async techpackSectionsControllerUpdateTechpackSectionOrder(id: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.techpackSectionsControllerUpdateTechpackSectionOrder(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CompaniesTechpackSectionsApi - factory interface
 * @export
 */
export const CompaniesTechpackSectionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompaniesTechpackSectionsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        techpackSectionsControllerUpdateTechpackSectionOrder(id: string, body: object, options?: any): AxiosPromise<Company> {
            return localVarFp.techpackSectionsControllerUpdateTechpackSectionOrder(id, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompaniesTechpackSectionsApi - object-oriented interface
 * @export
 * @class CompaniesTechpackSectionsApi
 * @extends {BaseAPI}
 */
export class CompaniesTechpackSectionsApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesTechpackSectionsApi
     */
    public techpackSectionsControllerUpdateTechpackSectionOrder(id: string, body: object, options?: AxiosRequestConfig) {
        return CompaniesTechpackSectionsApiFp(this.configuration).techpackSectionsControllerUpdateTechpackSectionOrder(id, body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ComponentColorwaysApi - axios parameter creator
 * @export
 */
export const ComponentColorwaysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} q 
         * @param {string} id Component Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentColorwaysControllerGetComponentColorways: async (q: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('componentColorwaysControllerGetComponentColorways', 'q', q)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentColorwaysControllerGetComponentColorways', 'id', id)
            const localVarPath = `/components/{id}/colorways`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComponentColorwaysApi - functional programming interface
 * @export
 */
export const ComponentColorwaysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ComponentColorwaysApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} q 
         * @param {string} id Component Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentColorwaysControllerGetComponentColorways(q: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Swatch>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentColorwaysControllerGetComponentColorways(q, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ComponentColorwaysApi - factory interface
 * @export
 */
export const ComponentColorwaysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ComponentColorwaysApiFp(configuration)
    return {
        /**
         * 
         * @param {string} q 
         * @param {string} id Component Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentColorwaysControllerGetComponentColorways(q: string, id: string, options?: any): AxiosPromise<Array<Swatch>> {
            return localVarFp.componentColorwaysControllerGetComponentColorways(q, id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ComponentColorwaysApi - object-oriented interface
 * @export
 * @class ComponentColorwaysApi
 * @extends {BaseAPI}
 */
export class ComponentColorwaysApi extends BaseAPI {
    /**
     * 
     * @param {string} q 
     * @param {string} id Component Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentColorwaysApi
     */
    public componentColorwaysControllerGetComponentColorways(q: string, id: string, options?: AxiosRequestConfig) {
        return ComponentColorwaysApiFp(this.configuration).componentColorwaysControllerGetComponentColorways(q, id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ComponentRevisionsApi - axios parameter creator
 * @export
 */
export const ComponentRevisionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} revisionId Revision Id
         * @param {string} imageId Image Id
         * @param {string} id Component Id
         * @param {CopyRevisionImageDTO} copyRevisionImageDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentRevisionsControllerCopyComponentRevisionImage: async (revisionId: string, imageId: string, id: string, copyRevisionImageDTO: CopyRevisionImageDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'revisionId' is not null or undefined
            assertParamExists('componentRevisionsControllerCopyComponentRevisionImage', 'revisionId', revisionId)
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('componentRevisionsControllerCopyComponentRevisionImage', 'imageId', imageId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentRevisionsControllerCopyComponentRevisionImage', 'id', id)
            // verify required parameter 'copyRevisionImageDTO' is not null or undefined
            assertParamExists('componentRevisionsControllerCopyComponentRevisionImage', 'copyRevisionImageDTO', copyRevisionImageDTO)
            const localVarPath = `/components/{id}/revisions/{revisionId}/images/{imageId}/copy`
                .replace(`{${"revisionId"}}`, encodeURIComponent(String(revisionId)))
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(copyRevisionImageDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Component Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentRevisionsControllerGetComponentRevisions: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentRevisionsControllerGetComponentRevisions', 'id', id)
            const localVarPath = `/components/{id}/revisions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sourceFileId 
         * @param {string} revisionId 
         * @param {string} id Component Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentRevisionsControllerGetComponentSourceFileById: async (sourceFileId: string, revisionId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceFileId' is not null or undefined
            assertParamExists('componentRevisionsControllerGetComponentSourceFileById', 'sourceFileId', sourceFileId)
            // verify required parameter 'revisionId' is not null or undefined
            assertParamExists('componentRevisionsControllerGetComponentSourceFileById', 'revisionId', revisionId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentRevisionsControllerGetComponentSourceFileById', 'id', id)
            const localVarPath = `/components/{id}/revisions/{revisionId}/source-files/{sourceFileId}`
                .replace(`{${"sourceFileId"}}`, encodeURIComponent(String(sourceFileId)))
                .replace(`{${"revisionId"}}`, encodeURIComponent(String(revisionId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Component Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentRevisionsControllerGetSourceFiles: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentRevisionsControllerGetSourceFiles', 'id', id)
            const localVarPath = `/components/{id}/revisions/source-files`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComponentRevisionsApi - functional programming interface
 * @export
 */
export const ComponentRevisionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ComponentRevisionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} revisionId Revision Id
         * @param {string} imageId Image Id
         * @param {string} id Component Id
         * @param {CopyRevisionImageDTO} copyRevisionImageDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentRevisionsControllerCopyComponentRevisionImage(revisionId: string, imageId: string, id: string, copyRevisionImageDTO: CopyRevisionImageDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Component>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentRevisionsControllerCopyComponentRevisionImage(revisionId, imageId, id, copyRevisionImageDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id Component Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentRevisionsControllerGetComponentRevisions(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Component>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentRevisionsControllerGetComponentRevisions(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} sourceFileId 
         * @param {string} revisionId 
         * @param {string} id Component Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentRevisionsControllerGetComponentSourceFileById(sourceFileId: string, revisionId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SourceFile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentRevisionsControllerGetComponentSourceFileById(sourceFileId, revisionId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id Component Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentRevisionsControllerGetSourceFiles(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Revision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentRevisionsControllerGetSourceFiles(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ComponentRevisionsApi - factory interface
 * @export
 */
export const ComponentRevisionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ComponentRevisionsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} revisionId Revision Id
         * @param {string} imageId Image Id
         * @param {string} id Component Id
         * @param {CopyRevisionImageDTO} copyRevisionImageDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentRevisionsControllerCopyComponentRevisionImage(revisionId: string, imageId: string, id: string, copyRevisionImageDTO: CopyRevisionImageDTO, options?: any): AxiosPromise<Component> {
            return localVarFp.componentRevisionsControllerCopyComponentRevisionImage(revisionId, imageId, id, copyRevisionImageDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Component Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentRevisionsControllerGetComponentRevisions(id: string, options?: any): AxiosPromise<Component> {
            return localVarFp.componentRevisionsControllerGetComponentRevisions(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sourceFileId 
         * @param {string} revisionId 
         * @param {string} id Component Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentRevisionsControllerGetComponentSourceFileById(sourceFileId: string, revisionId: string, id: string, options?: any): AxiosPromise<SourceFile> {
            return localVarFp.componentRevisionsControllerGetComponentSourceFileById(sourceFileId, revisionId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Component Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentRevisionsControllerGetSourceFiles(id: string, options?: any): AxiosPromise<Revision> {
            return localVarFp.componentRevisionsControllerGetSourceFiles(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ComponentRevisionsApi - object-oriented interface
 * @export
 * @class ComponentRevisionsApi
 * @extends {BaseAPI}
 */
export class ComponentRevisionsApi extends BaseAPI {
    /**
     * 
     * @param {string} revisionId Revision Id
     * @param {string} imageId Image Id
     * @param {string} id Component Id
     * @param {CopyRevisionImageDTO} copyRevisionImageDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentRevisionsApi
     */
    public componentRevisionsControllerCopyComponentRevisionImage(revisionId: string, imageId: string, id: string, copyRevisionImageDTO: CopyRevisionImageDTO, options?: AxiosRequestConfig) {
        return ComponentRevisionsApiFp(this.configuration).componentRevisionsControllerCopyComponentRevisionImage(revisionId, imageId, id, copyRevisionImageDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Component Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentRevisionsApi
     */
    public componentRevisionsControllerGetComponentRevisions(id: string, options?: AxiosRequestConfig) {
        return ComponentRevisionsApiFp(this.configuration).componentRevisionsControllerGetComponentRevisions(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sourceFileId 
     * @param {string} revisionId 
     * @param {string} id Component Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentRevisionsApi
     */
    public componentRevisionsControllerGetComponentSourceFileById(sourceFileId: string, revisionId: string, id: string, options?: AxiosRequestConfig) {
        return ComponentRevisionsApiFp(this.configuration).componentRevisionsControllerGetComponentSourceFileById(sourceFileId, revisionId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Component Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentRevisionsApi
     */
    public componentRevisionsControllerGetSourceFiles(id: string, options?: AxiosRequestConfig) {
        return ComponentRevisionsApiFp(this.configuration).componentRevisionsControllerGetSourceFiles(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ComponentSourceFilesApi - axios parameter creator
 * @export
 */
export const ComponentSourceFilesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {CreateSourceFileDto} createSourceFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentSourceFilesControllerCreateSourceFile: async (id: string, createSourceFileDto: CreateSourceFileDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentSourceFilesControllerCreateSourceFile', 'id', id)
            // verify required parameter 'createSourceFileDto' is not null or undefined
            assertParamExists('componentSourceFilesControllerCreateSourceFile', 'createSourceFileDto', createSourceFileDto)
            const localVarPath = `/components/{id}/source-files`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSourceFileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateFilesSignedUrlDto} createFilesSignedUrlDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentSourceFilesControllerGetSignedURL: async (id: string, createFilesSignedUrlDto: CreateFilesSignedUrlDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentSourceFilesControllerGetSignedURL', 'id', id)
            // verify required parameter 'createFilesSignedUrlDto' is not null or undefined
            assertParamExists('componentSourceFilesControllerGetSignedURL', 'createFilesSignedUrlDto', createFilesSignedUrlDto)
            const localVarPath = `/components/{id}/source-files/signed-urls`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFilesSignedUrlDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sourceFileId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentSourceFilesControllerGetSourceFile: async (sourceFileId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceFileId' is not null or undefined
            assertParamExists('componentSourceFilesControllerGetSourceFile', 'sourceFileId', sourceFileId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentSourceFilesControllerGetSourceFile', 'id', id)
            const localVarPath = `/components/{id}/source-files/{sourceFileId}`
                .replace(`{${"sourceFileId"}}`, encodeURIComponent(String(sourceFileId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentSourceFilesControllerGetSourceFiles: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentSourceFilesControllerGetSourceFiles', 'id', id)
            const localVarPath = `/components/{id}/source-files`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sourceFileId 
         * @param {string} id 
         * @param {UpdateSourceFilesImagesDTO} updateSourceFilesImagesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentSourceFilesControllerUpdateComponentImages: async (sourceFileId: string, id: string, updateSourceFilesImagesDTO: UpdateSourceFilesImagesDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceFileId' is not null or undefined
            assertParamExists('componentSourceFilesControllerUpdateComponentImages', 'sourceFileId', sourceFileId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentSourceFilesControllerUpdateComponentImages', 'id', id)
            // verify required parameter 'updateSourceFilesImagesDTO' is not null or undefined
            assertParamExists('componentSourceFilesControllerUpdateComponentImages', 'updateSourceFilesImagesDTO', updateSourceFilesImagesDTO)
            const localVarPath = `/components/{id}/source-files/{sourceFileId}/images`
                .replace(`{${"sourceFileId"}}`, encodeURIComponent(String(sourceFileId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSourceFilesImagesDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sourceFileId 
         * @param {string} id 
         * @param {UpdateSourceFileDto} updateSourceFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentSourceFilesControllerUpdateSourceFile: async (sourceFileId: string, id: string, updateSourceFileDto: UpdateSourceFileDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceFileId' is not null or undefined
            assertParamExists('componentSourceFilesControllerUpdateSourceFile', 'sourceFileId', sourceFileId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentSourceFilesControllerUpdateSourceFile', 'id', id)
            // verify required parameter 'updateSourceFileDto' is not null or undefined
            assertParamExists('componentSourceFilesControllerUpdateSourceFile', 'updateSourceFileDto', updateSourceFileDto)
            const localVarPath = `/components/{id}/source-files/{sourceFileId}`
                .replace(`{${"sourceFileId"}}`, encodeURIComponent(String(sourceFileId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSourceFileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComponentSourceFilesApi - functional programming interface
 * @export
 */
export const ComponentSourceFilesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ComponentSourceFilesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {CreateSourceFileDto} createSourceFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentSourceFilesControllerCreateSourceFile(id: string, createSourceFileDto: CreateSourceFileDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SourceFile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentSourceFilesControllerCreateSourceFile(id, createSourceFileDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateFilesSignedUrlDto} createFilesSignedUrlDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentSourceFilesControllerGetSignedURL(id: string, createFilesSignedUrlDto: CreateFilesSignedUrlDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentSourceFilesControllerGetSignedURL(id, createFilesSignedUrlDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} sourceFileId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentSourceFilesControllerGetSourceFile(sourceFileId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SourceFile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentSourceFilesControllerGetSourceFile(sourceFileId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentSourceFilesControllerGetSourceFiles(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SourceFile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentSourceFilesControllerGetSourceFiles(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} sourceFileId 
         * @param {string} id 
         * @param {UpdateSourceFilesImagesDTO} updateSourceFilesImagesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentSourceFilesControllerUpdateComponentImages(sourceFileId: string, id: string, updateSourceFilesImagesDTO: UpdateSourceFilesImagesDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentSourceFilesControllerUpdateComponentImages(sourceFileId, id, updateSourceFilesImagesDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} sourceFileId 
         * @param {string} id 
         * @param {UpdateSourceFileDto} updateSourceFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentSourceFilesControllerUpdateSourceFile(sourceFileId: string, id: string, updateSourceFileDto: UpdateSourceFileDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentSourceFilesControllerUpdateSourceFile(sourceFileId, id, updateSourceFileDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ComponentSourceFilesApi - factory interface
 * @export
 */
export const ComponentSourceFilesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ComponentSourceFilesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {CreateSourceFileDto} createSourceFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentSourceFilesControllerCreateSourceFile(id: string, createSourceFileDto: CreateSourceFileDto, options?: any): AxiosPromise<SourceFile> {
            return localVarFp.componentSourceFilesControllerCreateSourceFile(id, createSourceFileDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateFilesSignedUrlDto} createFilesSignedUrlDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentSourceFilesControllerGetSignedURL(id: string, createFilesSignedUrlDto: CreateFilesSignedUrlDto, options?: any): AxiosPromise<void> {
            return localVarFp.componentSourceFilesControllerGetSignedURL(id, createFilesSignedUrlDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sourceFileId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentSourceFilesControllerGetSourceFile(sourceFileId: string, id: string, options?: any): AxiosPromise<SourceFile> {
            return localVarFp.componentSourceFilesControllerGetSourceFile(sourceFileId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentSourceFilesControllerGetSourceFiles(id: string, options?: any): AxiosPromise<SourceFile> {
            return localVarFp.componentSourceFilesControllerGetSourceFiles(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sourceFileId 
         * @param {string} id 
         * @param {UpdateSourceFilesImagesDTO} updateSourceFilesImagesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentSourceFilesControllerUpdateComponentImages(sourceFileId: string, id: string, updateSourceFilesImagesDTO: UpdateSourceFilesImagesDTO, options?: any): AxiosPromise<void> {
            return localVarFp.componentSourceFilesControllerUpdateComponentImages(sourceFileId, id, updateSourceFilesImagesDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sourceFileId 
         * @param {string} id 
         * @param {UpdateSourceFileDto} updateSourceFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentSourceFilesControllerUpdateSourceFile(sourceFileId: string, id: string, updateSourceFileDto: UpdateSourceFileDto, options?: any): AxiosPromise<void> {
            return localVarFp.componentSourceFilesControllerUpdateSourceFile(sourceFileId, id, updateSourceFileDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ComponentSourceFilesApi - object-oriented interface
 * @export
 * @class ComponentSourceFilesApi
 * @extends {BaseAPI}
 */
export class ComponentSourceFilesApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {CreateSourceFileDto} createSourceFileDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentSourceFilesApi
     */
    public componentSourceFilesControllerCreateSourceFile(id: string, createSourceFileDto: CreateSourceFileDto, options?: AxiosRequestConfig) {
        return ComponentSourceFilesApiFp(this.configuration).componentSourceFilesControllerCreateSourceFile(id, createSourceFileDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {CreateFilesSignedUrlDto} createFilesSignedUrlDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentSourceFilesApi
     */
    public componentSourceFilesControllerGetSignedURL(id: string, createFilesSignedUrlDto: CreateFilesSignedUrlDto, options?: AxiosRequestConfig) {
        return ComponentSourceFilesApiFp(this.configuration).componentSourceFilesControllerGetSignedURL(id, createFilesSignedUrlDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sourceFileId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentSourceFilesApi
     */
    public componentSourceFilesControllerGetSourceFile(sourceFileId: string, id: string, options?: AxiosRequestConfig) {
        return ComponentSourceFilesApiFp(this.configuration).componentSourceFilesControllerGetSourceFile(sourceFileId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentSourceFilesApi
     */
    public componentSourceFilesControllerGetSourceFiles(id: string, options?: AxiosRequestConfig) {
        return ComponentSourceFilesApiFp(this.configuration).componentSourceFilesControllerGetSourceFiles(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sourceFileId 
     * @param {string} id 
     * @param {UpdateSourceFilesImagesDTO} updateSourceFilesImagesDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentSourceFilesApi
     */
    public componentSourceFilesControllerUpdateComponentImages(sourceFileId: string, id: string, updateSourceFilesImagesDTO: UpdateSourceFilesImagesDTO, options?: AxiosRequestConfig) {
        return ComponentSourceFilesApiFp(this.configuration).componentSourceFilesControllerUpdateComponentImages(sourceFileId, id, updateSourceFilesImagesDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sourceFileId 
     * @param {string} id 
     * @param {UpdateSourceFileDto} updateSourceFileDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentSourceFilesApi
     */
    public componentSourceFilesControllerUpdateSourceFile(sourceFileId: string, id: string, updateSourceFileDto: UpdateSourceFileDto, options?: AxiosRequestConfig) {
        return ComponentSourceFilesApiFp(this.configuration).componentSourceFilesControllerUpdateSourceFile(sourceFileId, id, updateSourceFileDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ComponentTechpacksApi - axios parameter creator
 * @export
 */
export const ComponentTechpacksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentTechpacksControllerGenerateNewComponentTechpack: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentTechpacksControllerGenerateNewComponentTechpack', 'id', id)
            const localVarPath = `/components/{id}/techpacks`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComponentTechpacksApi - functional programming interface
 * @export
 */
export const ComponentTechpacksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ComponentTechpacksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentTechpacksControllerGenerateNewComponentTechpack(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentTechpacksControllerGenerateNewComponentTechpack(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ComponentTechpacksApi - factory interface
 * @export
 */
export const ComponentTechpacksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ComponentTechpacksApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentTechpacksControllerGenerateNewComponentTechpack(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.componentTechpacksControllerGenerateNewComponentTechpack(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ComponentTechpacksApi - object-oriented interface
 * @export
 * @class ComponentTechpacksApi
 * @extends {BaseAPI}
 */
export class ComponentTechpacksApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentTechpacksApi
     */
    public componentTechpacksControllerGenerateNewComponentTechpack(id: string, options?: AxiosRequestConfig) {
        return ComponentTechpacksApiFp(this.configuration).componentTechpacksControllerGenerateNewComponentTechpack(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ComponentTypesApi - axios parameter creator
 * @export
 */
export const ComponentTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminComponentTypesControllerDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminComponentTypesControllerDelete', 'id', id)
            const localVarPath = `/admin/component-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminComponentTypesControllerQueryComponentTypes: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/component-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComponentTypesApi - functional programming interface
 * @export
 */
export const ComponentTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ComponentTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminComponentTypesControllerDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminComponentTypesControllerDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminComponentTypesControllerQueryComponentTypes(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ComponentType>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminComponentTypesControllerQueryComponentTypes(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ComponentTypesApi - factory interface
 * @export
 */
export const ComponentTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ComponentTypesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminComponentTypesControllerDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.adminComponentTypesControllerDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminComponentTypesControllerQueryComponentTypes(options?: any): AxiosPromise<Array<ComponentType>> {
            return localVarFp.adminComponentTypesControllerQueryComponentTypes(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ComponentTypesApi - object-oriented interface
 * @export
 * @class ComponentTypesApi
 * @extends {BaseAPI}
 */
export class ComponentTypesApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentTypesApi
     */
    public adminComponentTypesControllerDelete(id: string, options?: AxiosRequestConfig) {
        return ComponentTypesApiFp(this.configuration).adminComponentTypesControllerDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentTypesApi
     */
    public adminComponentTypesControllerQueryComponentTypes(options?: AxiosRequestConfig) {
        return ComponentTypesApiFp(this.configuration).adminComponentTypesControllerQueryComponentTypes(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ComponentUtilizationReportApi - axios parameter creator
 * @export
 */
export const ComponentUtilizationReportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentUtilizationReportControllerBulkDelete: async (requestBody: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('componentUtilizationReportControllerBulkDelete', 'requestBody', requestBody)
            const localVarPath = `/component-utilization-reports/bulk-delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentUtilizationReportControllerBulkRemoveFilter: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/component-utilization-reports/bulk-remove-filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentUtilizationReportControllerCreate: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/component-utilization-reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {GenerateCsvDto} generateCsvDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentUtilizationReportControllerCreateCsvReport: async (id: string, generateCsvDto: GenerateCsvDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentUtilizationReportControllerCreateCsvReport', 'id', id)
            // verify required parameter 'generateCsvDto' is not null or undefined
            assertParamExists('componentUtilizationReportControllerCreateCsvReport', 'generateCsvDto', generateCsvDto)
            const localVarPath = `/component-utilization-reports/{id}/csv`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateCsvDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentUtilizationReportControllerDeleteReport: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentUtilizationReportControllerDeleteReport', 'id', id)
            const localVarPath = `/component-utilization-reports/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentUtilizationReportControllerFindAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/component-utilization-reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentUtilizationReportControllerFindOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentUtilizationReportControllerFindOne', 'id', id)
            const localVarPath = `/component-utilization-reports/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentUtilizationReportControllerGenerate: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentUtilizationReportControllerGenerate', 'id', id)
            const localVarPath = `/component-utilization-reports/{id}/generate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentUtilizationReportControllerUpdateCustomFields: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/component-utilization-reports/custom-fields`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentUtilizationReportControllerUpdateReport: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentUtilizationReportControllerUpdateReport', 'id', id)
            const localVarPath = `/component-utilization-reports/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComponentUtilizationReportApi - functional programming interface
 * @export
 */
export const ComponentUtilizationReportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ComponentUtilizationReportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentUtilizationReportControllerBulkDelete(requestBody: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentUtilizationReportControllerBulkDelete(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentUtilizationReportControllerBulkRemoveFilter(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentUtilizationReportControllerBulkRemoveFilter(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentUtilizationReportControllerCreate(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComponentUtilizationReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentUtilizationReportControllerCreate(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {GenerateCsvDto} generateCsvDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentUtilizationReportControllerCreateCsvReport(id: string, generateCsvDto: GenerateCsvDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentUtilizationReportControllerCreateCsvReport(id, generateCsvDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentUtilizationReportControllerDeleteReport(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentUtilizationReportControllerDeleteReport(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentUtilizationReportControllerFindAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ComponentUtilizationReport>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentUtilizationReportControllerFindAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentUtilizationReportControllerFindOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComponentUtilizationReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentUtilizationReportControllerFindOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentUtilizationReportControllerGenerate(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentUtilizationReportControllerGenerate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentUtilizationReportControllerUpdateCustomFields(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentUtilizationReportControllerUpdateCustomFields(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentUtilizationReportControllerUpdateReport(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComponentUtilizationReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentUtilizationReportControllerUpdateReport(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ComponentUtilizationReportApi - factory interface
 * @export
 */
export const ComponentUtilizationReportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ComponentUtilizationReportApiFp(configuration)
    return {
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentUtilizationReportControllerBulkDelete(requestBody: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.componentUtilizationReportControllerBulkDelete(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentUtilizationReportControllerBulkRemoveFilter(options?: any): AxiosPromise<void> {
            return localVarFp.componentUtilizationReportControllerBulkRemoveFilter(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentUtilizationReportControllerCreate(options?: any): AxiosPromise<ComponentUtilizationReport> {
            return localVarFp.componentUtilizationReportControllerCreate(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {GenerateCsvDto} generateCsvDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentUtilizationReportControllerCreateCsvReport(id: string, generateCsvDto: GenerateCsvDto, options?: any): AxiosPromise<void> {
            return localVarFp.componentUtilizationReportControllerCreateCsvReport(id, generateCsvDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentUtilizationReportControllerDeleteReport(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.componentUtilizationReportControllerDeleteReport(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentUtilizationReportControllerFindAll(options?: any): AxiosPromise<Array<ComponentUtilizationReport>> {
            return localVarFp.componentUtilizationReportControllerFindAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentUtilizationReportControllerFindOne(id: string, options?: any): AxiosPromise<ComponentUtilizationReport> {
            return localVarFp.componentUtilizationReportControllerFindOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentUtilizationReportControllerGenerate(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.componentUtilizationReportControllerGenerate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentUtilizationReportControllerUpdateCustomFields(options?: any): AxiosPromise<void> {
            return localVarFp.componentUtilizationReportControllerUpdateCustomFields(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentUtilizationReportControllerUpdateReport(id: string, options?: any): AxiosPromise<ComponentUtilizationReport> {
            return localVarFp.componentUtilizationReportControllerUpdateReport(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ComponentUtilizationReportApi - object-oriented interface
 * @export
 * @class ComponentUtilizationReportApi
 * @extends {BaseAPI}
 */
export class ComponentUtilizationReportApi extends BaseAPI {
    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentUtilizationReportApi
     */
    public componentUtilizationReportControllerBulkDelete(requestBody: Array<string>, options?: AxiosRequestConfig) {
        return ComponentUtilizationReportApiFp(this.configuration).componentUtilizationReportControllerBulkDelete(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentUtilizationReportApi
     */
    public componentUtilizationReportControllerBulkRemoveFilter(options?: AxiosRequestConfig) {
        return ComponentUtilizationReportApiFp(this.configuration).componentUtilizationReportControllerBulkRemoveFilter(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentUtilizationReportApi
     */
    public componentUtilizationReportControllerCreate(options?: AxiosRequestConfig) {
        return ComponentUtilizationReportApiFp(this.configuration).componentUtilizationReportControllerCreate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {GenerateCsvDto} generateCsvDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentUtilizationReportApi
     */
    public componentUtilizationReportControllerCreateCsvReport(id: string, generateCsvDto: GenerateCsvDto, options?: AxiosRequestConfig) {
        return ComponentUtilizationReportApiFp(this.configuration).componentUtilizationReportControllerCreateCsvReport(id, generateCsvDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentUtilizationReportApi
     */
    public componentUtilizationReportControllerDeleteReport(id: string, options?: AxiosRequestConfig) {
        return ComponentUtilizationReportApiFp(this.configuration).componentUtilizationReportControllerDeleteReport(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentUtilizationReportApi
     */
    public componentUtilizationReportControllerFindAll(options?: AxiosRequestConfig) {
        return ComponentUtilizationReportApiFp(this.configuration).componentUtilizationReportControllerFindAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentUtilizationReportApi
     */
    public componentUtilizationReportControllerFindOne(id: string, options?: AxiosRequestConfig) {
        return ComponentUtilizationReportApiFp(this.configuration).componentUtilizationReportControllerFindOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentUtilizationReportApi
     */
    public componentUtilizationReportControllerGenerate(id: string, options?: AxiosRequestConfig) {
        return ComponentUtilizationReportApiFp(this.configuration).componentUtilizationReportControllerGenerate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentUtilizationReportApi
     */
    public componentUtilizationReportControllerUpdateCustomFields(options?: AxiosRequestConfig) {
        return ComponentUtilizationReportApiFp(this.configuration).componentUtilizationReportControllerUpdateCustomFields(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentUtilizationReportApi
     */
    public componentUtilizationReportControllerUpdateReport(id: string, options?: AxiosRequestConfig) {
        return ComponentUtilizationReportApiFp(this.configuration).componentUtilizationReportControllerUpdateReport(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ComponentsApi - axios parameter creator
 * @export
 */
export const ComponentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {AddColorwayDTO} addColorwayDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsControllerAddColorways: async (id: string, addColorwayDTO: AddColorwayDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentsControllerAddColorways', 'id', id)
            // verify required parameter 'addColorwayDTO' is not null or undefined
            assertParamExists('componentsControllerAddColorways', 'addColorwayDTO', addColorwayDTO)
            const localVarPath = `/components/{id}/colorways`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addColorwayDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fileId 
         * @param {string} componentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsControllerAddFile: async (fileId: string, componentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('componentsControllerAddFile', 'fileId', fileId)
            // verify required parameter 'componentId' is not null or undefined
            assertParamExists('componentsControllerAddFile', 'componentId', componentId)
            const localVarPath = `/components/{componentId}/files/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)))
                .replace(`{${"componentId"}}`, encodeURIComponent(String(componentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateComponentDTO} createComponentDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsControllerCreateComponent: async (createComponentDTO: CreateComponentDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createComponentDTO' is not null or undefined
            assertParamExists('componentsControllerCreateComponent', 'createComponentDTO', createComponentDTO)
            const localVarPath = `/components`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createComponentDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsControllerCreateComponentCopy: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentsControllerCreateComponentCopy', 'id', id)
            const localVarPath = `/components/{id}/copy`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsControllerGetComponentById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentsControllerGetComponentById', 'id', id)
            const localVarPath = `/components/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [query] 
         * @param {Array<string>} [division] 
         * @param {Array<string>} [season] 
         * @param {Array<string>} [year] 
         * @param {Array<string>} [brand] 
         * @param {Array<string>} [customFields] 
         * @param {boolean} [canceled] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {Array<string>} [componentType] 
         * @param {string} [sort] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsControllerQueryComponents: async (query?: string, division?: Array<string>, season?: Array<string>, year?: Array<string>, brand?: Array<string>, customFields?: Array<string>, canceled?: boolean, updatedAtStart?: string, updatedAtEnd?: string, componentType?: Array<string>, sort?: string, skip?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/components`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (division) {
                localVarQueryParameter['division'] = division;
            }

            if (season) {
                localVarQueryParameter['season'] = season;
            }

            if (year) {
                localVarQueryParameter['year'] = year;
            }

            if (brand) {
                localVarQueryParameter['brand'] = brand;
            }

            if (customFields) {
                localVarQueryParameter['custom_fields'] = customFields;
            }

            if (canceled !== undefined) {
                localVarQueryParameter['canceled'] = canceled;
            }

            if (updatedAtStart !== undefined) {
                localVarQueryParameter['updatedAtStart'] = (updatedAtStart as any instanceof Date) ?
                    (updatedAtStart as any).toISOString() :
                    updatedAtStart;
            }

            if (updatedAtEnd !== undefined) {
                localVarQueryParameter['updatedAtEnd'] = (updatedAtEnd as any instanceof Date) ?
                    (updatedAtEnd as any).toISOString() :
                    updatedAtEnd;
            }

            if (componentType) {
                localVarQueryParameter['component_type'] = componentType;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsControllerRemoveColorway: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentsControllerRemoveColorway', 'id', id)
            const localVarPath = `/components/{id}/colorway`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {RemoveColorwaysFromComponentDTO} removeColorwaysFromComponentDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsControllerRemoveColorways: async (id: string, removeColorwaysFromComponentDTO: RemoveColorwaysFromComponentDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentsControllerRemoveColorways', 'id', id)
            // verify required parameter 'removeColorwaysFromComponentDTO' is not null or undefined
            assertParamExists('componentsControllerRemoveColorways', 'removeColorwaysFromComponentDTO', removeColorwaysFromComponentDTO)
            const localVarPath = `/components/{id}/colorways`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeColorwaysFromComponentDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsControllerRemoveComponent: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentsControllerRemoveComponent', 'id', id)
            const localVarPath = `/components/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fileId 
         * @param {string} componentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsControllerRemoveFile: async (fileId: string, componentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('componentsControllerRemoveFile', 'fileId', fileId)
            // verify required parameter 'componentId' is not null or undefined
            assertParamExists('componentsControllerRemoveFile', 'componentId', componentId)
            const localVarPath = `/components/{componentId}/files/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)))
                .replace(`{${"componentId"}}`, encodeURIComponent(String(componentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsControllerUpdateComponent: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentsControllerUpdateComponent', 'id', id)
            const localVarPath = `/components/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsControllerUpdateComponentVariant: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentsControllerUpdateComponentVariant', 'id', id)
            const localVarPath = `/components/{id}/variants`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComponentsApi - functional programming interface
 * @export
 */
export const ComponentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ComponentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {AddColorwayDTO} addColorwayDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentsControllerAddColorways(id: string, addColorwayDTO: AddColorwayDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentsControllerAddColorways(id, addColorwayDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} fileId 
         * @param {string} componentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentsControllerAddFile(fileId: string, componentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Component>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentsControllerAddFile(fileId, componentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateComponentDTO} createComponentDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentsControllerCreateComponent(createComponentDTO: CreateComponentDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Component>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentsControllerCreateComponent(createComponentDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentsControllerCreateComponentCopy(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Component>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentsControllerCreateComponentCopy(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentsControllerGetComponentById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentsControllerGetComponentById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [query] 
         * @param {Array<string>} [division] 
         * @param {Array<string>} [season] 
         * @param {Array<string>} [year] 
         * @param {Array<string>} [brand] 
         * @param {Array<string>} [customFields] 
         * @param {boolean} [canceled] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {Array<string>} [componentType] 
         * @param {string} [sort] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentsControllerQueryComponents(query?: string, division?: Array<string>, season?: Array<string>, year?: Array<string>, brand?: Array<string>, customFields?: Array<string>, canceled?: boolean, updatedAtStart?: string, updatedAtEnd?: string, componentType?: Array<string>, sort?: string, skip?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComponentsControllerQueryComponents200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentsControllerQueryComponents(query, division, season, year, brand, customFields, canceled, updatedAtStart, updatedAtEnd, componentType, sort, skip, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentsControllerRemoveColorway(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentsControllerRemoveColorway(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {RemoveColorwaysFromComponentDTO} removeColorwaysFromComponentDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentsControllerRemoveColorways(id: string, removeColorwaysFromComponentDTO: RemoveColorwaysFromComponentDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentsControllerRemoveColorways(id, removeColorwaysFromComponentDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentsControllerRemoveComponent(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentsControllerRemoveComponent(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} fileId 
         * @param {string} componentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentsControllerRemoveFile(fileId: string, componentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Component>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentsControllerRemoveFile(fileId, componentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentsControllerUpdateComponent(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Component>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentsControllerUpdateComponent(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentsControllerUpdateComponentVariant(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentsControllerUpdateComponentVariant(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ComponentsApi - factory interface
 * @export
 */
export const ComponentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ComponentsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {AddColorwayDTO} addColorwayDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsControllerAddColorways(id: string, addColorwayDTO: AddColorwayDTO, options?: any): AxiosPromise<void> {
            return localVarFp.componentsControllerAddColorways(id, addColorwayDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} fileId 
         * @param {string} componentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsControllerAddFile(fileId: string, componentId: string, options?: any): AxiosPromise<Component> {
            return localVarFp.componentsControllerAddFile(fileId, componentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateComponentDTO} createComponentDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsControllerCreateComponent(createComponentDTO: CreateComponentDTO, options?: any): AxiosPromise<Component> {
            return localVarFp.componentsControllerCreateComponent(createComponentDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsControllerCreateComponentCopy(id: string, options?: any): AxiosPromise<Component> {
            return localVarFp.componentsControllerCreateComponentCopy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsControllerGetComponentById(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.componentsControllerGetComponentById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [query] 
         * @param {Array<string>} [division] 
         * @param {Array<string>} [season] 
         * @param {Array<string>} [year] 
         * @param {Array<string>} [brand] 
         * @param {Array<string>} [customFields] 
         * @param {boolean} [canceled] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {Array<string>} [componentType] 
         * @param {string} [sort] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsControllerQueryComponents(query?: string, division?: Array<string>, season?: Array<string>, year?: Array<string>, brand?: Array<string>, customFields?: Array<string>, canceled?: boolean, updatedAtStart?: string, updatedAtEnd?: string, componentType?: Array<string>, sort?: string, skip?: number, limit?: number, options?: any): AxiosPromise<ComponentsControllerQueryComponents200Response> {
            return localVarFp.componentsControllerQueryComponents(query, division, season, year, brand, customFields, canceled, updatedAtStart, updatedAtEnd, componentType, sort, skip, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsControllerRemoveColorway(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.componentsControllerRemoveColorway(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {RemoveColorwaysFromComponentDTO} removeColorwaysFromComponentDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsControllerRemoveColorways(id: string, removeColorwaysFromComponentDTO: RemoveColorwaysFromComponentDTO, options?: any): AxiosPromise<void> {
            return localVarFp.componentsControllerRemoveColorways(id, removeColorwaysFromComponentDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsControllerRemoveComponent(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.componentsControllerRemoveComponent(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} fileId 
         * @param {string} componentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsControllerRemoveFile(fileId: string, componentId: string, options?: any): AxiosPromise<Component> {
            return localVarFp.componentsControllerRemoveFile(fileId, componentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsControllerUpdateComponent(id: string, options?: any): AxiosPromise<Component> {
            return localVarFp.componentsControllerUpdateComponent(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsControllerUpdateComponentVariant(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.componentsControllerUpdateComponentVariant(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ComponentsApi - object-oriented interface
 * @export
 * @class ComponentsApi
 * @extends {BaseAPI}
 */
export class ComponentsApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {AddColorwayDTO} addColorwayDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsApi
     */
    public componentsControllerAddColorways(id: string, addColorwayDTO: AddColorwayDTO, options?: AxiosRequestConfig) {
        return ComponentsApiFp(this.configuration).componentsControllerAddColorways(id, addColorwayDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} fileId 
     * @param {string} componentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsApi
     */
    public componentsControllerAddFile(fileId: string, componentId: string, options?: AxiosRequestConfig) {
        return ComponentsApiFp(this.configuration).componentsControllerAddFile(fileId, componentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateComponentDTO} createComponentDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsApi
     */
    public componentsControllerCreateComponent(createComponentDTO: CreateComponentDTO, options?: AxiosRequestConfig) {
        return ComponentsApiFp(this.configuration).componentsControllerCreateComponent(createComponentDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsApi
     */
    public componentsControllerCreateComponentCopy(id: string, options?: AxiosRequestConfig) {
        return ComponentsApiFp(this.configuration).componentsControllerCreateComponentCopy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsApi
     */
    public componentsControllerGetComponentById(id: string, options?: AxiosRequestConfig) {
        return ComponentsApiFp(this.configuration).componentsControllerGetComponentById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [query] 
     * @param {Array<string>} [division] 
     * @param {Array<string>} [season] 
     * @param {Array<string>} [year] 
     * @param {Array<string>} [brand] 
     * @param {Array<string>} [customFields] 
     * @param {boolean} [canceled] 
     * @param {string} [updatedAtStart] 
     * @param {string} [updatedAtEnd] 
     * @param {Array<string>} [componentType] 
     * @param {string} [sort] 
     * @param {number} [skip] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsApi
     */
    public componentsControllerQueryComponents(query?: string, division?: Array<string>, season?: Array<string>, year?: Array<string>, brand?: Array<string>, customFields?: Array<string>, canceled?: boolean, updatedAtStart?: string, updatedAtEnd?: string, componentType?: Array<string>, sort?: string, skip?: number, limit?: number, options?: AxiosRequestConfig) {
        return ComponentsApiFp(this.configuration).componentsControllerQueryComponents(query, division, season, year, brand, customFields, canceled, updatedAtStart, updatedAtEnd, componentType, sort, skip, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsApi
     */
    public componentsControllerRemoveColorway(id: string, options?: AxiosRequestConfig) {
        return ComponentsApiFp(this.configuration).componentsControllerRemoveColorway(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {RemoveColorwaysFromComponentDTO} removeColorwaysFromComponentDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsApi
     */
    public componentsControllerRemoveColorways(id: string, removeColorwaysFromComponentDTO: RemoveColorwaysFromComponentDTO, options?: AxiosRequestConfig) {
        return ComponentsApiFp(this.configuration).componentsControllerRemoveColorways(id, removeColorwaysFromComponentDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsApi
     */
    public componentsControllerRemoveComponent(id: string, options?: AxiosRequestConfig) {
        return ComponentsApiFp(this.configuration).componentsControllerRemoveComponent(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} fileId 
     * @param {string} componentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsApi
     */
    public componentsControllerRemoveFile(fileId: string, componentId: string, options?: AxiosRequestConfig) {
        return ComponentsApiFp(this.configuration).componentsControllerRemoveFile(fileId, componentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsApi
     */
    public componentsControllerUpdateComponent(id: string, options?: AxiosRequestConfig) {
        return ComponentsApiFp(this.configuration).componentsControllerUpdateComponent(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsApi
     */
    public componentsControllerUpdateComponentVariant(id: string, options?: AxiosRequestConfig) {
        return ComponentsApiFp(this.configuration).componentsControllerUpdateComponentVariant(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ComponentsComponentIdVariantMatrixApi - axios parameter creator
 * @export
 */
export const ComponentsComponentIdVariantMatrixApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} componentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        variantMatrixControllerGetVariantMatrixForComponent: async (componentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentId' is not null or undefined
            assertParamExists('variantMatrixControllerGetVariantMatrixForComponent', 'componentId', componentId)
            const localVarPath = `/components/{componentId}/variant-matrix`
                .replace(`{${"componentId"}}`, encodeURIComponent(String(componentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} variantMatrixId 
         * @param {string} componentId 
         * @param {UpdateVariantMatrixPropertiesDTO} updateVariantMatrixPropertiesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        variantMatrixControllerUpdateVariantMatrixProperties: async (variantMatrixId: string, componentId: string, updateVariantMatrixPropertiesDTO: UpdateVariantMatrixPropertiesDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'variantMatrixId' is not null or undefined
            assertParamExists('variantMatrixControllerUpdateVariantMatrixProperties', 'variantMatrixId', variantMatrixId)
            // verify required parameter 'componentId' is not null or undefined
            assertParamExists('variantMatrixControllerUpdateVariantMatrixProperties', 'componentId', componentId)
            // verify required parameter 'updateVariantMatrixPropertiesDTO' is not null or undefined
            assertParamExists('variantMatrixControllerUpdateVariantMatrixProperties', 'updateVariantMatrixPropertiesDTO', updateVariantMatrixPropertiesDTO)
            const localVarPath = `/components/{componentId}/variant-matrix/{variantMatrixId}`
                .replace(`{${"variantMatrixId"}}`, encodeURIComponent(String(variantMatrixId)))
                .replace(`{${"componentId"}}`, encodeURIComponent(String(componentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVariantMatrixPropertiesDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComponentsComponentIdVariantMatrixApi - functional programming interface
 * @export
 */
export const ComponentsComponentIdVariantMatrixApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ComponentsComponentIdVariantMatrixApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} componentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async variantMatrixControllerGetVariantMatrixForComponent(componentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VariantMatrix>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.variantMatrixControllerGetVariantMatrixForComponent(componentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} variantMatrixId 
         * @param {string} componentId 
         * @param {UpdateVariantMatrixPropertiesDTO} updateVariantMatrixPropertiesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async variantMatrixControllerUpdateVariantMatrixProperties(variantMatrixId: string, componentId: string, updateVariantMatrixPropertiesDTO: UpdateVariantMatrixPropertiesDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VariantMatrix>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.variantMatrixControllerUpdateVariantMatrixProperties(variantMatrixId, componentId, updateVariantMatrixPropertiesDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ComponentsComponentIdVariantMatrixApi - factory interface
 * @export
 */
export const ComponentsComponentIdVariantMatrixApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ComponentsComponentIdVariantMatrixApiFp(configuration)
    return {
        /**
         * 
         * @param {string} componentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        variantMatrixControllerGetVariantMatrixForComponent(componentId: string, options?: any): AxiosPromise<VariantMatrix> {
            return localVarFp.variantMatrixControllerGetVariantMatrixForComponent(componentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} variantMatrixId 
         * @param {string} componentId 
         * @param {UpdateVariantMatrixPropertiesDTO} updateVariantMatrixPropertiesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        variantMatrixControllerUpdateVariantMatrixProperties(variantMatrixId: string, componentId: string, updateVariantMatrixPropertiesDTO: UpdateVariantMatrixPropertiesDTO, options?: any): AxiosPromise<VariantMatrix> {
            return localVarFp.variantMatrixControllerUpdateVariantMatrixProperties(variantMatrixId, componentId, updateVariantMatrixPropertiesDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ComponentsComponentIdVariantMatrixApi - object-oriented interface
 * @export
 * @class ComponentsComponentIdVariantMatrixApi
 * @extends {BaseAPI}
 */
export class ComponentsComponentIdVariantMatrixApi extends BaseAPI {
    /**
     * 
     * @param {string} componentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsComponentIdVariantMatrixApi
     */
    public variantMatrixControllerGetVariantMatrixForComponent(componentId: string, options?: AxiosRequestConfig) {
        return ComponentsComponentIdVariantMatrixApiFp(this.configuration).variantMatrixControllerGetVariantMatrixForComponent(componentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} variantMatrixId 
     * @param {string} componentId 
     * @param {UpdateVariantMatrixPropertiesDTO} updateVariantMatrixPropertiesDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsComponentIdVariantMatrixApi
     */
    public variantMatrixControllerUpdateVariantMatrixProperties(variantMatrixId: string, componentId: string, updateVariantMatrixPropertiesDTO: UpdateVariantMatrixPropertiesDTO, options?: AxiosRequestConfig) {
        return ComponentsComponentIdVariantMatrixApiFp(this.configuration).variantMatrixControllerUpdateVariantMatrixProperties(variantMatrixId, componentId, updateVariantMatrixPropertiesDTO, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ComponentsComponentIdVariantTypesApi - axios parameter creator
 * @export
 */
export const ComponentsComponentIdVariantTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} componentId 
         * @param {CreateVariantTypeDTO} createVariantTypeDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        variantTypesControllerCreateVariantType: async (componentId: string, createVariantTypeDTO: CreateVariantTypeDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentId' is not null or undefined
            assertParamExists('variantTypesControllerCreateVariantType', 'componentId', componentId)
            // verify required parameter 'createVariantTypeDTO' is not null or undefined
            assertParamExists('variantTypesControllerCreateVariantType', 'createVariantTypeDTO', createVariantTypeDTO)
            const localVarPath = `/components/{componentId}/variant-types`
                .replace(`{${"componentId"}}`, encodeURIComponent(String(componentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createVariantTypeDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} componentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        variantTypesControllerGetVariantTypes: async (componentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentId' is not null or undefined
            assertParamExists('variantTypesControllerGetVariantTypes', 'componentId', componentId)
            const localVarPath = `/components/{componentId}/variant-types`
                .replace(`{${"componentId"}}`, encodeURIComponent(String(componentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} variantTypeId 
         * @param {string} componentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        variantTypesControllerRemoveVariantType: async (variantTypeId: string, componentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'variantTypeId' is not null or undefined
            assertParamExists('variantTypesControllerRemoveVariantType', 'variantTypeId', variantTypeId)
            // verify required parameter 'componentId' is not null or undefined
            assertParamExists('variantTypesControllerRemoveVariantType', 'componentId', componentId)
            const localVarPath = `/components/{componentId}/variant-types/{variantTypeId}`
                .replace(`{${"variantTypeId"}}`, encodeURIComponent(String(variantTypeId)))
                .replace(`{${"componentId"}}`, encodeURIComponent(String(componentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} variantTypeId 
         * @param {string} componentId 
         * @param {UpdateVariantTypeDto} updateVariantTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        variantTypesControllerUpdateVariantType: async (variantTypeId: string, componentId: string, updateVariantTypeDto: UpdateVariantTypeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'variantTypeId' is not null or undefined
            assertParamExists('variantTypesControllerUpdateVariantType', 'variantTypeId', variantTypeId)
            // verify required parameter 'componentId' is not null or undefined
            assertParamExists('variantTypesControllerUpdateVariantType', 'componentId', componentId)
            // verify required parameter 'updateVariantTypeDto' is not null or undefined
            assertParamExists('variantTypesControllerUpdateVariantType', 'updateVariantTypeDto', updateVariantTypeDto)
            const localVarPath = `/components/{componentId}/variant-types/{variantTypeId}`
                .replace(`{${"variantTypeId"}}`, encodeURIComponent(String(variantTypeId)))
                .replace(`{${"componentId"}}`, encodeURIComponent(String(componentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVariantTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComponentsComponentIdVariantTypesApi - functional programming interface
 * @export
 */
export const ComponentsComponentIdVariantTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ComponentsComponentIdVariantTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} componentId 
         * @param {CreateVariantTypeDTO} createVariantTypeDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async variantTypesControllerCreateVariantType(componentId: string, createVariantTypeDTO: CreateVariantTypeDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VariantType>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.variantTypesControllerCreateVariantType(componentId, createVariantTypeDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} componentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async variantTypesControllerGetVariantTypes(componentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VariantType>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.variantTypesControllerGetVariantTypes(componentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} variantTypeId 
         * @param {string} componentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async variantTypesControllerRemoveVariantType(variantTypeId: string, componentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Component>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.variantTypesControllerRemoveVariantType(variantTypeId, componentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} variantTypeId 
         * @param {string} componentId 
         * @param {UpdateVariantTypeDto} updateVariantTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async variantTypesControllerUpdateVariantType(variantTypeId: string, componentId: string, updateVariantTypeDto: UpdateVariantTypeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VariantType>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.variantTypesControllerUpdateVariantType(variantTypeId, componentId, updateVariantTypeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ComponentsComponentIdVariantTypesApi - factory interface
 * @export
 */
export const ComponentsComponentIdVariantTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ComponentsComponentIdVariantTypesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} componentId 
         * @param {CreateVariantTypeDTO} createVariantTypeDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        variantTypesControllerCreateVariantType(componentId: string, createVariantTypeDTO: CreateVariantTypeDTO, options?: any): AxiosPromise<VariantType> {
            return localVarFp.variantTypesControllerCreateVariantType(componentId, createVariantTypeDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} componentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        variantTypesControllerGetVariantTypes(componentId: string, options?: any): AxiosPromise<Array<VariantType>> {
            return localVarFp.variantTypesControllerGetVariantTypes(componentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} variantTypeId 
         * @param {string} componentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        variantTypesControllerRemoveVariantType(variantTypeId: string, componentId: string, options?: any): AxiosPromise<Component> {
            return localVarFp.variantTypesControllerRemoveVariantType(variantTypeId, componentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} variantTypeId 
         * @param {string} componentId 
         * @param {UpdateVariantTypeDto} updateVariantTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        variantTypesControllerUpdateVariantType(variantTypeId: string, componentId: string, updateVariantTypeDto: UpdateVariantTypeDto, options?: any): AxiosPromise<VariantType> {
            return localVarFp.variantTypesControllerUpdateVariantType(variantTypeId, componentId, updateVariantTypeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ComponentsComponentIdVariantTypesApi - object-oriented interface
 * @export
 * @class ComponentsComponentIdVariantTypesApi
 * @extends {BaseAPI}
 */
export class ComponentsComponentIdVariantTypesApi extends BaseAPI {
    /**
     * 
     * @param {string} componentId 
     * @param {CreateVariantTypeDTO} createVariantTypeDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsComponentIdVariantTypesApi
     */
    public variantTypesControllerCreateVariantType(componentId: string, createVariantTypeDTO: CreateVariantTypeDTO, options?: AxiosRequestConfig) {
        return ComponentsComponentIdVariantTypesApiFp(this.configuration).variantTypesControllerCreateVariantType(componentId, createVariantTypeDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} componentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsComponentIdVariantTypesApi
     */
    public variantTypesControllerGetVariantTypes(componentId: string, options?: AxiosRequestConfig) {
        return ComponentsComponentIdVariantTypesApiFp(this.configuration).variantTypesControllerGetVariantTypes(componentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} variantTypeId 
     * @param {string} componentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsComponentIdVariantTypesApi
     */
    public variantTypesControllerRemoveVariantType(variantTypeId: string, componentId: string, options?: AxiosRequestConfig) {
        return ComponentsComponentIdVariantTypesApiFp(this.configuration).variantTypesControllerRemoveVariantType(variantTypeId, componentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} variantTypeId 
     * @param {string} componentId 
     * @param {UpdateVariantTypeDto} updateVariantTypeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsComponentIdVariantTypesApi
     */
    public variantTypesControllerUpdateVariantType(variantTypeId: string, componentId: string, updateVariantTypeDto: UpdateVariantTypeDto, options?: AxiosRequestConfig) {
        return ComponentsComponentIdVariantTypesApiFp(this.configuration).variantTypesControllerUpdateVariantType(variantTypeId, componentId, updateVariantTypeDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ComponentsComponentIdVariantValuesApi - axios parameter creator
 * @export
 */
export const ComponentsComponentIdVariantValuesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} variantValueId 
         * @param {string} componentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        variantValuesControllerRemoveVariantValue: async (variantValueId: string, componentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'variantValueId' is not null or undefined
            assertParamExists('variantValuesControllerRemoveVariantValue', 'variantValueId', variantValueId)
            // verify required parameter 'componentId' is not null or undefined
            assertParamExists('variantValuesControllerRemoveVariantValue', 'componentId', componentId)
            const localVarPath = `/components/{componentId}/variant-values/{variantValueId}`
                .replace(`{${"variantValueId"}}`, encodeURIComponent(String(variantValueId)))
                .replace(`{${"componentId"}}`, encodeURIComponent(String(componentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} variantValueId 
         * @param {string} componentId 
         * @param {UpdateVariantValueDTO} updateVariantValueDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        variantValuesControllerUpdateVariantType: async (variantValueId: string, componentId: string, updateVariantValueDTO: UpdateVariantValueDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'variantValueId' is not null or undefined
            assertParamExists('variantValuesControllerUpdateVariantType', 'variantValueId', variantValueId)
            // verify required parameter 'componentId' is not null or undefined
            assertParamExists('variantValuesControllerUpdateVariantType', 'componentId', componentId)
            // verify required parameter 'updateVariantValueDTO' is not null or undefined
            assertParamExists('variantValuesControllerUpdateVariantType', 'updateVariantValueDTO', updateVariantValueDTO)
            const localVarPath = `/components/{componentId}/variant-values/{variantValueId}`
                .replace(`{${"variantValueId"}}`, encodeURIComponent(String(variantValueId)))
                .replace(`{${"componentId"}}`, encodeURIComponent(String(componentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVariantValueDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComponentsComponentIdVariantValuesApi - functional programming interface
 * @export
 */
export const ComponentsComponentIdVariantValuesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ComponentsComponentIdVariantValuesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} variantValueId 
         * @param {string} componentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async variantValuesControllerRemoveVariantValue(variantValueId: string, componentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Component>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.variantValuesControllerRemoveVariantValue(variantValueId, componentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} variantValueId 
         * @param {string} componentId 
         * @param {UpdateVariantValueDTO} updateVariantValueDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async variantValuesControllerUpdateVariantType(variantValueId: string, componentId: string, updateVariantValueDTO: UpdateVariantValueDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VariantValue>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.variantValuesControllerUpdateVariantType(variantValueId, componentId, updateVariantValueDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ComponentsComponentIdVariantValuesApi - factory interface
 * @export
 */
export const ComponentsComponentIdVariantValuesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ComponentsComponentIdVariantValuesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} variantValueId 
         * @param {string} componentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        variantValuesControllerRemoveVariantValue(variantValueId: string, componentId: string, options?: any): AxiosPromise<Component> {
            return localVarFp.variantValuesControllerRemoveVariantValue(variantValueId, componentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} variantValueId 
         * @param {string} componentId 
         * @param {UpdateVariantValueDTO} updateVariantValueDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        variantValuesControllerUpdateVariantType(variantValueId: string, componentId: string, updateVariantValueDTO: UpdateVariantValueDTO, options?: any): AxiosPromise<VariantValue> {
            return localVarFp.variantValuesControllerUpdateVariantType(variantValueId, componentId, updateVariantValueDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ComponentsComponentIdVariantValuesApi - object-oriented interface
 * @export
 * @class ComponentsComponentIdVariantValuesApi
 * @extends {BaseAPI}
 */
export class ComponentsComponentIdVariantValuesApi extends BaseAPI {
    /**
     * 
     * @param {string} variantValueId 
     * @param {string} componentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsComponentIdVariantValuesApi
     */
    public variantValuesControllerRemoveVariantValue(variantValueId: string, componentId: string, options?: AxiosRequestConfig) {
        return ComponentsComponentIdVariantValuesApiFp(this.configuration).variantValuesControllerRemoveVariantValue(variantValueId, componentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} variantValueId 
     * @param {string} componentId 
     * @param {UpdateVariantValueDTO} updateVariantValueDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsComponentIdVariantValuesApi
     */
    public variantValuesControllerUpdateVariantType(variantValueId: string, componentId: string, updateVariantValueDTO: UpdateVariantValueDTO, options?: AxiosRequestConfig) {
        return ComponentsComponentIdVariantValuesApiFp(this.configuration).variantValuesControllerUpdateVariantType(variantValueId, componentId, updateVariantValueDTO, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ComponentsImagesApi - axios parameter creator
 * @export
 */
export const ComponentsImagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id Component Id
         * @param {DeleteComponentImagesDTO} deleteComponentImagesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsImagesControllerBulkDeleteComponentImages: async (id: string, deleteComponentImagesDTO: DeleteComponentImagesDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentsImagesControllerBulkDeleteComponentImages', 'id', id)
            // verify required parameter 'deleteComponentImagesDTO' is not null or undefined
            assertParamExists('componentsImagesControllerBulkDeleteComponentImages', 'deleteComponentImagesDTO', deleteComponentImagesDTO)
            const localVarPath = `/components/{id}/images/bulk`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteComponentImagesDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Component Id
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsImagesControllerBulkUpdateComponentImages: async (id: string, requestBody: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentsImagesControllerBulkUpdateComponentImages', 'id', id)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('componentsImagesControllerBulkUpdateComponentImages', 'requestBody', requestBody)
            const localVarPath = `/components/{id}/images`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Component Id
         * @param {CreateImageDTO} createImageDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsImagesControllerCreateImageJob: async (id: string, createImageDTO: CreateImageDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentsImagesControllerCreateImageJob', 'id', id)
            // verify required parameter 'createImageDTO' is not null or undefined
            assertParamExists('componentsImagesControllerCreateImageJob', 'createImageDTO', createImageDTO)
            const localVarPath = `/components/{id}/images`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createImageDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} imageId Image Id
         * @param {string} id Component Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsImagesControllerDeleteComponentImage: async (imageId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('componentsImagesControllerDeleteComponentImage', 'imageId', imageId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentsImagesControllerDeleteComponentImage', 'id', id)
            const localVarPath = `/components/{id}/images/{imageId}`
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Component Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsImagesControllerGetImages: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentsImagesControllerGetImages', 'id', id)
            const localVarPath = `/components/{id}/images`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Component Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsImagesControllerGetSourceFiles: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentsImagesControllerGetSourceFiles', 'id', id)
            const localVarPath = `/components/{id}/images/source-files`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} imageId Image Id
         * @param {string} id Component Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsImagesControllerSetDefaultComponentImage: async (imageId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('componentsImagesControllerSetDefaultComponentImage', 'imageId', imageId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentsImagesControllerSetDefaultComponentImage', 'id', id)
            const localVarPath = `/components/{id}/images/{imageId}/default`
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} imageId Image Id
         * @param {string} id Component Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsImagesControllerUpdateComponentImage: async (imageId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('componentsImagesControllerUpdateComponentImage', 'imageId', imageId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('componentsImagesControllerUpdateComponentImage', 'id', id)
            const localVarPath = `/components/{id}/images/{imageId}`
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComponentsImagesApi - functional programming interface
 * @export
 */
export const ComponentsImagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ComponentsImagesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id Component Id
         * @param {DeleteComponentImagesDTO} deleteComponentImagesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentsImagesControllerBulkDeleteComponentImages(id: string, deleteComponentImagesDTO: DeleteComponentImagesDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Component>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentsImagesControllerBulkDeleteComponentImages(id, deleteComponentImagesDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id Component Id
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentsImagesControllerBulkUpdateComponentImages(id: string, requestBody: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Component>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentsImagesControllerBulkUpdateComponentImages(id, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id Component Id
         * @param {CreateImageDTO} createImageDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentsImagesControllerCreateImageJob(id: string, createImageDTO: CreateImageDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Component>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentsImagesControllerCreateImageJob(id, createImageDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} imageId Image Id
         * @param {string} id Component Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentsImagesControllerDeleteComponentImage(imageId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Component>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentsImagesControllerDeleteComponentImage(imageId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id Component Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentsImagesControllerGetImages(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TechpackImage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentsImagesControllerGetImages(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id Component Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentsImagesControllerGetSourceFiles(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SourceFile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentsImagesControllerGetSourceFiles(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} imageId Image Id
         * @param {string} id Component Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentsImagesControllerSetDefaultComponentImage(imageId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentsImagesControllerSetDefaultComponentImage(imageId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} imageId Image Id
         * @param {string} id Component Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async componentsImagesControllerUpdateComponentImage(imageId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Image>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.componentsImagesControllerUpdateComponentImage(imageId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ComponentsImagesApi - factory interface
 * @export
 */
export const ComponentsImagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ComponentsImagesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id Component Id
         * @param {DeleteComponentImagesDTO} deleteComponentImagesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsImagesControllerBulkDeleteComponentImages(id: string, deleteComponentImagesDTO: DeleteComponentImagesDTO, options?: any): AxiosPromise<Component> {
            return localVarFp.componentsImagesControllerBulkDeleteComponentImages(id, deleteComponentImagesDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Component Id
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsImagesControllerBulkUpdateComponentImages(id: string, requestBody: Array<string>, options?: any): AxiosPromise<Component> {
            return localVarFp.componentsImagesControllerBulkUpdateComponentImages(id, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Component Id
         * @param {CreateImageDTO} createImageDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsImagesControllerCreateImageJob(id: string, createImageDTO: CreateImageDTO, options?: any): AxiosPromise<Component> {
            return localVarFp.componentsImagesControllerCreateImageJob(id, createImageDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} imageId Image Id
         * @param {string} id Component Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsImagesControllerDeleteComponentImage(imageId: string, id: string, options?: any): AxiosPromise<Component> {
            return localVarFp.componentsImagesControllerDeleteComponentImage(imageId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Component Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsImagesControllerGetImages(id: string, options?: any): AxiosPromise<TechpackImage> {
            return localVarFp.componentsImagesControllerGetImages(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Component Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsImagesControllerGetSourceFiles(id: string, options?: any): AxiosPromise<SourceFile> {
            return localVarFp.componentsImagesControllerGetSourceFiles(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} imageId Image Id
         * @param {string} id Component Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsImagesControllerSetDefaultComponentImage(imageId: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.componentsImagesControllerSetDefaultComponentImage(imageId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} imageId Image Id
         * @param {string} id Component Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        componentsImagesControllerUpdateComponentImage(imageId: string, id: string, options?: any): AxiosPromise<Image> {
            return localVarFp.componentsImagesControllerUpdateComponentImage(imageId, id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ComponentsImagesApi - object-oriented interface
 * @export
 * @class ComponentsImagesApi
 * @extends {BaseAPI}
 */
export class ComponentsImagesApi extends BaseAPI {
    /**
     * 
     * @param {string} id Component Id
     * @param {DeleteComponentImagesDTO} deleteComponentImagesDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsImagesApi
     */
    public componentsImagesControllerBulkDeleteComponentImages(id: string, deleteComponentImagesDTO: DeleteComponentImagesDTO, options?: AxiosRequestConfig) {
        return ComponentsImagesApiFp(this.configuration).componentsImagesControllerBulkDeleteComponentImages(id, deleteComponentImagesDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Component Id
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsImagesApi
     */
    public componentsImagesControllerBulkUpdateComponentImages(id: string, requestBody: Array<string>, options?: AxiosRequestConfig) {
        return ComponentsImagesApiFp(this.configuration).componentsImagesControllerBulkUpdateComponentImages(id, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Component Id
     * @param {CreateImageDTO} createImageDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsImagesApi
     */
    public componentsImagesControllerCreateImageJob(id: string, createImageDTO: CreateImageDTO, options?: AxiosRequestConfig) {
        return ComponentsImagesApiFp(this.configuration).componentsImagesControllerCreateImageJob(id, createImageDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} imageId Image Id
     * @param {string} id Component Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsImagesApi
     */
    public componentsImagesControllerDeleteComponentImage(imageId: string, id: string, options?: AxiosRequestConfig) {
        return ComponentsImagesApiFp(this.configuration).componentsImagesControllerDeleteComponentImage(imageId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Component Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsImagesApi
     */
    public componentsImagesControllerGetImages(id: string, options?: AxiosRequestConfig) {
        return ComponentsImagesApiFp(this.configuration).componentsImagesControllerGetImages(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Component Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsImagesApi
     */
    public componentsImagesControllerGetSourceFiles(id: string, options?: AxiosRequestConfig) {
        return ComponentsImagesApiFp(this.configuration).componentsImagesControllerGetSourceFiles(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} imageId Image Id
     * @param {string} id Component Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsImagesApi
     */
    public componentsImagesControllerSetDefaultComponentImage(imageId: string, id: string, options?: AxiosRequestConfig) {
        return ComponentsImagesApiFp(this.configuration).componentsImagesControllerSetDefaultComponentImage(imageId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} imageId Image Id
     * @param {string} id Component Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsImagesApi
     */
    public componentsImagesControllerUpdateComponentImage(imageId: string, id: string, options?: AxiosRequestConfig) {
        return ComponentsImagesApiFp(this.configuration).componentsImagesControllerUpdateComponentImage(imageId, id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ConstructionDetailApi - axios parameter creator
 * @export
 */
export const ConstructionDetailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateConstructionDetailDTO} createConstructionDetailDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        constructionDetailsControllerCreate: async (createConstructionDetailDTO: CreateConstructionDetailDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createConstructionDetailDTO' is not null or undefined
            assertParamExists('constructionDetailsControllerCreate', 'createConstructionDetailDTO', createConstructionDetailDTO)
            const localVarPath = `/construction-details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createConstructionDetailDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        constructionDetailsControllerFindAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/construction-details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        constructionDetailsControllerRemoveFromSearch: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('constructionDetailsControllerRemoveFromSearch', 'id', id)
            const localVarPath = `/construction-details/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConstructionDetailApi - functional programming interface
 * @export
 */
export const ConstructionDetailApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConstructionDetailApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateConstructionDetailDTO} createConstructionDetailDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async constructionDetailsControllerCreate(createConstructionDetailDTO: CreateConstructionDetailDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConstructionDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.constructionDetailsControllerCreate(createConstructionDetailDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async constructionDetailsControllerFindAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConstructionDetail>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.constructionDetailsControllerFindAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async constructionDetailsControllerRemoveFromSearch(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.constructionDetailsControllerRemoveFromSearch(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ConstructionDetailApi - factory interface
 * @export
 */
export const ConstructionDetailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConstructionDetailApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateConstructionDetailDTO} createConstructionDetailDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        constructionDetailsControllerCreate(createConstructionDetailDTO: CreateConstructionDetailDTO, options?: any): AxiosPromise<ConstructionDetail> {
            return localVarFp.constructionDetailsControllerCreate(createConstructionDetailDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        constructionDetailsControllerFindAll(options?: any): AxiosPromise<Array<ConstructionDetail>> {
            return localVarFp.constructionDetailsControllerFindAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        constructionDetailsControllerRemoveFromSearch(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.constructionDetailsControllerRemoveFromSearch(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConstructionDetailApi - object-oriented interface
 * @export
 * @class ConstructionDetailApi
 * @extends {BaseAPI}
 */
export class ConstructionDetailApi extends BaseAPI {
    /**
     * 
     * @param {CreateConstructionDetailDTO} createConstructionDetailDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConstructionDetailApi
     */
    public constructionDetailsControllerCreate(createConstructionDetailDTO: CreateConstructionDetailDTO, options?: AxiosRequestConfig) {
        return ConstructionDetailApiFp(this.configuration).constructionDetailsControllerCreate(createConstructionDetailDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConstructionDetailApi
     */
    public constructionDetailsControllerFindAll(options?: AxiosRequestConfig) {
        return ConstructionDetailApiFp(this.configuration).constructionDetailsControllerFindAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConstructionDetailApi
     */
    public constructionDetailsControllerRemoveFromSearch(id: string, options?: AxiosRequestConfig) {
        return ConstructionDetailApiFp(this.configuration).constructionDetailsControllerRemoveFromSearch(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ContactsApi - axios parameter creator
 * @export
 */
export const ContactsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateContactDTO} createContactDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactsControllerCreateNewContact: async (createContactDTO: CreateContactDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createContactDTO' is not null or undefined
            assertParamExists('contactsControllerCreateNewContact', 'createContactDTO', createContactDTO)
            const localVarPath = `/contacts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createContactDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactsControllerDeleteContact: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('contactsControllerDeleteContact', 'id', id)
            const localVarPath = `/contacts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactsControllerGetContactById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('contactsControllerGetContactById', 'id', id)
            const localVarPath = `/contacts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactsControllerGetContacts: async (email: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('contactsControllerGetContacts', 'email', email)
            const localVarPath = `/contacts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateContactDTO} updateContactDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactsControllerUpdateExistingContact: async (id: string, updateContactDTO: UpdateContactDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('contactsControllerUpdateExistingContact', 'id', id)
            // verify required parameter 'updateContactDTO' is not null or undefined
            assertParamExists('contactsControllerUpdateExistingContact', 'updateContactDTO', updateContactDTO)
            const localVarPath = `/contacts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateContactDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContactsApi - functional programming interface
 * @export
 */
export const ContactsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContactsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateContactDTO} createContactDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contactsControllerCreateNewContact(createContactDTO: CreateContactDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Contact>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contactsControllerCreateNewContact(createContactDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contactsControllerDeleteContact(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Contact>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contactsControllerDeleteContact(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contactsControllerGetContactById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Contact>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contactsControllerGetContactById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contactsControllerGetContacts(email: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Contact>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contactsControllerGetContacts(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateContactDTO} updateContactDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contactsControllerUpdateExistingContact(id: string, updateContactDTO: UpdateContactDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Contact>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contactsControllerUpdateExistingContact(id, updateContactDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ContactsApi - factory interface
 * @export
 */
export const ContactsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContactsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateContactDTO} createContactDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactsControllerCreateNewContact(createContactDTO: CreateContactDTO, options?: any): AxiosPromise<Contact> {
            return localVarFp.contactsControllerCreateNewContact(createContactDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactsControllerDeleteContact(id: string, options?: any): AxiosPromise<Contact> {
            return localVarFp.contactsControllerDeleteContact(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactsControllerGetContactById(id: string, options?: any): AxiosPromise<Array<Contact>> {
            return localVarFp.contactsControllerGetContactById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactsControllerGetContacts(email: string, options?: any): AxiosPromise<Array<Contact>> {
            return localVarFp.contactsControllerGetContacts(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateContactDTO} updateContactDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactsControllerUpdateExistingContact(id: string, updateContactDTO: UpdateContactDTO, options?: any): AxiosPromise<Contact> {
            return localVarFp.contactsControllerUpdateExistingContact(id, updateContactDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContactsApi - object-oriented interface
 * @export
 * @class ContactsApi
 * @extends {BaseAPI}
 */
export class ContactsApi extends BaseAPI {
    /**
     * 
     * @param {CreateContactDTO} createContactDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public contactsControllerCreateNewContact(createContactDTO: CreateContactDTO, options?: AxiosRequestConfig) {
        return ContactsApiFp(this.configuration).contactsControllerCreateNewContact(createContactDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public contactsControllerDeleteContact(id: string, options?: AxiosRequestConfig) {
        return ContactsApiFp(this.configuration).contactsControllerDeleteContact(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public contactsControllerGetContactById(id: string, options?: AxiosRequestConfig) {
        return ContactsApiFp(this.configuration).contactsControllerGetContactById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public contactsControllerGetContacts(email: string, options?: AxiosRequestConfig) {
        return ContactsApiFp(this.configuration).contactsControllerGetContacts(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateContactDTO} updateContactDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public contactsControllerUpdateExistingContact(id: string, updateContactDTO: UpdateContactDTO, options?: AxiosRequestConfig) {
        return ContactsApiFp(this.configuration).contactsControllerUpdateExistingContact(id, updateContactDTO, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CustomFieldDividersApi - axios parameter creator
 * @export
 */
export const CustomFieldDividersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldDividerControllerCreateCustomFieldDivider: async (body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('customFieldDividerControllerCreateCustomFieldDivider', 'body', body)
            const localVarPath = `/custom-field-dividers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldDividerControllerDeleteCustomFieldDivider: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customFieldDividerControllerDeleteCustomFieldDivider', 'id', id)
            const localVarPath = `/custom-field-dividers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldDividerControllerGetCustomFieldDivider: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customFieldDividerControllerGetCustomFieldDivider', 'id', id)
            const localVarPath = `/custom-field-dividers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldDividerControllerQueryCustomFieldDivider: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/custom-field-dividers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldDividerControllerUpdateCustomFieldDivider: async (id: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customFieldDividerControllerUpdateCustomFieldDivider', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('customFieldDividerControllerUpdateCustomFieldDivider', 'body', body)
            const localVarPath = `/custom-field-dividers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomFieldDividersApi - functional programming interface
 * @export
 */
export const CustomFieldDividersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomFieldDividersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customFieldDividerControllerCreateCustomFieldDivider(body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomFieldDivider>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customFieldDividerControllerCreateCustomFieldDivider(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customFieldDividerControllerDeleteCustomFieldDivider(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customFieldDividerControllerDeleteCustomFieldDivider(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customFieldDividerControllerGetCustomFieldDivider(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomFieldDivider>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customFieldDividerControllerGetCustomFieldDivider(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customFieldDividerControllerQueryCustomFieldDivider(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CustomFieldDivider>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customFieldDividerControllerQueryCustomFieldDivider(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customFieldDividerControllerUpdateCustomFieldDivider(id: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomFieldDivider>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customFieldDividerControllerUpdateCustomFieldDivider(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomFieldDividersApi - factory interface
 * @export
 */
export const CustomFieldDividersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomFieldDividersApiFp(configuration)
    return {
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldDividerControllerCreateCustomFieldDivider(body: object, options?: any): AxiosPromise<CustomFieldDivider> {
            return localVarFp.customFieldDividerControllerCreateCustomFieldDivider(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldDividerControllerDeleteCustomFieldDivider(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.customFieldDividerControllerDeleteCustomFieldDivider(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldDividerControllerGetCustomFieldDivider(id: string, options?: any): AxiosPromise<CustomFieldDivider> {
            return localVarFp.customFieldDividerControllerGetCustomFieldDivider(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldDividerControllerQueryCustomFieldDivider(options?: any): AxiosPromise<Array<CustomFieldDivider>> {
            return localVarFp.customFieldDividerControllerQueryCustomFieldDivider(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldDividerControllerUpdateCustomFieldDivider(id: string, body: object, options?: any): AxiosPromise<CustomFieldDivider> {
            return localVarFp.customFieldDividerControllerUpdateCustomFieldDivider(id, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomFieldDividersApi - object-oriented interface
 * @export
 * @class CustomFieldDividersApi
 * @extends {BaseAPI}
 */
export class CustomFieldDividersApi extends BaseAPI {
    /**
     * 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFieldDividersApi
     */
    public customFieldDividerControllerCreateCustomFieldDivider(body: object, options?: AxiosRequestConfig) {
        return CustomFieldDividersApiFp(this.configuration).customFieldDividerControllerCreateCustomFieldDivider(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFieldDividersApi
     */
    public customFieldDividerControllerDeleteCustomFieldDivider(id: string, options?: AxiosRequestConfig) {
        return CustomFieldDividersApiFp(this.configuration).customFieldDividerControllerDeleteCustomFieldDivider(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFieldDividersApi
     */
    public customFieldDividerControllerGetCustomFieldDivider(id: string, options?: AxiosRequestConfig) {
        return CustomFieldDividersApiFp(this.configuration).customFieldDividerControllerGetCustomFieldDivider(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFieldDividersApi
     */
    public customFieldDividerControllerQueryCustomFieldDivider(options?: AxiosRequestConfig) {
        return CustomFieldDividersApiFp(this.configuration).customFieldDividerControllerQueryCustomFieldDivider(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFieldDividersApi
     */
    public customFieldDividerControllerUpdateCustomFieldDivider(id: string, body: object, options?: AxiosRequestConfig) {
        return CustomFieldDividersApiFp(this.configuration).customFieldDividerControllerUpdateCustomFieldDivider(id, body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CustomFieldsApi - axios parameter creator
 * @export
 */
export const CustomFieldsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateCustomFieldDTO} createCustomFieldDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldControllerCreateCustomField: async (createCustomFieldDTO: CreateCustomFieldDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCustomFieldDTO' is not null or undefined
            assertParamExists('customFieldControllerCreateCustomField', 'createCustomFieldDTO', createCustomFieldDTO)
            const localVarPath = `/custom-fields`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCustomFieldDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldControllerDeleteCustomField: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customFieldControllerDeleteCustomField', 'id', id)
            const localVarPath = `/custom-fields/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldControllerGetCustomFields: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/custom-fields`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldControllerUpdateCustomField: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customFieldControllerUpdateCustomField', 'id', id)
            const localVarPath = `/custom-fields/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldControllerUpdatePositions: async (requestBody: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('customFieldControllerUpdatePositions', 'requestBody', requestBody)
            const localVarPath = `/custom-fields/update-positions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomFieldsApi - functional programming interface
 * @export
 */
export const CustomFieldsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomFieldsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateCustomFieldDTO} createCustomFieldDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customFieldControllerCreateCustomField(createCustomFieldDTO: CreateCustomFieldDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomField>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customFieldControllerCreateCustomField(createCustomFieldDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customFieldControllerDeleteCustomField(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomField>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customFieldControllerDeleteCustomField(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customFieldControllerGetCustomFields(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomField>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customFieldControllerGetCustomFields(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customFieldControllerUpdateCustomField(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomField>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customFieldControllerUpdateCustomField(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customFieldControllerUpdatePositions(requestBody: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomField>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customFieldControllerUpdatePositions(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomFieldsApi - factory interface
 * @export
 */
export const CustomFieldsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomFieldsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateCustomFieldDTO} createCustomFieldDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldControllerCreateCustomField(createCustomFieldDTO: CreateCustomFieldDTO, options?: any): AxiosPromise<CustomField> {
            return localVarFp.customFieldControllerCreateCustomField(createCustomFieldDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldControllerDeleteCustomField(id: string, options?: any): AxiosPromise<CustomField> {
            return localVarFp.customFieldControllerDeleteCustomField(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldControllerGetCustomFields(options?: any): AxiosPromise<CustomField> {
            return localVarFp.customFieldControllerGetCustomFields(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldControllerUpdateCustomField(id: string, options?: any): AxiosPromise<CustomField> {
            return localVarFp.customFieldControllerUpdateCustomField(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldControllerUpdatePositions(requestBody: Array<string>, options?: any): AxiosPromise<CustomField> {
            return localVarFp.customFieldControllerUpdatePositions(requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomFieldsApi - object-oriented interface
 * @export
 * @class CustomFieldsApi
 * @extends {BaseAPI}
 */
export class CustomFieldsApi extends BaseAPI {
    /**
     * 
     * @param {CreateCustomFieldDTO} createCustomFieldDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFieldsApi
     */
    public customFieldControllerCreateCustomField(createCustomFieldDTO: CreateCustomFieldDTO, options?: AxiosRequestConfig) {
        return CustomFieldsApiFp(this.configuration).customFieldControllerCreateCustomField(createCustomFieldDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFieldsApi
     */
    public customFieldControllerDeleteCustomField(id: string, options?: AxiosRequestConfig) {
        return CustomFieldsApiFp(this.configuration).customFieldControllerDeleteCustomField(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFieldsApi
     */
    public customFieldControllerGetCustomFields(options?: AxiosRequestConfig) {
        return CustomFieldsApiFp(this.configuration).customFieldControllerGetCustomFields(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFieldsApi
     */
    public customFieldControllerUpdateCustomField(id: string, options?: AxiosRequestConfig) {
        return CustomFieldsApiFp(this.configuration).customFieldControllerUpdateCustomField(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFieldsApi
     */
    public customFieldControllerUpdatePositions(requestBody: Array<string>, options?: AxiosRequestConfig) {
        return CustomFieldsApiFp(this.configuration).customFieldControllerUpdatePositions(requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminImportControllerColumnNames: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/import/column-names`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminImportControllerExecute: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/import/execute`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminImportControllerImport: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/import/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auth0ControllerUpdate: async (body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('auth0ControllerUpdate', 'body', body)
            const localVarPath = `/auth0/obtain-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminImportControllerColumnNames(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminImportControllerColumnNames(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminImportControllerExecute(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminImportControllerExecute(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminImportControllerImport(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminImportControllerImport(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async auth0ControllerUpdate(body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.auth0ControllerUpdate(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminImportControllerColumnNames(options?: any): AxiosPromise<void> {
            return localVarFp.adminImportControllerColumnNames(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminImportControllerExecute(options?: any): AxiosPromise<void> {
            return localVarFp.adminImportControllerExecute(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminImportControllerImport(options?: any): AxiosPromise<void> {
            return localVarFp.adminImportControllerImport(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auth0ControllerUpdate(body: object, options?: any): AxiosPromise<void> {
            return localVarFp.auth0ControllerUpdate(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public adminImportControllerColumnNames(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).adminImportControllerColumnNames(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public adminImportControllerExecute(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).adminImportControllerExecute(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public adminImportControllerImport(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).adminImportControllerImport(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public auth0ControllerUpdate(body: object, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).auth0ControllerUpdate(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DivisionsApi - axios parameter creator
 * @export
 */
export const DivisionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        divisionsControllerQueryDivisions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/divisions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DivisionsApi - functional programming interface
 * @export
 */
export const DivisionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DivisionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async divisionsControllerQueryDivisions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Division>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.divisionsControllerQueryDivisions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DivisionsApi - factory interface
 * @export
 */
export const DivisionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DivisionsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        divisionsControllerQueryDivisions(options?: any): AxiosPromise<Array<Division>> {
            return localVarFp.divisionsControllerQueryDivisions(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DivisionsApi - object-oriented interface
 * @export
 * @class DivisionsApi
 * @extends {BaseAPI}
 */
export class DivisionsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivisionsApi
     */
    public divisionsControllerQueryDivisions(options?: AxiosRequestConfig) {
        return DivisionsApiFp(this.configuration).divisionsControllerQueryDivisions(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * HealthApi - axios parameter creator
 * @export
 */
export const HealthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckControllerHealthCheck: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health-check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthApi - functional programming interface
 * @export
 */
export const HealthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HealthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthCheckControllerHealthCheck(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HealthCheckDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheckControllerHealthCheck(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HealthApi - factory interface
 * @export
 */
export const HealthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HealthApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckControllerHealthCheck(options?: any): AxiosPromise<HealthCheckDTO> {
            return localVarFp.healthCheckControllerHealthCheck(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HealthApi - object-oriented interface
 * @export
 * @class HealthApi
 * @extends {BaseAPI}
 */
export class HealthApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    public healthCheckControllerHealthCheck(options?: AxiosRequestConfig) {
        return HealthApiFp(this.configuration).healthCheckControllerHealthCheck(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ImageSectionsApi - axios parameter creator
 * @export
 */
export const ImageSectionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageSectionsControllerRemoveTechpackImageSection: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('imageSectionsControllerRemoveTechpackImageSection', 'id', id)
            const localVarPath = `/image-sections/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImageSectionsApi - functional programming interface
 * @export
 */
export const ImageSectionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ImageSectionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async imageSectionsControllerRemoveTechpackImageSection(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.imageSectionsControllerRemoveTechpackImageSection(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ImageSectionsApi - factory interface
 * @export
 */
export const ImageSectionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ImageSectionsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageSectionsControllerRemoveTechpackImageSection(id: string, options?: any): AxiosPromise<Company> {
            return localVarFp.imageSectionsControllerRemoveTechpackImageSection(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ImageSectionsApi - object-oriented interface
 * @export
 * @class ImageSectionsApi
 * @extends {BaseAPI}
 */
export class ImageSectionsApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImageSectionsApi
     */
    public imageSectionsControllerRemoveTechpackImageSection(id: string, options?: AxiosRequestConfig) {
        return ImageSectionsApiFp(this.configuration).imageSectionsControllerRemoveTechpackImageSection(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ImagesApi - axios parameter creator
 * @export
 */
export const ImagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imagesControllerCopyAnnotations: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/images/copy-annotations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Image Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imagesControllerCopyImage: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('imagesControllerCopyImage', 'id', id)
            const localVarPath = `/images/{id}/copy`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ConvertImageDTO} convertImageDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imagesControllerGetImageUrls: async (convertImageDTO: ConvertImageDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'convertImageDTO' is not null or undefined
            assertParamExists('imagesControllerGetImageUrls', 'convertImageDTO', convertImageDTO)
            const localVarPath = `/images/converted-urls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(convertImageDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imagesControllerGetResizeUrl: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/images/resize-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Image Id
         * @param {PatchImageDto} patchImageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imagesControllerPatchImage: async (id: string, patchImageDto: PatchImageDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('imagesControllerPatchImage', 'id', id)
            // verify required parameter 'patchImageDto' is not null or undefined
            assertParamExists('imagesControllerPatchImage', 'patchImageDto', patchImageDto)
            const localVarPath = `/images/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchImageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImagesApi - functional programming interface
 * @export
 */
export const ImagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ImagesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async imagesControllerCopyAnnotations(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.imagesControllerCopyAnnotations(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id Image Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async imagesControllerCopyImage(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Job>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.imagesControllerCopyImage(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ConvertImageDTO} convertImageDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async imagesControllerGetImageUrls(convertImageDTO: ConvertImageDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Job>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.imagesControllerGetImageUrls(convertImageDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async imagesControllerGetResizeUrl(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Job>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.imagesControllerGetResizeUrl(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id Image Id
         * @param {PatchImageDto} patchImageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async imagesControllerPatchImage(id: string, patchImageDto: PatchImageDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Image>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.imagesControllerPatchImage(id, patchImageDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ImagesApi - factory interface
 * @export
 */
export const ImagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ImagesApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imagesControllerCopyAnnotations(options?: any): AxiosPromise<void> {
            return localVarFp.imagesControllerCopyAnnotations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Image Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imagesControllerCopyImage(id: string, options?: any): AxiosPromise<Job> {
            return localVarFp.imagesControllerCopyImage(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ConvertImageDTO} convertImageDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imagesControllerGetImageUrls(convertImageDTO: ConvertImageDTO, options?: any): AxiosPromise<Job> {
            return localVarFp.imagesControllerGetImageUrls(convertImageDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imagesControllerGetResizeUrl(options?: any): AxiosPromise<Job> {
            return localVarFp.imagesControllerGetResizeUrl(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Image Id
         * @param {PatchImageDto} patchImageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imagesControllerPatchImage(id: string, patchImageDto: PatchImageDto, options?: any): AxiosPromise<Image> {
            return localVarFp.imagesControllerPatchImage(id, patchImageDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ImagesApi - object-oriented interface
 * @export
 * @class ImagesApi
 * @extends {BaseAPI}
 */
export class ImagesApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImagesApi
     */
    public imagesControllerCopyAnnotations(options?: AxiosRequestConfig) {
        return ImagesApiFp(this.configuration).imagesControllerCopyAnnotations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Image Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImagesApi
     */
    public imagesControllerCopyImage(id: string, options?: AxiosRequestConfig) {
        return ImagesApiFp(this.configuration).imagesControllerCopyImage(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ConvertImageDTO} convertImageDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImagesApi
     */
    public imagesControllerGetImageUrls(convertImageDTO: ConvertImageDTO, options?: AxiosRequestConfig) {
        return ImagesApiFp(this.configuration).imagesControllerGetImageUrls(convertImageDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImagesApi
     */
    public imagesControllerGetResizeUrl(options?: AxiosRequestConfig) {
        return ImagesApiFp(this.configuration).imagesControllerGetResizeUrl(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Image Id
     * @param {PatchImageDto} patchImageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImagesApi
     */
    public imagesControllerPatchImage(id: string, patchImageDto: PatchImageDto, options?: AxiosRequestConfig) {
        return ImagesApiFp(this.configuration).imagesControllerPatchImage(id, patchImageDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ItemViewsReportsApi - axios parameter creator
 * @export
 */
export const ItemViewsReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemViewControllerCopy: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('itemViewControllerCopy', 'id', id)
            const localVarPath = `/item-views-reports/{id}/copy`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemViewControllerCreateItemView: async (body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('itemViewControllerCreateItemView', 'body', body)
            const localVarPath = `/item-views-reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemViewControllerDeleteItemView: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('itemViewControllerDeleteItemView', 'id', id)
            const localVarPath = `/item-views-reports/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemViewControllerGetItemView: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('itemViewControllerGetItemView', 'id', id)
            const localVarPath = `/item-views-reports/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemViewControllerQueryItemView: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/item-views-reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemViewControllerUpdateItemView: async (id: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('itemViewControllerUpdateItemView', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('itemViewControllerUpdateItemView', 'body', body)
            const localVarPath = `/item-views-reports/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ItemViewsReportsApi - functional programming interface
 * @export
 */
export const ItemViewsReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ItemViewsReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async itemViewControllerCopy(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.itemViewControllerCopy(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async itemViewControllerCreateItemView(body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ItemViewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.itemViewControllerCreateItemView(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async itemViewControllerDeleteItemView(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.itemViewControllerDeleteItemView(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async itemViewControllerGetItemView(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ItemViewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.itemViewControllerGetItemView(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async itemViewControllerQueryItemView(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ItemViewDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.itemViewControllerQueryItemView(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async itemViewControllerUpdateItemView(id: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ItemViewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.itemViewControllerUpdateItemView(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ItemViewsReportsApi - factory interface
 * @export
 */
export const ItemViewsReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ItemViewsReportsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemViewControllerCopy(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.itemViewControllerCopy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemViewControllerCreateItemView(body: object, options?: any): AxiosPromise<ItemViewDTO> {
            return localVarFp.itemViewControllerCreateItemView(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemViewControllerDeleteItemView(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.itemViewControllerDeleteItemView(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemViewControllerGetItemView(id: string, options?: any): AxiosPromise<ItemViewDTO> {
            return localVarFp.itemViewControllerGetItemView(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemViewControllerQueryItemView(options?: any): AxiosPromise<Array<ItemViewDTO>> {
            return localVarFp.itemViewControllerQueryItemView(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemViewControllerUpdateItemView(id: string, body: object, options?: any): AxiosPromise<ItemViewDTO> {
            return localVarFp.itemViewControllerUpdateItemView(id, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ItemViewsReportsApi - object-oriented interface
 * @export
 * @class ItemViewsReportsApi
 * @extends {BaseAPI}
 */
export class ItemViewsReportsApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemViewsReportsApi
     */
    public itemViewControllerCopy(id: string, options?: AxiosRequestConfig) {
        return ItemViewsReportsApiFp(this.configuration).itemViewControllerCopy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemViewsReportsApi
     */
    public itemViewControllerCreateItemView(body: object, options?: AxiosRequestConfig) {
        return ItemViewsReportsApiFp(this.configuration).itemViewControllerCreateItemView(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemViewsReportsApi
     */
    public itemViewControllerDeleteItemView(id: string, options?: AxiosRequestConfig) {
        return ItemViewsReportsApiFp(this.configuration).itemViewControllerDeleteItemView(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemViewsReportsApi
     */
    public itemViewControllerGetItemView(id: string, options?: AxiosRequestConfig) {
        return ItemViewsReportsApiFp(this.configuration).itemViewControllerGetItemView(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemViewsReportsApi
     */
    public itemViewControllerQueryItemView(options?: AxiosRequestConfig) {
        return ItemViewsReportsApiFp(this.configuration).itemViewControllerQueryItemView(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemViewsReportsApi
     */
    public itemViewControllerUpdateItemView(id: string, body: object, options?: AxiosRequestConfig) {
        return ItemViewsReportsApiFp(this.configuration).itemViewControllerUpdateItemView(id, body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ItemViewsReportsIdComponentsApi - axios parameter creator
 * @export
 */
export const ItemViewsReportsIdComponentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} limit 
         * @param {string} sort 
         * @param {string} detail 
         * @param {string} accept 
         * @param {string} id 
         * @param {Array<string>} [division] 
         * @param {Array<string>} [season] 
         * @param {Array<string>} [year] 
         * @param {Array<string>} [brand] 
         * @param {Array<string>} [customFields] 
         * @param {boolean} [canceled] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {Array<string>} [category] 
         * @param {Array<string>} [componentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemViewComponentControllerQueryItemViewComponents: async (limit: number, sort: string, detail: string, accept: string, id: string, division?: Array<string>, season?: Array<string>, year?: Array<string>, brand?: Array<string>, customFields?: Array<string>, canceled?: boolean, updatedAtStart?: string, updatedAtEnd?: string, category?: Array<string>, componentType?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('itemViewComponentControllerQueryItemViewComponents', 'limit', limit)
            // verify required parameter 'sort' is not null or undefined
            assertParamExists('itemViewComponentControllerQueryItemViewComponents', 'sort', sort)
            // verify required parameter 'detail' is not null or undefined
            assertParamExists('itemViewComponentControllerQueryItemViewComponents', 'detail', detail)
            // verify required parameter 'accept' is not null or undefined
            assertParamExists('itemViewComponentControllerQueryItemViewComponents', 'accept', accept)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('itemViewComponentControllerQueryItemViewComponents', 'id', id)
            const localVarPath = `/item-views-reports/{id}/components`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (division) {
                localVarQueryParameter['division'] = division;
            }

            if (season) {
                localVarQueryParameter['season'] = season;
            }

            if (year) {
                localVarQueryParameter['year'] = year;
            }

            if (brand) {
                localVarQueryParameter['brand'] = brand;
            }

            if (customFields) {
                localVarQueryParameter['custom_fields'] = customFields;
            }

            if (canceled !== undefined) {
                localVarQueryParameter['canceled'] = canceled;
            }

            if (updatedAtStart !== undefined) {
                localVarQueryParameter['updatedAtStart'] = (updatedAtStart as any instanceof Date) ?
                    (updatedAtStart as any).toISOString() :
                    updatedAtStart;
            }

            if (updatedAtEnd !== undefined) {
                localVarQueryParameter['updatedAtEnd'] = (updatedAtEnd as any instanceof Date) ?
                    (updatedAtEnd as any).toISOString() :
                    updatedAtEnd;
            }

            if (category) {
                localVarQueryParameter['category'] = category;
            }

            if (componentType) {
                localVarQueryParameter['component_type'] = componentType;
            }

            if (detail !== undefined) {
                localVarQueryParameter['detail'] = detail;
            }

            if (accept != null) {
                localVarHeaderParameter['accept'] = String(accept);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ItemViewsReportsIdComponentsApi - functional programming interface
 * @export
 */
export const ItemViewsReportsIdComponentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ItemViewsReportsIdComponentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} limit 
         * @param {string} sort 
         * @param {string} detail 
         * @param {string} accept 
         * @param {string} id 
         * @param {Array<string>} [division] 
         * @param {Array<string>} [season] 
         * @param {Array<string>} [year] 
         * @param {Array<string>} [brand] 
         * @param {Array<string>} [customFields] 
         * @param {boolean} [canceled] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {Array<string>} [category] 
         * @param {Array<string>} [componentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async itemViewComponentControllerQueryItemViewComponents(limit: number, sort: string, detail: string, accept: string, id: string, division?: Array<string>, season?: Array<string>, year?: Array<string>, brand?: Array<string>, customFields?: Array<string>, canceled?: boolean, updatedAtStart?: string, updatedAtEnd?: string, category?: Array<string>, componentType?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Component>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.itemViewComponentControllerQueryItemViewComponents(limit, sort, detail, accept, id, division, season, year, brand, customFields, canceled, updatedAtStart, updatedAtEnd, category, componentType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ItemViewsReportsIdComponentsApi - factory interface
 * @export
 */
export const ItemViewsReportsIdComponentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ItemViewsReportsIdComponentsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} limit 
         * @param {string} sort 
         * @param {string} detail 
         * @param {string} accept 
         * @param {string} id 
         * @param {Array<string>} [division] 
         * @param {Array<string>} [season] 
         * @param {Array<string>} [year] 
         * @param {Array<string>} [brand] 
         * @param {Array<string>} [customFields] 
         * @param {boolean} [canceled] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {Array<string>} [category] 
         * @param {Array<string>} [componentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemViewComponentControllerQueryItemViewComponents(limit: number, sort: string, detail: string, accept: string, id: string, division?: Array<string>, season?: Array<string>, year?: Array<string>, brand?: Array<string>, customFields?: Array<string>, canceled?: boolean, updatedAtStart?: string, updatedAtEnd?: string, category?: Array<string>, componentType?: Array<string>, options?: any): AxiosPromise<Array<Component>> {
            return localVarFp.itemViewComponentControllerQueryItemViewComponents(limit, sort, detail, accept, id, division, season, year, brand, customFields, canceled, updatedAtStart, updatedAtEnd, category, componentType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ItemViewsReportsIdComponentsApi - object-oriented interface
 * @export
 * @class ItemViewsReportsIdComponentsApi
 * @extends {BaseAPI}
 */
export class ItemViewsReportsIdComponentsApi extends BaseAPI {
    /**
     * 
     * @param {number} limit 
     * @param {string} sort 
     * @param {string} detail 
     * @param {string} accept 
     * @param {string} id 
     * @param {Array<string>} [division] 
     * @param {Array<string>} [season] 
     * @param {Array<string>} [year] 
     * @param {Array<string>} [brand] 
     * @param {Array<string>} [customFields] 
     * @param {boolean} [canceled] 
     * @param {string} [updatedAtStart] 
     * @param {string} [updatedAtEnd] 
     * @param {Array<string>} [category] 
     * @param {Array<string>} [componentType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemViewsReportsIdComponentsApi
     */
    public itemViewComponentControllerQueryItemViewComponents(limit: number, sort: string, detail: string, accept: string, id: string, division?: Array<string>, season?: Array<string>, year?: Array<string>, brand?: Array<string>, customFields?: Array<string>, canceled?: boolean, updatedAtStart?: string, updatedAtEnd?: string, category?: Array<string>, componentType?: Array<string>, options?: AxiosRequestConfig) {
        return ItemViewsReportsIdComponentsApiFp(this.configuration).itemViewComponentControllerQueryItemViewComponents(limit, sort, detail, accept, id, division, season, year, brand, customFields, canceled, updatedAtStart, updatedAtEnd, category, componentType, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ItemViewsReportsIdProductsApi - axios parameter creator
 * @export
 */
export const ItemViewsReportsIdProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} limit 
         * @param {string} sort 
         * @param {string} detail 
         * @param {string} accept 
         * @param {string} id 
         * @param {Array<string>} [division] 
         * @param {Array<string>} [season] 
         * @param {Array<string>} [year] 
         * @param {Array<string>} [brand] 
         * @param {Array<string>} [customFields] 
         * @param {boolean} [canceled] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {Array<string>} [category] 
         * @param {Array<string>} [componentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemViewProductControllerQueryItemViewProducts: async (limit: number, sort: string, detail: string, accept: string, id: string, division?: Array<string>, season?: Array<string>, year?: Array<string>, brand?: Array<string>, customFields?: Array<string>, canceled?: boolean, updatedAtStart?: string, updatedAtEnd?: string, category?: Array<string>, componentType?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('itemViewProductControllerQueryItemViewProducts', 'limit', limit)
            // verify required parameter 'sort' is not null or undefined
            assertParamExists('itemViewProductControllerQueryItemViewProducts', 'sort', sort)
            // verify required parameter 'detail' is not null or undefined
            assertParamExists('itemViewProductControllerQueryItemViewProducts', 'detail', detail)
            // verify required parameter 'accept' is not null or undefined
            assertParamExists('itemViewProductControllerQueryItemViewProducts', 'accept', accept)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('itemViewProductControllerQueryItemViewProducts', 'id', id)
            const localVarPath = `/item-views-reports/{id}/products`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (division) {
                localVarQueryParameter['division'] = division;
            }

            if (season) {
                localVarQueryParameter['season'] = season;
            }

            if (year) {
                localVarQueryParameter['year'] = year;
            }

            if (brand) {
                localVarQueryParameter['brand'] = brand;
            }

            if (customFields) {
                localVarQueryParameter['custom_fields'] = customFields;
            }

            if (canceled !== undefined) {
                localVarQueryParameter['canceled'] = canceled;
            }

            if (updatedAtStart !== undefined) {
                localVarQueryParameter['updatedAtStart'] = (updatedAtStart as any instanceof Date) ?
                    (updatedAtStart as any).toISOString() :
                    updatedAtStart;
            }

            if (updatedAtEnd !== undefined) {
                localVarQueryParameter['updatedAtEnd'] = (updatedAtEnd as any instanceof Date) ?
                    (updatedAtEnd as any).toISOString() :
                    updatedAtEnd;
            }

            if (category) {
                localVarQueryParameter['category'] = category;
            }

            if (componentType) {
                localVarQueryParameter['component_type'] = componentType;
            }

            if (detail !== undefined) {
                localVarQueryParameter['detail'] = detail;
            }

            if (accept != null) {
                localVarHeaderParameter['accept'] = String(accept);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ItemViewsReportsIdProductsApi - functional programming interface
 * @export
 */
export const ItemViewsReportsIdProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ItemViewsReportsIdProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} limit 
         * @param {string} sort 
         * @param {string} detail 
         * @param {string} accept 
         * @param {string} id 
         * @param {Array<string>} [division] 
         * @param {Array<string>} [season] 
         * @param {Array<string>} [year] 
         * @param {Array<string>} [brand] 
         * @param {Array<string>} [customFields] 
         * @param {boolean} [canceled] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {Array<string>} [category] 
         * @param {Array<string>} [componentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async itemViewProductControllerQueryItemViewProducts(limit: number, sort: string, detail: string, accept: string, id: string, division?: Array<string>, season?: Array<string>, year?: Array<string>, brand?: Array<string>, customFields?: Array<string>, canceled?: boolean, updatedAtStart?: string, updatedAtEnd?: string, category?: Array<string>, componentType?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Product>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.itemViewProductControllerQueryItemViewProducts(limit, sort, detail, accept, id, division, season, year, brand, customFields, canceled, updatedAtStart, updatedAtEnd, category, componentType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ItemViewsReportsIdProductsApi - factory interface
 * @export
 */
export const ItemViewsReportsIdProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ItemViewsReportsIdProductsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} limit 
         * @param {string} sort 
         * @param {string} detail 
         * @param {string} accept 
         * @param {string} id 
         * @param {Array<string>} [division] 
         * @param {Array<string>} [season] 
         * @param {Array<string>} [year] 
         * @param {Array<string>} [brand] 
         * @param {Array<string>} [customFields] 
         * @param {boolean} [canceled] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {Array<string>} [category] 
         * @param {Array<string>} [componentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemViewProductControllerQueryItemViewProducts(limit: number, sort: string, detail: string, accept: string, id: string, division?: Array<string>, season?: Array<string>, year?: Array<string>, brand?: Array<string>, customFields?: Array<string>, canceled?: boolean, updatedAtStart?: string, updatedAtEnd?: string, category?: Array<string>, componentType?: Array<string>, options?: any): AxiosPromise<Array<Product>> {
            return localVarFp.itemViewProductControllerQueryItemViewProducts(limit, sort, detail, accept, id, division, season, year, brand, customFields, canceled, updatedAtStart, updatedAtEnd, category, componentType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ItemViewsReportsIdProductsApi - object-oriented interface
 * @export
 * @class ItemViewsReportsIdProductsApi
 * @extends {BaseAPI}
 */
export class ItemViewsReportsIdProductsApi extends BaseAPI {
    /**
     * 
     * @param {number} limit 
     * @param {string} sort 
     * @param {string} detail 
     * @param {string} accept 
     * @param {string} id 
     * @param {Array<string>} [division] 
     * @param {Array<string>} [season] 
     * @param {Array<string>} [year] 
     * @param {Array<string>} [brand] 
     * @param {Array<string>} [customFields] 
     * @param {boolean} [canceled] 
     * @param {string} [updatedAtStart] 
     * @param {string} [updatedAtEnd] 
     * @param {Array<string>} [category] 
     * @param {Array<string>} [componentType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemViewsReportsIdProductsApi
     */
    public itemViewProductControllerQueryItemViewProducts(limit: number, sort: string, detail: string, accept: string, id: string, division?: Array<string>, season?: Array<string>, year?: Array<string>, brand?: Array<string>, customFields?: Array<string>, canceled?: boolean, updatedAtStart?: string, updatedAtEnd?: string, category?: Array<string>, componentType?: Array<string>, options?: AxiosRequestConfig) {
        return ItemViewsReportsIdProductsApiFp(this.configuration).itemViewProductControllerQueryItemViewProducts(limit, sort, detail, accept, id, division, season, year, brand, customFields, canceled, updatedAtStart, updatedAtEnd, category, componentType, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ItemViewsReportsIdSharesApi - axios parameter creator
 * @export
 */
export const ItemViewsReportsIdSharesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemViewSharesControllerCreateItemViewShare: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('itemViewSharesControllerCreateItemViewShare', 'id', id)
            const localVarPath = `/item-views-reports/{id}/shares`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemViewSharesControllerDeleteItemViewShare: async (userId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('itemViewSharesControllerDeleteItemViewShare', 'userId', userId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('itemViewSharesControllerDeleteItemViewShare', 'id', id)
            const localVarPath = `/item-views-reports/{id}/shares/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemViewSharesControllerGetItemViewShares: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('itemViewSharesControllerGetItemViewShares', 'id', id)
            const localVarPath = `/item-views-reports/{id}/shares`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ItemViewsReportsIdSharesApi - functional programming interface
 * @export
 */
export const ItemViewsReportsIdSharesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ItemViewsReportsIdSharesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async itemViewSharesControllerCreateItemViewShare(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.itemViewSharesControllerCreateItemViewShare(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async itemViewSharesControllerDeleteItemViewShare(userId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.itemViewSharesControllerDeleteItemViewShare(userId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async itemViewSharesControllerGetItemViewShares(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.itemViewSharesControllerGetItemViewShares(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ItemViewsReportsIdSharesApi - factory interface
 * @export
 */
export const ItemViewsReportsIdSharesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ItemViewsReportsIdSharesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemViewSharesControllerCreateItemViewShare(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.itemViewSharesControllerCreateItemViewShare(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemViewSharesControllerDeleteItemViewShare(userId: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.itemViewSharesControllerDeleteItemViewShare(userId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemViewSharesControllerGetItemViewShares(id: string, options?: any): AxiosPromise<Array<object>> {
            return localVarFp.itemViewSharesControllerGetItemViewShares(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ItemViewsReportsIdSharesApi - object-oriented interface
 * @export
 * @class ItemViewsReportsIdSharesApi
 * @extends {BaseAPI}
 */
export class ItemViewsReportsIdSharesApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemViewsReportsIdSharesApi
     */
    public itemViewSharesControllerCreateItemViewShare(id: string, options?: AxiosRequestConfig) {
        return ItemViewsReportsIdSharesApiFp(this.configuration).itemViewSharesControllerCreateItemViewShare(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemViewsReportsIdSharesApi
     */
    public itemViewSharesControllerDeleteItemViewShare(userId: string, id: string, options?: AxiosRequestConfig) {
        return ItemViewsReportsIdSharesApiFp(this.configuration).itemViewSharesControllerDeleteItemViewShare(userId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemViewsReportsIdSharesApi
     */
    public itemViewSharesControllerGetItemViewShares(id: string, options?: AxiosRequestConfig) {
        return ItemViewsReportsIdSharesApiFp(this.configuration).itemViewSharesControllerGetItemViewShares(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ItemViewsReportsIdSortPreferencesApi - axios parameter creator
 * @export
 */
export const ItemViewsReportsIdSortPreferencesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemViewSortPreferenceControllerCreateSortPreference: async (id: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('itemViewSortPreferenceControllerCreateSortPreference', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('itemViewSortPreferenceControllerCreateSortPreference', 'body', body)
            const localVarPath = `/item-views-reports/{id}/sort-preferences`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemViewSortPreferenceControllerQuerySortPreference: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('itemViewSortPreferenceControllerQuerySortPreference', 'id', id)
            const localVarPath = `/item-views-reports/{id}/sort-preferences`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ItemViewsReportsIdSortPreferencesApi - functional programming interface
 * @export
 */
export const ItemViewsReportsIdSortPreferencesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ItemViewsReportsIdSortPreferencesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async itemViewSortPreferenceControllerCreateSortPreference(id: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.itemViewSortPreferenceControllerCreateSortPreference(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async itemViewSortPreferenceControllerQuerySortPreference(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ItemMasterSortPreference>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.itemViewSortPreferenceControllerQuerySortPreference(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ItemViewsReportsIdSortPreferencesApi - factory interface
 * @export
 */
export const ItemViewsReportsIdSortPreferencesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ItemViewsReportsIdSortPreferencesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemViewSortPreferenceControllerCreateSortPreference(id: string, body: object, options?: any): AxiosPromise<object> {
            return localVarFp.itemViewSortPreferenceControllerCreateSortPreference(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemViewSortPreferenceControllerQuerySortPreference(id: string, options?: any): AxiosPromise<ItemMasterSortPreference> {
            return localVarFp.itemViewSortPreferenceControllerQuerySortPreference(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ItemViewsReportsIdSortPreferencesApi - object-oriented interface
 * @export
 * @class ItemViewsReportsIdSortPreferencesApi
 * @extends {BaseAPI}
 */
export class ItemViewsReportsIdSortPreferencesApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemViewsReportsIdSortPreferencesApi
     */
    public itemViewSortPreferenceControllerCreateSortPreference(id: string, body: object, options?: AxiosRequestConfig) {
        return ItemViewsReportsIdSortPreferencesApiFp(this.configuration).itemViewSortPreferenceControllerCreateSortPreference(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemViewsReportsIdSortPreferencesApi
     */
    public itemViewSortPreferenceControllerQuerySortPreference(id: string, options?: AxiosRequestConfig) {
        return ItemViewsReportsIdSortPreferencesApiFp(this.configuration).itemViewSortPreferenceControllerQuerySortPreference(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * JobsApi - axios parameter creator
 * @export
 */
export const JobsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobsControllerGetJobDocument: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('jobsControllerGetJobDocument', 'id', id)
            const localVarPath = `/jobs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JobsApi - functional programming interface
 * @export
 */
export const JobsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JobsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobsControllerGetJobDocument(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobsControllerGetJobDocument(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * JobsApi - factory interface
 * @export
 */
export const JobsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JobsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobsControllerGetJobDocument(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.jobsControllerGetJobDocument(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * JobsApi - object-oriented interface
 * @export
 * @class JobsApi
 * @extends {BaseAPI}
 */
export class JobsApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public jobsControllerGetJobDocument(id: string, options?: AxiosRequestConfig) {
        return JobsApiFp(this.configuration).jobsControllerGetJobDocument(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LineSheetsApi - axios parameter creator
 * @export
 */
export const LineSheetsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lineSheetsControllerCopyLineSheet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('lineSheetsControllerCopyLineSheet', 'id', id)
            const localVarPath = `/line-sheets/{id}/copy`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateLineSheetDTO} createLineSheetDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lineSheetsControllerCreateLineSheet: async (createLineSheetDTO: CreateLineSheetDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createLineSheetDTO' is not null or undefined
            assertParamExists('lineSheetsControllerCreateLineSheet', 'createLineSheetDTO', createLineSheetDTO)
            const localVarPath = `/line-sheets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLineSheetDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [searchString] 
         * @param {'colorwayView' | 'productViewCondensed' | 'productViewExpanded'} [layout] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lineSheetsControllerGenerateLineSheetReport: async (id: string, searchString?: string, layout?: 'colorwayView' | 'productViewCondensed' | 'productViewExpanded', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('lineSheetsControllerGenerateLineSheetReport', 'id', id)
            const localVarPath = `/line-sheets/{id}/pdf`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (layout !== undefined) {
                localVarQueryParameter['layout'] = layout;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lineSheetsControllerGetLineSheet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('lineSheetsControllerGetLineSheet', 'id', id)
            const localVarPath = `/line-sheets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [searchString] 
         * @param {'colorwayView' | 'productViewCondensed' | 'productViewExpanded'} [layout] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lineSheetsControllerGetLineSheetProducts: async (id: string, searchString?: string, layout?: 'colorwayView' | 'productViewCondensed' | 'productViewExpanded', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('lineSheetsControllerGetLineSheetProducts', 'id', id)
            const localVarPath = `/line-sheets/{id}/products`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (layout !== undefined) {
                localVarQueryParameter['layout'] = layout;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lineSheetsControllerGetLineSheets: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/line-sheets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateLineSheetDTO} updateLineSheetDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lineSheetsControllerUpdateLineSheet: async (id: string, updateLineSheetDTO: UpdateLineSheetDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('lineSheetsControllerUpdateLineSheet', 'id', id)
            // verify required parameter 'updateLineSheetDTO' is not null or undefined
            assertParamExists('lineSheetsControllerUpdateLineSheet', 'updateLineSheetDTO', updateLineSheetDTO)
            const localVarPath = `/line-sheets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLineSheetDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LineSheetsApi - functional programming interface
 * @export
 */
export const LineSheetsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LineSheetsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lineSheetsControllerCopyLineSheet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LineSheet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lineSheetsControllerCopyLineSheet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateLineSheetDTO} createLineSheetDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lineSheetsControllerCreateLineSheet(createLineSheetDTO: CreateLineSheetDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LineSheet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lineSheetsControllerCreateLineSheet(createLineSheetDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [searchString] 
         * @param {'colorwayView' | 'productViewCondensed' | 'productViewExpanded'} [layout] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lineSheetsControllerGenerateLineSheetReport(id: string, searchString?: string, layout?: 'colorwayView' | 'productViewCondensed' | 'productViewExpanded', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductsControllerQueryProducts200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lineSheetsControllerGenerateLineSheetReport(id, searchString, layout, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lineSheetsControllerGetLineSheet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lineSheetsControllerGetLineSheet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [searchString] 
         * @param {'colorwayView' | 'productViewCondensed' | 'productViewExpanded'} [layout] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lineSheetsControllerGetLineSheetProducts(id: string, searchString?: string, layout?: 'colorwayView' | 'productViewCondensed' | 'productViewExpanded', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductsControllerQueryProducts200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lineSheetsControllerGetLineSheetProducts(id, searchString, layout, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lineSheetsControllerGetLineSheets(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LineSheetsControllerGetLineSheets200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lineSheetsControllerGetLineSheets(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateLineSheetDTO} updateLineSheetDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lineSheetsControllerUpdateLineSheet(id: string, updateLineSheetDTO: UpdateLineSheetDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LineSheet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lineSheetsControllerUpdateLineSheet(id, updateLineSheetDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LineSheetsApi - factory interface
 * @export
 */
export const LineSheetsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LineSheetsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lineSheetsControllerCopyLineSheet(id: string, options?: any): AxiosPromise<LineSheet> {
            return localVarFp.lineSheetsControllerCopyLineSheet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateLineSheetDTO} createLineSheetDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lineSheetsControllerCreateLineSheet(createLineSheetDTO: CreateLineSheetDTO, options?: any): AxiosPromise<LineSheet> {
            return localVarFp.lineSheetsControllerCreateLineSheet(createLineSheetDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [searchString] 
         * @param {'colorwayView' | 'productViewCondensed' | 'productViewExpanded'} [layout] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lineSheetsControllerGenerateLineSheetReport(id: string, searchString?: string, layout?: 'colorwayView' | 'productViewCondensed' | 'productViewExpanded', options?: any): AxiosPromise<ProductsControllerQueryProducts200Response> {
            return localVarFp.lineSheetsControllerGenerateLineSheetReport(id, searchString, layout, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lineSheetsControllerGetLineSheet(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.lineSheetsControllerGetLineSheet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [searchString] 
         * @param {'colorwayView' | 'productViewCondensed' | 'productViewExpanded'} [layout] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lineSheetsControllerGetLineSheetProducts(id: string, searchString?: string, layout?: 'colorwayView' | 'productViewCondensed' | 'productViewExpanded', options?: any): AxiosPromise<ProductsControllerQueryProducts200Response> {
            return localVarFp.lineSheetsControllerGetLineSheetProducts(id, searchString, layout, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lineSheetsControllerGetLineSheets(options?: any): AxiosPromise<LineSheetsControllerGetLineSheets200Response> {
            return localVarFp.lineSheetsControllerGetLineSheets(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateLineSheetDTO} updateLineSheetDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lineSheetsControllerUpdateLineSheet(id: string, updateLineSheetDTO: UpdateLineSheetDTO, options?: any): AxiosPromise<LineSheet> {
            return localVarFp.lineSheetsControllerUpdateLineSheet(id, updateLineSheetDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LineSheetsApi - object-oriented interface
 * @export
 * @class LineSheetsApi
 * @extends {BaseAPI}
 */
export class LineSheetsApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LineSheetsApi
     */
    public lineSheetsControllerCopyLineSheet(id: string, options?: AxiosRequestConfig) {
        return LineSheetsApiFp(this.configuration).lineSheetsControllerCopyLineSheet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateLineSheetDTO} createLineSheetDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LineSheetsApi
     */
    public lineSheetsControllerCreateLineSheet(createLineSheetDTO: CreateLineSheetDTO, options?: AxiosRequestConfig) {
        return LineSheetsApiFp(this.configuration).lineSheetsControllerCreateLineSheet(createLineSheetDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} [searchString] 
     * @param {'colorwayView' | 'productViewCondensed' | 'productViewExpanded'} [layout] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LineSheetsApi
     */
    public lineSheetsControllerGenerateLineSheetReport(id: string, searchString?: string, layout?: 'colorwayView' | 'productViewCondensed' | 'productViewExpanded', options?: AxiosRequestConfig) {
        return LineSheetsApiFp(this.configuration).lineSheetsControllerGenerateLineSheetReport(id, searchString, layout, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LineSheetsApi
     */
    public lineSheetsControllerGetLineSheet(id: string, options?: AxiosRequestConfig) {
        return LineSheetsApiFp(this.configuration).lineSheetsControllerGetLineSheet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} [searchString] 
     * @param {'colorwayView' | 'productViewCondensed' | 'productViewExpanded'} [layout] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LineSheetsApi
     */
    public lineSheetsControllerGetLineSheetProducts(id: string, searchString?: string, layout?: 'colorwayView' | 'productViewCondensed' | 'productViewExpanded', options?: AxiosRequestConfig) {
        return LineSheetsApiFp(this.configuration).lineSheetsControllerGetLineSheetProducts(id, searchString, layout, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LineSheetsApi
     */
    public lineSheetsControllerGetLineSheets(options?: AxiosRequestConfig) {
        return LineSheetsApiFp(this.configuration).lineSheetsControllerGetLineSheets(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateLineSheetDTO} updateLineSheetDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LineSheetsApi
     */
    public lineSheetsControllerUpdateLineSheet(id: string, updateLineSheetDTO: UpdateLineSheetDTO, options?: AxiosRequestConfig) {
        return LineSheetsApiFp(this.configuration).lineSheetsControllerUpdateLineSheet(id, updateLineSheetDTO, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PalettesApi - axios parameter creator
 * @export
 */
export const PalettesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        palettesControllerCopy: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('palettesControllerCopy', 'id', id)
            const localVarPath = `/palettes/{id}/copy`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreatePaletteDto} createPaletteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        palettesControllerCreate: async (createPaletteDto: CreatePaletteDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPaletteDto' is not null or undefined
            assertParamExists('palettesControllerCreate', 'createPaletteDto', createPaletteDto)
            const localVarPath = `/palettes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPaletteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        palettesControllerDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('palettesControllerDelete', 'id', id)
            const localVarPath = `/palettes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        palettesControllerFindAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/palettes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {CreatePaletteDto} createPaletteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        palettesControllerUpdate: async (id: string, createPaletteDto: CreatePaletteDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('palettesControllerUpdate', 'id', id)
            // verify required parameter 'createPaletteDto' is not null or undefined
            assertParamExists('palettesControllerUpdate', 'createPaletteDto', createPaletteDto)
            const localVarPath = `/palettes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPaletteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PalettesApi - functional programming interface
 * @export
 */
export const PalettesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PalettesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async palettesControllerCopy(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Palette>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.palettesControllerCopy(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreatePaletteDto} createPaletteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async palettesControllerCreate(createPaletteDto: CreatePaletteDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Palette>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.palettesControllerCreate(createPaletteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async palettesControllerDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.palettesControllerDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async palettesControllerFindAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Palette>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.palettesControllerFindAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {CreatePaletteDto} createPaletteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async palettesControllerUpdate(id: string, createPaletteDto: CreatePaletteDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Palette>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.palettesControllerUpdate(id, createPaletteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PalettesApi - factory interface
 * @export
 */
export const PalettesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PalettesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        palettesControllerCopy(id: string, options?: any): AxiosPromise<Palette> {
            return localVarFp.palettesControllerCopy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreatePaletteDto} createPaletteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        palettesControllerCreate(createPaletteDto: CreatePaletteDto, options?: any): AxiosPromise<Palette> {
            return localVarFp.palettesControllerCreate(createPaletteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        palettesControllerDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.palettesControllerDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        palettesControllerFindAll(options?: any): AxiosPromise<Array<Palette>> {
            return localVarFp.palettesControllerFindAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {CreatePaletteDto} createPaletteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        palettesControllerUpdate(id: string, createPaletteDto: CreatePaletteDto, options?: any): AxiosPromise<Palette> {
            return localVarFp.palettesControllerUpdate(id, createPaletteDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PalettesApi - object-oriented interface
 * @export
 * @class PalettesApi
 * @extends {BaseAPI}
 */
export class PalettesApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PalettesApi
     */
    public palettesControllerCopy(id: string, options?: AxiosRequestConfig) {
        return PalettesApiFp(this.configuration).palettesControllerCopy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreatePaletteDto} createPaletteDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PalettesApi
     */
    public palettesControllerCreate(createPaletteDto: CreatePaletteDto, options?: AxiosRequestConfig) {
        return PalettesApiFp(this.configuration).palettesControllerCreate(createPaletteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PalettesApi
     */
    public palettesControllerDelete(id: string, options?: AxiosRequestConfig) {
        return PalettesApiFp(this.configuration).palettesControllerDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PalettesApi
     */
    public palettesControllerFindAll(options?: AxiosRequestConfig) {
        return PalettesApiFp(this.configuration).palettesControllerFindAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {CreatePaletteDto} createPaletteDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PalettesApi
     */
    public palettesControllerUpdate(id: string, createPaletteDto: CreatePaletteDto, options?: AxiosRequestConfig) {
        return PalettesApiFp(this.configuration).palettesControllerUpdate(id, createPaletteDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PointsOfMeasureApi - axios parameter creator
 * @export
 */
export const PointsOfMeasureApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {PomDuplicateDTO} pomDuplicateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointsOfMeasureControllerCheckDuplicate: async (pomDuplicateDTO: PomDuplicateDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pomDuplicateDTO' is not null or undefined
            assertParamExists('pointsOfMeasureControllerCheckDuplicate', 'pomDuplicateDTO', pomDuplicateDTO)
            const localVarPath = `/points-of-measure/check-duplicates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pomDuplicateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointsOfMeasureControllerExportToLibrary: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pointsOfMeasureControllerExportToLibrary', 'id', id)
            const localVarPath = `/points-of-measure/{id}/copy-to-library`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PointsOfMeasureApi - functional programming interface
 * @export
 */
export const PointsOfMeasureApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PointsOfMeasureApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {PomDuplicateDTO} pomDuplicateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pointsOfMeasureControllerCheckDuplicate(pomDuplicateDTO: PomDuplicateDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pointsOfMeasureControllerCheckDuplicate(pomDuplicateDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pointsOfMeasureControllerExportToLibrary(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pointsOfMeasureControllerExportToLibrary(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PointsOfMeasureApi - factory interface
 * @export
 */
export const PointsOfMeasureApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PointsOfMeasureApiFp(configuration)
    return {
        /**
         * 
         * @param {PomDuplicateDTO} pomDuplicateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointsOfMeasureControllerCheckDuplicate(pomDuplicateDTO: PomDuplicateDTO, options?: any): AxiosPromise<void> {
            return localVarFp.pointsOfMeasureControllerCheckDuplicate(pomDuplicateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointsOfMeasureControllerExportToLibrary(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.pointsOfMeasureControllerExportToLibrary(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PointsOfMeasureApi - object-oriented interface
 * @export
 * @class PointsOfMeasureApi
 * @extends {BaseAPI}
 */
export class PointsOfMeasureApi extends BaseAPI {
    /**
     * 
     * @param {PomDuplicateDTO} pomDuplicateDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointsOfMeasureApi
     */
    public pointsOfMeasureControllerCheckDuplicate(pomDuplicateDTO: PomDuplicateDTO, options?: AxiosRequestConfig) {
        return PointsOfMeasureApiFp(this.configuration).pointsOfMeasureControllerCheckDuplicate(pomDuplicateDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointsOfMeasureApi
     */
    public pointsOfMeasureControllerExportToLibrary(id: string, options?: AxiosRequestConfig) {
        return PointsOfMeasureApiFp(this.configuration).pointsOfMeasureControllerExportToLibrary(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductRevisionsApi - axios parameter creator
 * @export
 */
export const ProductRevisionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} revisionId Revision Id
         * @param {string} imageId Image Id
         * @param {string} id Product Id
         * @param {CopyRevisionImageDTO} copyRevisionImageDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productRevisionsControllerCopyProductRevisionImage: async (revisionId: string, imageId: string, id: string, copyRevisionImageDTO: CopyRevisionImageDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'revisionId' is not null or undefined
            assertParamExists('productRevisionsControllerCopyProductRevisionImage', 'revisionId', revisionId)
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('productRevisionsControllerCopyProductRevisionImage', 'imageId', imageId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productRevisionsControllerCopyProductRevisionImage', 'id', id)
            // verify required parameter 'copyRevisionImageDTO' is not null or undefined
            assertParamExists('productRevisionsControllerCopyProductRevisionImage', 'copyRevisionImageDTO', copyRevisionImageDTO)
            const localVarPath = `/products/{id}/revisions/{revisionId}/images/{imageId}/copy`
                .replace(`{${"revisionId"}}`, encodeURIComponent(String(revisionId)))
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(copyRevisionImageDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productRevisionsControllerGetProductRevisions: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productRevisionsControllerGetProductRevisions', 'id', id)
            const localVarPath = `/products/{id}/revisions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sourceFileId 
         * @param {string} revisionId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productRevisionsControllerGetProductSourceFileById: async (sourceFileId: string, revisionId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceFileId' is not null or undefined
            assertParamExists('productRevisionsControllerGetProductSourceFileById', 'sourceFileId', sourceFileId)
            // verify required parameter 'revisionId' is not null or undefined
            assertParamExists('productRevisionsControllerGetProductSourceFileById', 'revisionId', revisionId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productRevisionsControllerGetProductSourceFileById', 'id', id)
            const localVarPath = `/products/{id}/revisions/{revisionId}/source-files/{sourceFileId}`
                .replace(`{${"sourceFileId"}}`, encodeURIComponent(String(sourceFileId)))
                .replace(`{${"revisionId"}}`, encodeURIComponent(String(revisionId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productRevisionsControllerGetSourceFiles: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productRevisionsControllerGetSourceFiles', 'id', id)
            const localVarPath = `/products/{id}/revisions/source-files`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductRevisionsApi - functional programming interface
 * @export
 */
export const ProductRevisionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductRevisionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} revisionId Revision Id
         * @param {string} imageId Image Id
         * @param {string} id Product Id
         * @param {CopyRevisionImageDTO} copyRevisionImageDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productRevisionsControllerCopyProductRevisionImage(revisionId: string, imageId: string, id: string, copyRevisionImageDTO: CopyRevisionImageDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Product>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productRevisionsControllerCopyProductRevisionImage(revisionId, imageId, id, copyRevisionImageDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productRevisionsControllerGetProductRevisions(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Product>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productRevisionsControllerGetProductRevisions(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} sourceFileId 
         * @param {string} revisionId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productRevisionsControllerGetProductSourceFileById(sourceFileId: string, revisionId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SourceFile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productRevisionsControllerGetProductSourceFileById(sourceFileId, revisionId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productRevisionsControllerGetSourceFiles(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Revision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productRevisionsControllerGetSourceFiles(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductRevisionsApi - factory interface
 * @export
 */
export const ProductRevisionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductRevisionsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} revisionId Revision Id
         * @param {string} imageId Image Id
         * @param {string} id Product Id
         * @param {CopyRevisionImageDTO} copyRevisionImageDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productRevisionsControllerCopyProductRevisionImage(revisionId: string, imageId: string, id: string, copyRevisionImageDTO: CopyRevisionImageDTO, options?: any): AxiosPromise<Product> {
            return localVarFp.productRevisionsControllerCopyProductRevisionImage(revisionId, imageId, id, copyRevisionImageDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productRevisionsControllerGetProductRevisions(id: string, options?: any): AxiosPromise<Product> {
            return localVarFp.productRevisionsControllerGetProductRevisions(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sourceFileId 
         * @param {string} revisionId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productRevisionsControllerGetProductSourceFileById(sourceFileId: string, revisionId: string, id: string, options?: any): AxiosPromise<SourceFile> {
            return localVarFp.productRevisionsControllerGetProductSourceFileById(sourceFileId, revisionId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productRevisionsControllerGetSourceFiles(id: string, options?: any): AxiosPromise<Revision> {
            return localVarFp.productRevisionsControllerGetSourceFiles(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductRevisionsApi - object-oriented interface
 * @export
 * @class ProductRevisionsApi
 * @extends {BaseAPI}
 */
export class ProductRevisionsApi extends BaseAPI {
    /**
     * 
     * @param {string} revisionId Revision Id
     * @param {string} imageId Image Id
     * @param {string} id Product Id
     * @param {CopyRevisionImageDTO} copyRevisionImageDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductRevisionsApi
     */
    public productRevisionsControllerCopyProductRevisionImage(revisionId: string, imageId: string, id: string, copyRevisionImageDTO: CopyRevisionImageDTO, options?: AxiosRequestConfig) {
        return ProductRevisionsApiFp(this.configuration).productRevisionsControllerCopyProductRevisionImage(revisionId, imageId, id, copyRevisionImageDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductRevisionsApi
     */
    public productRevisionsControllerGetProductRevisions(id: string, options?: AxiosRequestConfig) {
        return ProductRevisionsApiFp(this.configuration).productRevisionsControllerGetProductRevisions(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sourceFileId 
     * @param {string} revisionId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductRevisionsApi
     */
    public productRevisionsControllerGetProductSourceFileById(sourceFileId: string, revisionId: string, id: string, options?: AxiosRequestConfig) {
        return ProductRevisionsApiFp(this.configuration).productRevisionsControllerGetProductSourceFileById(sourceFileId, revisionId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductRevisionsApi
     */
    public productRevisionsControllerGetSourceFiles(id: string, options?: AxiosRequestConfig) {
        return ProductRevisionsApiFp(this.configuration).productRevisionsControllerGetSourceFiles(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductSourceFilesApi - axios parameter creator
 * @export
 */
export const ProductSourceFilesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {CreateSourceFileDto} createSourceFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSourceFilesControllerCreateSourceFile: async (id: string, createSourceFileDto: CreateSourceFileDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productSourceFilesControllerCreateSourceFile', 'id', id)
            // verify required parameter 'createSourceFileDto' is not null or undefined
            assertParamExists('productSourceFilesControllerCreateSourceFile', 'createSourceFileDto', createSourceFileDto)
            const localVarPath = `/products/{id}/source-files`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSourceFileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateFilesSignedUrlDto} createFilesSignedUrlDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSourceFilesControllerGetSignedURL: async (id: string, createFilesSignedUrlDto: CreateFilesSignedUrlDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productSourceFilesControllerGetSignedURL', 'id', id)
            // verify required parameter 'createFilesSignedUrlDto' is not null or undefined
            assertParamExists('productSourceFilesControllerGetSignedURL', 'createFilesSignedUrlDto', createFilesSignedUrlDto)
            const localVarPath = `/products/{id}/source-files/signed-urls`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFilesSignedUrlDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sourceFileId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSourceFilesControllerGetSourceFile: async (sourceFileId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceFileId' is not null or undefined
            assertParamExists('productSourceFilesControllerGetSourceFile', 'sourceFileId', sourceFileId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productSourceFilesControllerGetSourceFile', 'id', id)
            const localVarPath = `/products/{id}/source-files/{sourceFileId}`
                .replace(`{${"sourceFileId"}}`, encodeURIComponent(String(sourceFileId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSourceFilesControllerGetSourceFiles: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productSourceFilesControllerGetSourceFiles', 'id', id)
            const localVarPath = `/products/{id}/source-files`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sourceFileId 
         * @param {string} id 
         * @param {UpdateSourceFilesImagesDTO} updateSourceFilesImagesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSourceFilesControllerUpdateProductImages: async (sourceFileId: string, id: string, updateSourceFilesImagesDTO: UpdateSourceFilesImagesDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceFileId' is not null or undefined
            assertParamExists('productSourceFilesControllerUpdateProductImages', 'sourceFileId', sourceFileId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productSourceFilesControllerUpdateProductImages', 'id', id)
            // verify required parameter 'updateSourceFilesImagesDTO' is not null or undefined
            assertParamExists('productSourceFilesControllerUpdateProductImages', 'updateSourceFilesImagesDTO', updateSourceFilesImagesDTO)
            const localVarPath = `/products/{id}/source-files/{sourceFileId}/images`
                .replace(`{${"sourceFileId"}}`, encodeURIComponent(String(sourceFileId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSourceFilesImagesDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sourceFileId 
         * @param {string} id 
         * @param {UpdateSourceFileDto} updateSourceFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSourceFilesControllerUpdateSourceFile: async (sourceFileId: string, id: string, updateSourceFileDto: UpdateSourceFileDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceFileId' is not null or undefined
            assertParamExists('productSourceFilesControllerUpdateSourceFile', 'sourceFileId', sourceFileId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productSourceFilesControllerUpdateSourceFile', 'id', id)
            // verify required parameter 'updateSourceFileDto' is not null or undefined
            assertParamExists('productSourceFilesControllerUpdateSourceFile', 'updateSourceFileDto', updateSourceFileDto)
            const localVarPath = `/products/{id}/source-files/{sourceFileId}`
                .replace(`{${"sourceFileId"}}`, encodeURIComponent(String(sourceFileId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSourceFileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductSourceFilesApi - functional programming interface
 * @export
 */
export const ProductSourceFilesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductSourceFilesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {CreateSourceFileDto} createSourceFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productSourceFilesControllerCreateSourceFile(id: string, createSourceFileDto: CreateSourceFileDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SourceFile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productSourceFilesControllerCreateSourceFile(id, createSourceFileDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateFilesSignedUrlDto} createFilesSignedUrlDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productSourceFilesControllerGetSignedURL(id: string, createFilesSignedUrlDto: CreateFilesSignedUrlDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productSourceFilesControllerGetSignedURL(id, createFilesSignedUrlDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} sourceFileId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productSourceFilesControllerGetSourceFile(sourceFileId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SourceFile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productSourceFilesControllerGetSourceFile(sourceFileId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productSourceFilesControllerGetSourceFiles(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SourceFile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productSourceFilesControllerGetSourceFiles(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} sourceFileId 
         * @param {string} id 
         * @param {UpdateSourceFilesImagesDTO} updateSourceFilesImagesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productSourceFilesControllerUpdateProductImages(sourceFileId: string, id: string, updateSourceFilesImagesDTO: UpdateSourceFilesImagesDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productSourceFilesControllerUpdateProductImages(sourceFileId, id, updateSourceFilesImagesDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} sourceFileId 
         * @param {string} id 
         * @param {UpdateSourceFileDto} updateSourceFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productSourceFilesControllerUpdateSourceFile(sourceFileId: string, id: string, updateSourceFileDto: UpdateSourceFileDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productSourceFilesControllerUpdateSourceFile(sourceFileId, id, updateSourceFileDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductSourceFilesApi - factory interface
 * @export
 */
export const ProductSourceFilesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductSourceFilesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {CreateSourceFileDto} createSourceFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSourceFilesControllerCreateSourceFile(id: string, createSourceFileDto: CreateSourceFileDto, options?: any): AxiosPromise<SourceFile> {
            return localVarFp.productSourceFilesControllerCreateSourceFile(id, createSourceFileDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateFilesSignedUrlDto} createFilesSignedUrlDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSourceFilesControllerGetSignedURL(id: string, createFilesSignedUrlDto: CreateFilesSignedUrlDto, options?: any): AxiosPromise<void> {
            return localVarFp.productSourceFilesControllerGetSignedURL(id, createFilesSignedUrlDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sourceFileId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSourceFilesControllerGetSourceFile(sourceFileId: string, id: string, options?: any): AxiosPromise<SourceFile> {
            return localVarFp.productSourceFilesControllerGetSourceFile(sourceFileId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSourceFilesControllerGetSourceFiles(id: string, options?: any): AxiosPromise<SourceFile> {
            return localVarFp.productSourceFilesControllerGetSourceFiles(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sourceFileId 
         * @param {string} id 
         * @param {UpdateSourceFilesImagesDTO} updateSourceFilesImagesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSourceFilesControllerUpdateProductImages(sourceFileId: string, id: string, updateSourceFilesImagesDTO: UpdateSourceFilesImagesDTO, options?: any): AxiosPromise<void> {
            return localVarFp.productSourceFilesControllerUpdateProductImages(sourceFileId, id, updateSourceFilesImagesDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sourceFileId 
         * @param {string} id 
         * @param {UpdateSourceFileDto} updateSourceFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productSourceFilesControllerUpdateSourceFile(sourceFileId: string, id: string, updateSourceFileDto: UpdateSourceFileDto, options?: any): AxiosPromise<void> {
            return localVarFp.productSourceFilesControllerUpdateSourceFile(sourceFileId, id, updateSourceFileDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductSourceFilesApi - object-oriented interface
 * @export
 * @class ProductSourceFilesApi
 * @extends {BaseAPI}
 */
export class ProductSourceFilesApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {CreateSourceFileDto} createSourceFileDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSourceFilesApi
     */
    public productSourceFilesControllerCreateSourceFile(id: string, createSourceFileDto: CreateSourceFileDto, options?: AxiosRequestConfig) {
        return ProductSourceFilesApiFp(this.configuration).productSourceFilesControllerCreateSourceFile(id, createSourceFileDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {CreateFilesSignedUrlDto} createFilesSignedUrlDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSourceFilesApi
     */
    public productSourceFilesControllerGetSignedURL(id: string, createFilesSignedUrlDto: CreateFilesSignedUrlDto, options?: AxiosRequestConfig) {
        return ProductSourceFilesApiFp(this.configuration).productSourceFilesControllerGetSignedURL(id, createFilesSignedUrlDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sourceFileId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSourceFilesApi
     */
    public productSourceFilesControllerGetSourceFile(sourceFileId: string, id: string, options?: AxiosRequestConfig) {
        return ProductSourceFilesApiFp(this.configuration).productSourceFilesControllerGetSourceFile(sourceFileId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSourceFilesApi
     */
    public productSourceFilesControllerGetSourceFiles(id: string, options?: AxiosRequestConfig) {
        return ProductSourceFilesApiFp(this.configuration).productSourceFilesControllerGetSourceFiles(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sourceFileId 
     * @param {string} id 
     * @param {UpdateSourceFilesImagesDTO} updateSourceFilesImagesDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSourceFilesApi
     */
    public productSourceFilesControllerUpdateProductImages(sourceFileId: string, id: string, updateSourceFilesImagesDTO: UpdateSourceFilesImagesDTO, options?: AxiosRequestConfig) {
        return ProductSourceFilesApiFp(this.configuration).productSourceFilesControllerUpdateProductImages(sourceFileId, id, updateSourceFilesImagesDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sourceFileId 
     * @param {string} id 
     * @param {UpdateSourceFileDto} updateSourceFileDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSourceFilesApi
     */
    public productSourceFilesControllerUpdateSourceFile(sourceFileId: string, id: string, updateSourceFileDto: UpdateSourceFileDto, options?: AxiosRequestConfig) {
        return ProductSourceFilesApiFp(this.configuration).productSourceFilesControllerUpdateSourceFile(sourceFileId, id, updateSourceFileDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductTechpackAttachmentsApi - axios parameter creator
 * @export
 */
export const ProductTechpackAttachmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} techpackId 
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTechpackAttachmentsControllerCreateNewProductTechpack: async (techpackId: string, id: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'techpackId' is not null or undefined
            assertParamExists('productTechpackAttachmentsControllerCreateNewProductTechpack', 'techpackId', techpackId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productTechpackAttachmentsControllerCreateNewProductTechpack', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('productTechpackAttachmentsControllerCreateNewProductTechpack', 'body', body)
            const localVarPath = `/products/{id}/techpacks/{techpackId}/attachments`
                .replace(`{${"techpackId"}}`, encodeURIComponent(String(techpackId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} techpackAttachmentId 
         * @param {string} techpackId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTechpackAttachmentsControllerDeleteProductTechpack: async (techpackAttachmentId: string, techpackId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'techpackAttachmentId' is not null or undefined
            assertParamExists('productTechpackAttachmentsControllerDeleteProductTechpack', 'techpackAttachmentId', techpackAttachmentId)
            // verify required parameter 'techpackId' is not null or undefined
            assertParamExists('productTechpackAttachmentsControllerDeleteProductTechpack', 'techpackId', techpackId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productTechpackAttachmentsControllerDeleteProductTechpack', 'id', id)
            const localVarPath = `/products/{id}/techpacks/{techpackId}/attachments/{techpackAttachmentId}`
                .replace(`{${"techpackAttachmentId"}}`, encodeURIComponent(String(techpackAttachmentId)))
                .replace(`{${"techpackId"}}`, encodeURIComponent(String(techpackId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} techpackId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTechpackAttachmentsControllerGetProductTechpackAttachments: async (techpackId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'techpackId' is not null or undefined
            assertParamExists('productTechpackAttachmentsControllerGetProductTechpackAttachments', 'techpackId', techpackId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productTechpackAttachmentsControllerGetProductTechpackAttachments', 'id', id)
            const localVarPath = `/products/{id}/techpacks/{techpackId}/attachments`
                .replace(`{${"techpackId"}}`, encodeURIComponent(String(techpackId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductTechpackAttachmentsApi - functional programming interface
 * @export
 */
export const ProductTechpackAttachmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductTechpackAttachmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} techpackId 
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productTechpackAttachmentsControllerCreateNewProductTechpack(techpackId: string, id: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productTechpackAttachmentsControllerCreateNewProductTechpack(techpackId, id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} techpackAttachmentId 
         * @param {string} techpackId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productTechpackAttachmentsControllerDeleteProductTechpack(techpackAttachmentId: string, techpackId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productTechpackAttachmentsControllerDeleteProductTechpack(techpackAttachmentId, techpackId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} techpackId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productTechpackAttachmentsControllerGetProductTechpackAttachments(techpackId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductTechpackAttachment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productTechpackAttachmentsControllerGetProductTechpackAttachments(techpackId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductTechpackAttachmentsApi - factory interface
 * @export
 */
export const ProductTechpackAttachmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductTechpackAttachmentsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} techpackId 
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTechpackAttachmentsControllerCreateNewProductTechpack(techpackId: string, id: string, body: object, options?: any): AxiosPromise<object> {
            return localVarFp.productTechpackAttachmentsControllerCreateNewProductTechpack(techpackId, id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} techpackAttachmentId 
         * @param {string} techpackId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTechpackAttachmentsControllerDeleteProductTechpack(techpackAttachmentId: string, techpackId: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.productTechpackAttachmentsControllerDeleteProductTechpack(techpackAttachmentId, techpackId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} techpackId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTechpackAttachmentsControllerGetProductTechpackAttachments(techpackId: string, id: string, options?: any): AxiosPromise<Array<ProductTechpackAttachment>> {
            return localVarFp.productTechpackAttachmentsControllerGetProductTechpackAttachments(techpackId, id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductTechpackAttachmentsApi - object-oriented interface
 * @export
 * @class ProductTechpackAttachmentsApi
 * @extends {BaseAPI}
 */
export class ProductTechpackAttachmentsApi extends BaseAPI {
    /**
     * 
     * @param {string} techpackId 
     * @param {string} id 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTechpackAttachmentsApi
     */
    public productTechpackAttachmentsControllerCreateNewProductTechpack(techpackId: string, id: string, body: object, options?: AxiosRequestConfig) {
        return ProductTechpackAttachmentsApiFp(this.configuration).productTechpackAttachmentsControllerCreateNewProductTechpack(techpackId, id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} techpackAttachmentId 
     * @param {string} techpackId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTechpackAttachmentsApi
     */
    public productTechpackAttachmentsControllerDeleteProductTechpack(techpackAttachmentId: string, techpackId: string, id: string, options?: AxiosRequestConfig) {
        return ProductTechpackAttachmentsApiFp(this.configuration).productTechpackAttachmentsControllerDeleteProductTechpack(techpackAttachmentId, techpackId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} techpackId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTechpackAttachmentsApi
     */
    public productTechpackAttachmentsControllerGetProductTechpackAttachments(techpackId: string, id: string, options?: AxiosRequestConfig) {
        return ProductTechpackAttachmentsApiFp(this.configuration).productTechpackAttachmentsControllerGetProductTechpackAttachments(techpackId, id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductTechpackSharesApi - axios parameter creator
 * @export
 */
export const ProductTechpackSharesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {string} techpackId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductTechpackShare: async (techpackId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'techpackId' is not null or undefined
            assertParamExists('createProductTechpackShare', 'techpackId', techpackId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createProductTechpackShare', 'id', id)
            const localVarPath = `/products/{id}/techpacks/{techpackId}/shares`
                .replace(`{${"techpackId"}}`, encodeURIComponent(String(techpackId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} techpackId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTechpackSharesControllerGetTechpackShare: async (techpackId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'techpackId' is not null or undefined
            assertParamExists('productTechpackSharesControllerGetTechpackShare', 'techpackId', techpackId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productTechpackSharesControllerGetTechpackShare', 'id', id)
            const localVarPath = `/products/{id}/techpacks/{techpackId}/shares`
                .replace(`{${"techpackId"}}`, encodeURIComponent(String(techpackId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductTechpackSharesApi - functional programming interface
 * @export
 */
export const ProductTechpackSharesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductTechpackSharesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {string} techpackId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProductTechpackShare(techpackId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductTechpackShare>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProductTechpackShare(techpackId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} techpackId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productTechpackSharesControllerGetTechpackShare(techpackId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductTechpackShare>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productTechpackSharesControllerGetTechpackShare(techpackId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductTechpackSharesApi - factory interface
 * @export
 */
export const ProductTechpackSharesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductTechpackSharesApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {string} techpackId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductTechpackShare(techpackId: string, id: string, options?: any): AxiosPromise<ProductTechpackShare> {
            return localVarFp.createProductTechpackShare(techpackId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} techpackId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTechpackSharesControllerGetTechpackShare(techpackId: string, id: string, options?: any): AxiosPromise<ProductTechpackShare> {
            return localVarFp.productTechpackSharesControllerGetTechpackShare(techpackId, id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductTechpackSharesApi - object-oriented interface
 * @export
 * @class ProductTechpackSharesApi
 * @extends {BaseAPI}
 */
export class ProductTechpackSharesApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {string} techpackId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTechpackSharesApi
     */
    public createProductTechpackShare(techpackId: string, id: string, options?: AxiosRequestConfig) {
        return ProductTechpackSharesApiFp(this.configuration).createProductTechpackShare(techpackId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} techpackId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTechpackSharesApi
     */
    public productTechpackSharesControllerGetTechpackShare(techpackId: string, id: string, options?: AxiosRequestConfig) {
        return ProductTechpackSharesApiFp(this.configuration).productTechpackSharesControllerGetTechpackShare(techpackId, id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductTechpacksApi - axios parameter creator
 * @export
 */
export const ProductTechpacksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {string} techpackId 
         * @param {string} id 
         * @param {EmailProductTechpackDto} emailProductTechpackDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailTechpackShare: async (techpackId: string, id: string, emailProductTechpackDto: EmailProductTechpackDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'techpackId' is not null or undefined
            assertParamExists('emailTechpackShare', 'techpackId', techpackId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('emailTechpackShare', 'id', id)
            // verify required parameter 'emailProductTechpackDto' is not null or undefined
            assertParamExists('emailTechpackShare', 'emailProductTechpackDto', emailProductTechpackDto)
            const localVarPath = `/products/{id}/techpacks/{techpackId}/email-share`
                .replace(`{${"techpackId"}}`, encodeURIComponent(String(techpackId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailProductTechpackDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} techpackId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignedUrlForTechpack: async (techpackId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'techpackId' is not null or undefined
            assertParamExists('getSignedUrlForTechpack', 'techpackId', techpackId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSignedUrlForTechpack', 'id', id)
            const localVarPath = `/products/{id}/techpacks/{techpackId}/signed-url`
                .replace(`{${"techpackId"}}`, encodeURIComponent(String(techpackId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTechpacksControllerCreateNewProductTechpack: async (id: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productTechpacksControllerCreateNewProductTechpack', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('productTechpacksControllerCreateNewProductTechpack', 'body', body)
            const localVarPath = `/products/{id}/techpacks/create`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} techpackId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTechpacksControllerDeleteProductTechpack: async (techpackId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'techpackId' is not null or undefined
            assertParamExists('productTechpacksControllerDeleteProductTechpack', 'techpackId', techpackId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productTechpacksControllerDeleteProductTechpack', 'id', id)
            const localVarPath = `/products/{id}/techpacks/{techpackId}`
                .replace(`{${"techpackId"}}`, encodeURIComponent(String(techpackId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} techpackId 
         * @param {string} id 
         * @param {EmailProductTechpackDto} emailProductTechpackDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTechpacksControllerEmailTechpack: async (techpackId: string, id: string, emailProductTechpackDto: EmailProductTechpackDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'techpackId' is not null or undefined
            assertParamExists('productTechpacksControllerEmailTechpack', 'techpackId', techpackId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productTechpacksControllerEmailTechpack', 'id', id)
            // verify required parameter 'emailProductTechpackDto' is not null or undefined
            assertParamExists('productTechpacksControllerEmailTechpack', 'emailProductTechpackDto', emailProductTechpackDto)
            const localVarPath = `/products/{id}/techpacks/{techpackId}/email`
                .replace(`{${"techpackId"}}`, encodeURIComponent(String(techpackId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailProductTechpackDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTechpacksControllerGenerateNewProductTechpack: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productTechpacksControllerGenerateNewProductTechpack', 'id', id)
            const localVarPath = `/products/{id}/techpacks`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} techpackId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTechpacksControllerGetProductTechpack: async (techpackId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'techpackId' is not null or undefined
            assertParamExists('productTechpacksControllerGetProductTechpack', 'techpackId', techpackId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productTechpacksControllerGetProductTechpack', 'id', id)
            const localVarPath = `/products/{id}/techpacks/{techpackId}`
                .replace(`{${"techpackId"}}`, encodeURIComponent(String(techpackId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTechpacksControllerGetProductTechpacks: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productTechpacksControllerGetProductTechpacks', 'id', id)
            const localVarPath = `/products/{id}/techpacks`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} techpackId 
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTechpacksControllerUpdateTechpack: async (techpackId: string, id: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'techpackId' is not null or undefined
            assertParamExists('productTechpacksControllerUpdateTechpack', 'techpackId', techpackId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productTechpacksControllerUpdateTechpack', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('productTechpacksControllerUpdateTechpack', 'body', body)
            const localVarPath = `/products/{id}/techpacks/{techpackId}`
                .replace(`{${"techpackId"}}`, encodeURIComponent(String(techpackId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductTechpacksApi - functional programming interface
 * @export
 */
export const ProductTechpacksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductTechpacksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {string} techpackId 
         * @param {string} id 
         * @param {EmailProductTechpackDto} emailProductTechpackDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailTechpackShare(techpackId: string, id: string, emailProductTechpackDto: EmailProductTechpackDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailTechpackShare(techpackId, id, emailProductTechpackDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} techpackId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSignedUrlForTechpack(techpackId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSignedUrlForTechpack(techpackId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productTechpacksControllerCreateNewProductTechpack(id: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productTechpacksControllerCreateNewProductTechpack(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} techpackId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productTechpacksControllerDeleteProductTechpack(techpackId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productTechpacksControllerDeleteProductTechpack(techpackId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} techpackId 
         * @param {string} id 
         * @param {EmailProductTechpackDto} emailProductTechpackDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productTechpacksControllerEmailTechpack(techpackId: string, id: string, emailProductTechpackDto: EmailProductTechpackDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productTechpacksControllerEmailTechpack(techpackId, id, emailProductTechpackDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productTechpacksControllerGenerateNewProductTechpack(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productTechpacksControllerGenerateNewProductTechpack(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} techpackId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productTechpacksControllerGetProductTechpack(techpackId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductTechpack>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productTechpacksControllerGetProductTechpack(techpackId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productTechpacksControllerGetProductTechpacks(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductTechpack>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productTechpacksControllerGetProductTechpacks(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} techpackId 
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productTechpacksControllerUpdateTechpack(techpackId: string, id: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productTechpacksControllerUpdateTechpack(techpackId, id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductTechpacksApi - factory interface
 * @export
 */
export const ProductTechpacksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductTechpacksApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {string} techpackId 
         * @param {string} id 
         * @param {EmailProductTechpackDto} emailProductTechpackDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailTechpackShare(techpackId: string, id: string, emailProductTechpackDto: EmailProductTechpackDto, options?: any): AxiosPromise<void> {
            return localVarFp.emailTechpackShare(techpackId, id, emailProductTechpackDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} techpackId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignedUrlForTechpack(techpackId: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.getSignedUrlForTechpack(techpackId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTechpacksControllerCreateNewProductTechpack(id: string, body: object, options?: any): AxiosPromise<object> {
            return localVarFp.productTechpacksControllerCreateNewProductTechpack(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} techpackId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTechpacksControllerDeleteProductTechpack(techpackId: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.productTechpacksControllerDeleteProductTechpack(techpackId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} techpackId 
         * @param {string} id 
         * @param {EmailProductTechpackDto} emailProductTechpackDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTechpacksControllerEmailTechpack(techpackId: string, id: string, emailProductTechpackDto: EmailProductTechpackDto, options?: any): AxiosPromise<void> {
            return localVarFp.productTechpacksControllerEmailTechpack(techpackId, id, emailProductTechpackDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTechpacksControllerGenerateNewProductTechpack(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.productTechpacksControllerGenerateNewProductTechpack(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} techpackId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTechpacksControllerGetProductTechpack(techpackId: string, id: string, options?: any): AxiosPromise<Array<ProductTechpack>> {
            return localVarFp.productTechpacksControllerGetProductTechpack(techpackId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTechpacksControllerGetProductTechpacks(id: string, options?: any): AxiosPromise<Array<ProductTechpack>> {
            return localVarFp.productTechpacksControllerGetProductTechpacks(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} techpackId 
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productTechpacksControllerUpdateTechpack(techpackId: string, id: string, body: object, options?: any): AxiosPromise<void> {
            return localVarFp.productTechpacksControllerUpdateTechpack(techpackId, id, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductTechpacksApi - object-oriented interface
 * @export
 * @class ProductTechpacksApi
 * @extends {BaseAPI}
 */
export class ProductTechpacksApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {string} techpackId 
     * @param {string} id 
     * @param {EmailProductTechpackDto} emailProductTechpackDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTechpacksApi
     */
    public emailTechpackShare(techpackId: string, id: string, emailProductTechpackDto: EmailProductTechpackDto, options?: AxiosRequestConfig) {
        return ProductTechpacksApiFp(this.configuration).emailTechpackShare(techpackId, id, emailProductTechpackDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} techpackId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTechpacksApi
     */
    public getSignedUrlForTechpack(techpackId: string, id: string, options?: AxiosRequestConfig) {
        return ProductTechpacksApiFp(this.configuration).getSignedUrlForTechpack(techpackId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTechpacksApi
     */
    public productTechpacksControllerCreateNewProductTechpack(id: string, body: object, options?: AxiosRequestConfig) {
        return ProductTechpacksApiFp(this.configuration).productTechpacksControllerCreateNewProductTechpack(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} techpackId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTechpacksApi
     */
    public productTechpacksControllerDeleteProductTechpack(techpackId: string, id: string, options?: AxiosRequestConfig) {
        return ProductTechpacksApiFp(this.configuration).productTechpacksControllerDeleteProductTechpack(techpackId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} techpackId 
     * @param {string} id 
     * @param {EmailProductTechpackDto} emailProductTechpackDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTechpacksApi
     */
    public productTechpacksControllerEmailTechpack(techpackId: string, id: string, emailProductTechpackDto: EmailProductTechpackDto, options?: AxiosRequestConfig) {
        return ProductTechpacksApiFp(this.configuration).productTechpacksControllerEmailTechpack(techpackId, id, emailProductTechpackDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTechpacksApi
     */
    public productTechpacksControllerGenerateNewProductTechpack(id: string, options?: AxiosRequestConfig) {
        return ProductTechpacksApiFp(this.configuration).productTechpacksControllerGenerateNewProductTechpack(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} techpackId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTechpacksApi
     */
    public productTechpacksControllerGetProductTechpack(techpackId: string, id: string, options?: AxiosRequestConfig) {
        return ProductTechpacksApiFp(this.configuration).productTechpacksControllerGetProductTechpack(techpackId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTechpacksApi
     */
    public productTechpacksControllerGetProductTechpacks(id: string, options?: AxiosRequestConfig) {
        return ProductTechpacksApiFp(this.configuration).productTechpacksControllerGetProductTechpacks(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} techpackId 
     * @param {string} id 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTechpacksApi
     */
    public productTechpacksControllerUpdateTechpack(techpackId: string, id: string, body: object, options?: AxiosRequestConfig) {
        return ProductTechpacksApiFp(this.configuration).productTechpacksControllerUpdateTechpack(techpackId, id, body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductsApi - axios parameter creator
 * @export
 */
export const ProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateProductDTO} createProductDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerCreateProduct: async (createProductDTO: CreateProductDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProductDTO' is not null or undefined
            assertParamExists('productsControllerCreateProduct', 'createProductDTO', createProductDTO)
            const localVarPath = `/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProductDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerCreateProductCopy: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productsControllerCreateProductCopy', 'id', id)
            const localVarPath = `/products/{id}/copy`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerDeleteProduct: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productsControllerDeleteProduct', 'id', id)
            const localVarPath = `/products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EmailProductTechpackDto} emailProductTechpackDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerEmailTechpack: async (emailProductTechpackDto: EmailProductTechpackDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailProductTechpackDto' is not null or undefined
            assertParamExists('productsControllerEmailTechpack', 'emailProductTechpackDto', emailProductTechpackDto)
            const localVarPath = `/products/techpacks/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailProductTechpackDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerGetConvertedProduct: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productsControllerGetConvertedProduct', 'id', id)
            const localVarPath = `/products/{id}/converted`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerGetProductById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productsControllerGetProductById', 'id', id)
            const localVarPath = `/products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ImportBoMItemsDTO} importBoMItemsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerImportBomTemplateToProduct: async (id: string, importBoMItemsDTO: ImportBoMItemsDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productsControllerImportBomTemplateToProduct', 'id', id)
            // verify required parameter 'importBoMItemsDTO' is not null or undefined
            assertParamExists('productsControllerImportBomTemplateToProduct', 'importBoMItemsDTO', importBoMItemsDTO)
            const localVarPath = `/products/{id}/import-bom-items`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importBoMItemsDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [query] 
         * @param {Array<string>} [division] 
         * @param {Array<string>} [season] 
         * @param {Array<string>} [year] 
         * @param {Array<string>} [brand] 
         * @param {Array<string>} [customFields] 
         * @param {boolean} [canceled] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {Array<string>} [category] 
         * @param {string} [code] 
         * @param {string} [name] 
         * @param {string} [exactMatch] 
         * @param {string} [sort] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerQueryProducts: async (query?: string, division?: Array<string>, season?: Array<string>, year?: Array<string>, brand?: Array<string>, customFields?: Array<string>, canceled?: boolean, updatedAtStart?: string, updatedAtEnd?: string, category?: Array<string>, code?: string, name?: string, exactMatch?: string, sort?: string, skip?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (division) {
                localVarQueryParameter['division'] = division;
            }

            if (season) {
                localVarQueryParameter['season'] = season;
            }

            if (year) {
                localVarQueryParameter['year'] = year;
            }

            if (brand) {
                localVarQueryParameter['brand'] = brand;
            }

            if (customFields) {
                localVarQueryParameter['custom_fields'] = customFields;
            }

            if (canceled !== undefined) {
                localVarQueryParameter['canceled'] = canceled;
            }

            if (updatedAtStart !== undefined) {
                localVarQueryParameter['updatedAtStart'] = (updatedAtStart as any instanceof Date) ?
                    (updatedAtStart as any).toISOString() :
                    updatedAtStart;
            }

            if (updatedAtEnd !== undefined) {
                localVarQueryParameter['updatedAtEnd'] = (updatedAtEnd as any instanceof Date) ?
                    (updatedAtEnd as any).toISOString() :
                    updatedAtEnd;
            }

            if (category) {
                localVarQueryParameter['category'] = category;
            }

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (exactMatch !== undefined) {
                localVarQueryParameter['exactMatch'] = exactMatch;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerUpdateProduct: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productsControllerUpdateProduct', 'id', id)
            const localVarPath = `/products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductsApi - functional programming interface
 * @export
 */
export const ProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateProductDTO} createProductDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsControllerCreateProduct(createProductDTO: CreateProductDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsControllerCreateProduct(createProductDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsControllerCreateProductCopy(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Product>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsControllerCreateProductCopy(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsControllerDeleteProduct(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsControllerDeleteProduct(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {EmailProductTechpackDto} emailProductTechpackDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsControllerEmailTechpack(emailProductTechpackDto: EmailProductTechpackDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsControllerEmailTechpack(emailProductTechpackDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsControllerGetConvertedProduct(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsControllerGetConvertedProduct(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsControllerGetProductById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsControllerGetProductById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ImportBoMItemsDTO} importBoMItemsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsControllerImportBomTemplateToProduct(id: string, importBoMItemsDTO: ImportBoMItemsDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsControllerImportBomTemplateToProduct(id, importBoMItemsDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [query] 
         * @param {Array<string>} [division] 
         * @param {Array<string>} [season] 
         * @param {Array<string>} [year] 
         * @param {Array<string>} [brand] 
         * @param {Array<string>} [customFields] 
         * @param {boolean} [canceled] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {Array<string>} [category] 
         * @param {string} [code] 
         * @param {string} [name] 
         * @param {string} [exactMatch] 
         * @param {string} [sort] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsControllerQueryProducts(query?: string, division?: Array<string>, season?: Array<string>, year?: Array<string>, brand?: Array<string>, customFields?: Array<string>, canceled?: boolean, updatedAtStart?: string, updatedAtEnd?: string, category?: Array<string>, code?: string, name?: string, exactMatch?: string, sort?: string, skip?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductsControllerQueryProducts200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsControllerQueryProducts(query, division, season, year, brand, customFields, canceled, updatedAtStart, updatedAtEnd, category, code, name, exactMatch, sort, skip, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsControllerUpdateProduct(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsControllerUpdateProduct(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductsApi - factory interface
 * @export
 */
export const ProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateProductDTO} createProductDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerCreateProduct(createProductDTO: CreateProductDTO, options?: any): AxiosPromise<object> {
            return localVarFp.productsControllerCreateProduct(createProductDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerCreateProductCopy(id: string, options?: any): AxiosPromise<Product> {
            return localVarFp.productsControllerCreateProductCopy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerDeleteProduct(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.productsControllerDeleteProduct(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmailProductTechpackDto} emailProductTechpackDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerEmailTechpack(emailProductTechpackDto: EmailProductTechpackDto, options?: any): AxiosPromise<void> {
            return localVarFp.productsControllerEmailTechpack(emailProductTechpackDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerGetConvertedProduct(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.productsControllerGetConvertedProduct(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerGetProductById(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.productsControllerGetProductById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ImportBoMItemsDTO} importBoMItemsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerImportBomTemplateToProduct(id: string, importBoMItemsDTO: ImportBoMItemsDTO, options?: any): AxiosPromise<object> {
            return localVarFp.productsControllerImportBomTemplateToProduct(id, importBoMItemsDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [query] 
         * @param {Array<string>} [division] 
         * @param {Array<string>} [season] 
         * @param {Array<string>} [year] 
         * @param {Array<string>} [brand] 
         * @param {Array<string>} [customFields] 
         * @param {boolean} [canceled] 
         * @param {string} [updatedAtStart] 
         * @param {string} [updatedAtEnd] 
         * @param {Array<string>} [category] 
         * @param {string} [code] 
         * @param {string} [name] 
         * @param {string} [exactMatch] 
         * @param {string} [sort] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerQueryProducts(query?: string, division?: Array<string>, season?: Array<string>, year?: Array<string>, brand?: Array<string>, customFields?: Array<string>, canceled?: boolean, updatedAtStart?: string, updatedAtEnd?: string, category?: Array<string>, code?: string, name?: string, exactMatch?: string, sort?: string, skip?: number, limit?: number, options?: any): AxiosPromise<ProductsControllerQueryProducts200Response> {
            return localVarFp.productsControllerQueryProducts(query, division, season, year, brand, customFields, canceled, updatedAtStart, updatedAtEnd, category, code, name, exactMatch, sort, skip, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsControllerUpdateProduct(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.productsControllerUpdateProduct(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductsApi - object-oriented interface
 * @export
 * @class ProductsApi
 * @extends {BaseAPI}
 */
export class ProductsApi extends BaseAPI {
    /**
     * 
     * @param {CreateProductDTO} createProductDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productsControllerCreateProduct(createProductDTO: CreateProductDTO, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).productsControllerCreateProduct(createProductDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productsControllerCreateProductCopy(id: string, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).productsControllerCreateProductCopy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productsControllerDeleteProduct(id: string, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).productsControllerDeleteProduct(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmailProductTechpackDto} emailProductTechpackDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productsControllerEmailTechpack(emailProductTechpackDto: EmailProductTechpackDto, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).productsControllerEmailTechpack(emailProductTechpackDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productsControllerGetConvertedProduct(id: string, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).productsControllerGetConvertedProduct(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productsControllerGetProductById(id: string, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).productsControllerGetProductById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ImportBoMItemsDTO} importBoMItemsDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productsControllerImportBomTemplateToProduct(id: string, importBoMItemsDTO: ImportBoMItemsDTO, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).productsControllerImportBomTemplateToProduct(id, importBoMItemsDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [query] 
     * @param {Array<string>} [division] 
     * @param {Array<string>} [season] 
     * @param {Array<string>} [year] 
     * @param {Array<string>} [brand] 
     * @param {Array<string>} [customFields] 
     * @param {boolean} [canceled] 
     * @param {string} [updatedAtStart] 
     * @param {string} [updatedAtEnd] 
     * @param {Array<string>} [category] 
     * @param {string} [code] 
     * @param {string} [name] 
     * @param {string} [exactMatch] 
     * @param {string} [sort] 
     * @param {number} [skip] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productsControllerQueryProducts(query?: string, division?: Array<string>, season?: Array<string>, year?: Array<string>, brand?: Array<string>, customFields?: Array<string>, canceled?: boolean, updatedAtStart?: string, updatedAtEnd?: string, category?: Array<string>, code?: string, name?: string, exactMatch?: string, sort?: string, skip?: number, limit?: number, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).productsControllerQueryProducts(query, division, season, year, brand, customFields, canceled, updatedAtStart, updatedAtEnd, category, code, name, exactMatch, sort, skip, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productsControllerUpdateProduct(id: string, options?: AxiosRequestConfig) {
        return ProductsApiFp(this.configuration).productsControllerUpdateProduct(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductsBomItemsApi - axios parameter creator
 * @export
 */
export const ProductsBomItemsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id Product Id
         * @param {CreateBomItemDTO} createBomItemDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsBomItemsControllerCreateBomItem: async (id: string, createBomItemDTO: CreateBomItemDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productsBomItemsControllerCreateBomItem', 'id', id)
            // verify required parameter 'createBomItemDTO' is not null or undefined
            assertParamExists('productsBomItemsControllerCreateBomItem', 'createBomItemDTO', createBomItemDTO)
            const localVarPath = `/products/{id}/bom-items`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBomItemDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Product Id
         * @param {DeleteBomItemsRequestDTO} deleteBomItemsRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsBomItemsControllerDeleteBomItems: async (id: string, deleteBomItemsRequestDTO: DeleteBomItemsRequestDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productsBomItemsControllerDeleteBomItems', 'id', id)
            // verify required parameter 'deleteBomItemsRequestDTO' is not null or undefined
            assertParamExists('productsBomItemsControllerDeleteBomItems', 'deleteBomItemsRequestDTO', deleteBomItemsRequestDTO)
            const localVarPath = `/products/{id}/bom-items`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteBomItemsRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsBomItemsControllerGetProductWithBomItems: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productsBomItemsControllerGetProductWithBomItems', 'id', id)
            const localVarPath = `/products/{id}/bom-items`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductsBomItemsApi - functional programming interface
 * @export
 */
export const ProductsBomItemsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductsBomItemsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id Product Id
         * @param {CreateBomItemDTO} createBomItemDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsBomItemsControllerCreateBomItem(id: string, createBomItemDTO: CreateBomItemDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Product>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsBomItemsControllerCreateBomItem(id, createBomItemDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id Product Id
         * @param {DeleteBomItemsRequestDTO} deleteBomItemsRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsBomItemsControllerDeleteBomItems(id: string, deleteBomItemsRequestDTO: DeleteBomItemsRequestDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteBomItemsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsBomItemsControllerDeleteBomItems(id, deleteBomItemsRequestDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsBomItemsControllerGetProductWithBomItems(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductBomResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsBomItemsControllerGetProductWithBomItems(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductsBomItemsApi - factory interface
 * @export
 */
export const ProductsBomItemsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductsBomItemsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id Product Id
         * @param {CreateBomItemDTO} createBomItemDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsBomItemsControllerCreateBomItem(id: string, createBomItemDTO: CreateBomItemDTO, options?: any): AxiosPromise<Product> {
            return localVarFp.productsBomItemsControllerCreateBomItem(id, createBomItemDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Product Id
         * @param {DeleteBomItemsRequestDTO} deleteBomItemsRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsBomItemsControllerDeleteBomItems(id: string, deleteBomItemsRequestDTO: DeleteBomItemsRequestDTO, options?: any): AxiosPromise<DeleteBomItemsResponseDTO> {
            return localVarFp.productsBomItemsControllerDeleteBomItems(id, deleteBomItemsRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsBomItemsControllerGetProductWithBomItems(id: string, options?: any): AxiosPromise<ProductBomResponse> {
            return localVarFp.productsBomItemsControllerGetProductWithBomItems(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductsBomItemsApi - object-oriented interface
 * @export
 * @class ProductsBomItemsApi
 * @extends {BaseAPI}
 */
export class ProductsBomItemsApi extends BaseAPI {
    /**
     * 
     * @param {string} id Product Id
     * @param {CreateBomItemDTO} createBomItemDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsBomItemsApi
     */
    public productsBomItemsControllerCreateBomItem(id: string, createBomItemDTO: CreateBomItemDTO, options?: AxiosRequestConfig) {
        return ProductsBomItemsApiFp(this.configuration).productsBomItemsControllerCreateBomItem(id, createBomItemDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Product Id
     * @param {DeleteBomItemsRequestDTO} deleteBomItemsRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsBomItemsApi
     */
    public productsBomItemsControllerDeleteBomItems(id: string, deleteBomItemsRequestDTO: DeleteBomItemsRequestDTO, options?: AxiosRequestConfig) {
        return ProductsBomItemsApiFp(this.configuration).productsBomItemsControllerDeleteBomItems(id, deleteBomItemsRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Product Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsBomItemsApi
     */
    public productsBomItemsControllerGetProductWithBomItems(id: string, options?: AxiosRequestConfig) {
        return ProductsBomItemsApiFp(this.configuration).productsBomItemsControllerGetProductWithBomItems(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductsFilesApi - axios parameter creator
 * @export
 */
export const ProductsFilesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} fileId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productFilesControllerAddFile: async (fileId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('productFilesControllerAddFile', 'fileId', fileId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productFilesControllerAddFile', 'id', id)
            const localVarPath = `/products/{id}/files/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateFileDto} createFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productFilesControllerCreateFile: async (id: string, createFileDto: CreateFileDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productFilesControllerCreateFile', 'id', id)
            // verify required parameter 'createFileDto' is not null or undefined
            assertParamExists('productFilesControllerCreateFile', 'createFileDto', createFileDto)
            const localVarPath = `/products/{id}/files`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fileId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productFilesControllerRemoveFile: async (fileId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('productFilesControllerRemoveFile', 'fileId', fileId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productFilesControllerRemoveFile', 'id', id)
            const localVarPath = `/products/{id}/files/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductsFilesApi - functional programming interface
 * @export
 */
export const ProductsFilesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductsFilesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} fileId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productFilesControllerAddFile(fileId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productFilesControllerAddFile(fileId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateFileDto} createFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productFilesControllerCreateFile(id: string, createFileDto: CreateFileDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productFilesControllerCreateFile(id, createFileDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} fileId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productFilesControllerRemoveFile(fileId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productFilesControllerRemoveFile(fileId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductsFilesApi - factory interface
 * @export
 */
export const ProductsFilesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductsFilesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} fileId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productFilesControllerAddFile(fileId: string, id: string, options?: any): AxiosPromise<object> {
            return localVarFp.productFilesControllerAddFile(fileId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateFileDto} createFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productFilesControllerCreateFile(id: string, createFileDto: CreateFileDto, options?: any): AxiosPromise<object> {
            return localVarFp.productFilesControllerCreateFile(id, createFileDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} fileId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productFilesControllerRemoveFile(fileId: string, id: string, options?: any): AxiosPromise<object> {
            return localVarFp.productFilesControllerRemoveFile(fileId, id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductsFilesApi - object-oriented interface
 * @export
 * @class ProductsFilesApi
 * @extends {BaseAPI}
 */
export class ProductsFilesApi extends BaseAPI {
    /**
     * 
     * @param {string} fileId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsFilesApi
     */
    public productFilesControllerAddFile(fileId: string, id: string, options?: AxiosRequestConfig) {
        return ProductsFilesApiFp(this.configuration).productFilesControllerAddFile(fileId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {CreateFileDto} createFileDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsFilesApi
     */
    public productFilesControllerCreateFile(id: string, createFileDto: CreateFileDto, options?: AxiosRequestConfig) {
        return ProductsFilesApiFp(this.configuration).productFilesControllerCreateFile(id, createFileDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} fileId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsFilesApi
     */
    public productFilesControllerRemoveFile(fileId: string, id: string, options?: AxiosRequestConfig) {
        return ProductsFilesApiFp(this.configuration).productFilesControllerRemoveFile(fileId, id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductsImagesApi - axios parameter creator
 * @export
 */
export const ProductsImagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id Product Id
         * @param {CreateImageDTO} createImageDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsImagesControllerAddImageToProduct: async (id: string, createImageDTO: CreateImageDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productsImagesControllerAddImageToProduct', 'id', id)
            // verify required parameter 'createImageDTO' is not null or undefined
            assertParamExists('productsImagesControllerAddImageToProduct', 'createImageDTO', createImageDTO)
            const localVarPath = `/products/{id}/images`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createImageDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Product Id
         * @param {DeleteProductImagesDTO} deleteProductImagesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsImagesControllerBulkDeleteProductImages: async (id: string, deleteProductImagesDTO: DeleteProductImagesDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productsImagesControllerBulkDeleteProductImages', 'id', id)
            // verify required parameter 'deleteProductImagesDTO' is not null or undefined
            assertParamExists('productsImagesControllerBulkDeleteProductImages', 'deleteProductImagesDTO', deleteProductImagesDTO)
            const localVarPath = `/products/{id}/images/bulk`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteProductImagesDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsImagesControllerBulkUpdateProductImages: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productsImagesControllerBulkUpdateProductImages', 'id', id)
            const localVarPath = `/products/{id}/images`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Product Id
         * @param {CopyProductImageAnnotationDTO} copyProductImageAnnotationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsImagesControllerCopyAnnotation: async (id: string, copyProductImageAnnotationDTO: CopyProductImageAnnotationDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productsImagesControllerCopyAnnotation', 'id', id)
            // verify required parameter 'copyProductImageAnnotationDTO' is not null or undefined
            assertParamExists('productsImagesControllerCopyAnnotation', 'copyProductImageAnnotationDTO', copyProductImageAnnotationDTO)
            const localVarPath = `/products/{id}/images/copy-annotation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(copyProductImageAnnotationDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} imageId Image Id
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsImagesControllerCopyProductImage: async (imageId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('productsImagesControllerCopyProductImage', 'imageId', imageId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productsImagesControllerCopyProductImage', 'id', id)
            const localVarPath = `/products/{id}/images/{imageId}/copy`
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} imageId Image Id
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsImagesControllerDeleteProductImage: async (imageId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('productsImagesControllerDeleteProductImage', 'imageId', imageId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productsImagesControllerDeleteProductImage', 'id', id)
            const localVarPath = `/products/{id}/images/{imageId}`
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsImagesControllerGetImages: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productsImagesControllerGetImages', 'id', id)
            const localVarPath = `/products/{id}/images`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsImagesControllerGetSourceFiles: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productsImagesControllerGetSourceFiles', 'id', id)
            const localVarPath = `/products/{id}/images/source-files`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} imageId Image Id
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsImagesControllerUpdateProductImage: async (imageId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('productsImagesControllerUpdateProductImage', 'imageId', imageId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productsImagesControllerUpdateProductImage', 'id', id)
            const localVarPath = `/products/{id}/images/{imageId}`
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductsImagesApi - functional programming interface
 * @export
 */
export const ProductsImagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductsImagesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id Product Id
         * @param {CreateImageDTO} createImageDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsImagesControllerAddImageToProduct(id: string, createImageDTO: CreateImageDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Product>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsImagesControllerAddImageToProduct(id, createImageDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id Product Id
         * @param {DeleteProductImagesDTO} deleteProductImagesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsImagesControllerBulkDeleteProductImages(id: string, deleteProductImagesDTO: DeleteProductImagesDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsImagesControllerBulkDeleteProductImages(id, deleteProductImagesDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsImagesControllerBulkUpdateProductImages(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Product>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsImagesControllerBulkUpdateProductImages(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id Product Id
         * @param {CopyProductImageAnnotationDTO} copyProductImageAnnotationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsImagesControllerCopyAnnotation(id: string, copyProductImageAnnotationDTO: CopyProductImageAnnotationDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsImagesControllerCopyAnnotation(id, copyProductImageAnnotationDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} imageId Image Id
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsImagesControllerCopyProductImage(imageId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Product>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsImagesControllerCopyProductImage(imageId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} imageId Image Id
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsImagesControllerDeleteProductImage(imageId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsImagesControllerDeleteProductImage(imageId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsImagesControllerGetImages(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TechpackImage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsImagesControllerGetImages(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsImagesControllerGetSourceFiles(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SourceFile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsImagesControllerGetSourceFiles(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} imageId Image Id
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsImagesControllerUpdateProductImage(imageId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Product>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsImagesControllerUpdateProductImage(imageId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductsImagesApi - factory interface
 * @export
 */
export const ProductsImagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductsImagesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id Product Id
         * @param {CreateImageDTO} createImageDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsImagesControllerAddImageToProduct(id: string, createImageDTO: CreateImageDTO, options?: any): AxiosPromise<Product> {
            return localVarFp.productsImagesControllerAddImageToProduct(id, createImageDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Product Id
         * @param {DeleteProductImagesDTO} deleteProductImagesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsImagesControllerBulkDeleteProductImages(id: string, deleteProductImagesDTO: DeleteProductImagesDTO, options?: any): AxiosPromise<void> {
            return localVarFp.productsImagesControllerBulkDeleteProductImages(id, deleteProductImagesDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsImagesControllerBulkUpdateProductImages(id: string, options?: any): AxiosPromise<Product> {
            return localVarFp.productsImagesControllerBulkUpdateProductImages(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Product Id
         * @param {CopyProductImageAnnotationDTO} copyProductImageAnnotationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsImagesControllerCopyAnnotation(id: string, copyProductImageAnnotationDTO: CopyProductImageAnnotationDTO, options?: any): AxiosPromise<void> {
            return localVarFp.productsImagesControllerCopyAnnotation(id, copyProductImageAnnotationDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} imageId Image Id
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsImagesControllerCopyProductImage(imageId: string, id: string, options?: any): AxiosPromise<Product> {
            return localVarFp.productsImagesControllerCopyProductImage(imageId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} imageId Image Id
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsImagesControllerDeleteProductImage(imageId: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.productsImagesControllerDeleteProductImage(imageId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsImagesControllerGetImages(id: string, options?: any): AxiosPromise<TechpackImage> {
            return localVarFp.productsImagesControllerGetImages(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsImagesControllerGetSourceFiles(id: string, options?: any): AxiosPromise<SourceFile> {
            return localVarFp.productsImagesControllerGetSourceFiles(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} imageId Image Id
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsImagesControllerUpdateProductImage(imageId: string, id: string, options?: any): AxiosPromise<Product> {
            return localVarFp.productsImagesControllerUpdateProductImage(imageId, id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductsImagesApi - object-oriented interface
 * @export
 * @class ProductsImagesApi
 * @extends {BaseAPI}
 */
export class ProductsImagesApi extends BaseAPI {
    /**
     * 
     * @param {string} id Product Id
     * @param {CreateImageDTO} createImageDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsImagesApi
     */
    public productsImagesControllerAddImageToProduct(id: string, createImageDTO: CreateImageDTO, options?: AxiosRequestConfig) {
        return ProductsImagesApiFp(this.configuration).productsImagesControllerAddImageToProduct(id, createImageDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Product Id
     * @param {DeleteProductImagesDTO} deleteProductImagesDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsImagesApi
     */
    public productsImagesControllerBulkDeleteProductImages(id: string, deleteProductImagesDTO: DeleteProductImagesDTO, options?: AxiosRequestConfig) {
        return ProductsImagesApiFp(this.configuration).productsImagesControllerBulkDeleteProductImages(id, deleteProductImagesDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Product Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsImagesApi
     */
    public productsImagesControllerBulkUpdateProductImages(id: string, options?: AxiosRequestConfig) {
        return ProductsImagesApiFp(this.configuration).productsImagesControllerBulkUpdateProductImages(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Product Id
     * @param {CopyProductImageAnnotationDTO} copyProductImageAnnotationDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsImagesApi
     */
    public productsImagesControllerCopyAnnotation(id: string, copyProductImageAnnotationDTO: CopyProductImageAnnotationDTO, options?: AxiosRequestConfig) {
        return ProductsImagesApiFp(this.configuration).productsImagesControllerCopyAnnotation(id, copyProductImageAnnotationDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} imageId Image Id
     * @param {string} id Product Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsImagesApi
     */
    public productsImagesControllerCopyProductImage(imageId: string, id: string, options?: AxiosRequestConfig) {
        return ProductsImagesApiFp(this.configuration).productsImagesControllerCopyProductImage(imageId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} imageId Image Id
     * @param {string} id Product Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsImagesApi
     */
    public productsImagesControllerDeleteProductImage(imageId: string, id: string, options?: AxiosRequestConfig) {
        return ProductsImagesApiFp(this.configuration).productsImagesControllerDeleteProductImage(imageId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Product Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsImagesApi
     */
    public productsImagesControllerGetImages(id: string, options?: AxiosRequestConfig) {
        return ProductsImagesApiFp(this.configuration).productsImagesControllerGetImages(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Product Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsImagesApi
     */
    public productsImagesControllerGetSourceFiles(id: string, options?: AxiosRequestConfig) {
        return ProductsImagesApiFp(this.configuration).productsImagesControllerGetSourceFiles(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} imageId Image Id
     * @param {string} id Product Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsImagesApi
     */
    public productsImagesControllerUpdateProductImage(imageId: string, id: string, options?: AxiosRequestConfig) {
        return ProductsImagesApiFp(this.configuration).productsImagesControllerUpdateProductImage(imageId, id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductsSamplesApi - axios parameter creator
 * @export
 */
export const ProductsSamplesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSamplesControllerAddFlexColumnToProduct: async (productId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('productsSamplesControllerAddFlexColumnToProduct', 'productId', productId)
            const localVarPath = `/products/{productId}/flex-columns`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSamplesControllerBulkRemoveSamples: async (productId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('productsSamplesControllerBulkRemoveSamples', 'productId', productId)
            const localVarPath = `/products/{productId}/samples`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sampleId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSamplesControllerCreateMeasurementSet: async (sampleId: string, productId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sampleId' is not null or undefined
            assertParamExists('productsSamplesControllerCreateMeasurementSet', 'sampleId', sampleId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('productsSamplesControllerCreateMeasurementSet', 'productId', productId)
            const localVarPath = `/products/{productId}/samples/{sampleId}/measurement-sets`
                .replace(`{${"sampleId"}}`, encodeURIComponent(String(sampleId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSamplesControllerCreateSample: async (productId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('productsSamplesControllerCreateSample', 'productId', productId)
            const localVarPath = `/products/{productId}/samples`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} measurementSetId 
         * @param {string} sampleId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSamplesControllerDeleteMeasurementSet: async (measurementSetId: string, sampleId: string, productId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'measurementSetId' is not null or undefined
            assertParamExists('productsSamplesControllerDeleteMeasurementSet', 'measurementSetId', measurementSetId)
            // verify required parameter 'sampleId' is not null or undefined
            assertParamExists('productsSamplesControllerDeleteMeasurementSet', 'sampleId', sampleId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('productsSamplesControllerDeleteMeasurementSet', 'productId', productId)
            const localVarPath = `/products/{productId}/samples/{sampleId}/measurement-sets/{measurementSetId}`
                .replace(`{${"measurementSetId"}}`, encodeURIComponent(String(measurementSetId)))
                .replace(`{${"sampleId"}}`, encodeURIComponent(String(sampleId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sampleId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSamplesControllerDeleteSample: async (sampleId: string, productId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sampleId' is not null or undefined
            assertParamExists('productsSamplesControllerDeleteSample', 'sampleId', sampleId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('productsSamplesControllerDeleteSample', 'productId', productId)
            const localVarPath = `/products/{productId}/samples/{sampleId}`
                .replace(`{${"sampleId"}}`, encodeURIComponent(String(sampleId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sampleId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSamplesControllerGetConvertedSample: async (sampleId: string, productId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sampleId' is not null or undefined
            assertParamExists('productsSamplesControllerGetConvertedSample', 'sampleId', sampleId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('productsSamplesControllerGetConvertedSample', 'productId', productId)
            const localVarPath = `/products/{productId}/converted-samples/{sampleId}`
                .replace(`{${"sampleId"}}`, encodeURIComponent(String(sampleId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSamplesControllerGetConvertedSamples: async (productId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('productsSamplesControllerGetConvertedSamples', 'productId', productId)
            const localVarPath = `/products/{productId}/converted-samples`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSamplesControllerGetSamples: async (productId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('productsSamplesControllerGetSamples', 'productId', productId)
            const localVarPath = `/products/{productId}/samples`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} measurementSetId 
         * @param {string} sampleId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSamplesControllerUpdateMeasurementSet: async (measurementSetId: string, sampleId: string, productId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'measurementSetId' is not null or undefined
            assertParamExists('productsSamplesControllerUpdateMeasurementSet', 'measurementSetId', measurementSetId)
            // verify required parameter 'sampleId' is not null or undefined
            assertParamExists('productsSamplesControllerUpdateMeasurementSet', 'sampleId', sampleId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('productsSamplesControllerUpdateMeasurementSet', 'productId', productId)
            const localVarPath = `/products/{productId}/samples/{sampleId}/measurement-sets/{measurementSetId}`
                .replace(`{${"measurementSetId"}}`, encodeURIComponent(String(measurementSetId)))
                .replace(`{${"sampleId"}}`, encodeURIComponent(String(sampleId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sampleId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSamplesControllerUpdateSample: async (sampleId: string, productId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sampleId' is not null or undefined
            assertParamExists('productsSamplesControllerUpdateSample', 'sampleId', sampleId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('productsSamplesControllerUpdateSample', 'productId', productId)
            const localVarPath = `/products/{productId}/samples/{sampleId}`
                .replace(`{${"sampleId"}}`, encodeURIComponent(String(sampleId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductsSamplesApi - functional programming interface
 * @export
 */
export const ProductsSamplesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductsSamplesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsSamplesControllerAddFlexColumnToProduct(productId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sample>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsSamplesControllerAddFlexColumnToProduct(productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsSamplesControllerBulkRemoveSamples(productId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Product>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsSamplesControllerBulkRemoveSamples(productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} sampleId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsSamplesControllerCreateMeasurementSet(sampleId: string, productId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sample>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsSamplesControllerCreateMeasurementSet(sampleId, productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsSamplesControllerCreateSample(productId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Product>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsSamplesControllerCreateSample(productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} measurementSetId 
         * @param {string} sampleId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsSamplesControllerDeleteMeasurementSet(measurementSetId: string, sampleId: string, productId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sample>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsSamplesControllerDeleteMeasurementSet(measurementSetId, sampleId, productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} sampleId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsSamplesControllerDeleteSample(sampleId: string, productId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Product>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsSamplesControllerDeleteSample(sampleId, productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} sampleId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsSamplesControllerGetConvertedSample(sampleId: string, productId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sample>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsSamplesControllerGetConvertedSample(sampleId, productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsSamplesControllerGetConvertedSamples(productId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sample>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsSamplesControllerGetConvertedSamples(productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsSamplesControllerGetSamples(productId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sample>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsSamplesControllerGetSamples(productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} measurementSetId 
         * @param {string} sampleId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsSamplesControllerUpdateMeasurementSet(measurementSetId: string, sampleId: string, productId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sample>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsSamplesControllerUpdateMeasurementSet(measurementSetId, sampleId, productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} sampleId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsSamplesControllerUpdateSample(sampleId: string, productId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sample>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsSamplesControllerUpdateSample(sampleId, productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductsSamplesApi - factory interface
 * @export
 */
export const ProductsSamplesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductsSamplesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSamplesControllerAddFlexColumnToProduct(productId: string, options?: any): AxiosPromise<Sample> {
            return localVarFp.productsSamplesControllerAddFlexColumnToProduct(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSamplesControllerBulkRemoveSamples(productId: string, options?: any): AxiosPromise<Product> {
            return localVarFp.productsSamplesControllerBulkRemoveSamples(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sampleId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSamplesControllerCreateMeasurementSet(sampleId: string, productId: string, options?: any): AxiosPromise<Sample> {
            return localVarFp.productsSamplesControllerCreateMeasurementSet(sampleId, productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSamplesControllerCreateSample(productId: string, options?: any): AxiosPromise<Product> {
            return localVarFp.productsSamplesControllerCreateSample(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} measurementSetId 
         * @param {string} sampleId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSamplesControllerDeleteMeasurementSet(measurementSetId: string, sampleId: string, productId: string, options?: any): AxiosPromise<Sample> {
            return localVarFp.productsSamplesControllerDeleteMeasurementSet(measurementSetId, sampleId, productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sampleId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSamplesControllerDeleteSample(sampleId: string, productId: string, options?: any): AxiosPromise<Product> {
            return localVarFp.productsSamplesControllerDeleteSample(sampleId, productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sampleId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSamplesControllerGetConvertedSample(sampleId: string, productId: string, options?: any): AxiosPromise<Sample> {
            return localVarFp.productsSamplesControllerGetConvertedSample(sampleId, productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSamplesControllerGetConvertedSamples(productId: string, options?: any): AxiosPromise<Sample> {
            return localVarFp.productsSamplesControllerGetConvertedSamples(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSamplesControllerGetSamples(productId: string, options?: any): AxiosPromise<Sample> {
            return localVarFp.productsSamplesControllerGetSamples(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} measurementSetId 
         * @param {string} sampleId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSamplesControllerUpdateMeasurementSet(measurementSetId: string, sampleId: string, productId: string, options?: any): AxiosPromise<Sample> {
            return localVarFp.productsSamplesControllerUpdateMeasurementSet(measurementSetId, sampleId, productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sampleId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSamplesControllerUpdateSample(sampleId: string, productId: string, options?: any): AxiosPromise<Sample> {
            return localVarFp.productsSamplesControllerUpdateSample(sampleId, productId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductsSamplesApi - object-oriented interface
 * @export
 * @class ProductsSamplesApi
 * @extends {BaseAPI}
 */
export class ProductsSamplesApi extends BaseAPI {
    /**
     * 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsSamplesApi
     */
    public productsSamplesControllerAddFlexColumnToProduct(productId: string, options?: AxiosRequestConfig) {
        return ProductsSamplesApiFp(this.configuration).productsSamplesControllerAddFlexColumnToProduct(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsSamplesApi
     */
    public productsSamplesControllerBulkRemoveSamples(productId: string, options?: AxiosRequestConfig) {
        return ProductsSamplesApiFp(this.configuration).productsSamplesControllerBulkRemoveSamples(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sampleId 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsSamplesApi
     */
    public productsSamplesControllerCreateMeasurementSet(sampleId: string, productId: string, options?: AxiosRequestConfig) {
        return ProductsSamplesApiFp(this.configuration).productsSamplesControllerCreateMeasurementSet(sampleId, productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsSamplesApi
     */
    public productsSamplesControllerCreateSample(productId: string, options?: AxiosRequestConfig) {
        return ProductsSamplesApiFp(this.configuration).productsSamplesControllerCreateSample(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} measurementSetId 
     * @param {string} sampleId 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsSamplesApi
     */
    public productsSamplesControllerDeleteMeasurementSet(measurementSetId: string, sampleId: string, productId: string, options?: AxiosRequestConfig) {
        return ProductsSamplesApiFp(this.configuration).productsSamplesControllerDeleteMeasurementSet(measurementSetId, sampleId, productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sampleId 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsSamplesApi
     */
    public productsSamplesControllerDeleteSample(sampleId: string, productId: string, options?: AxiosRequestConfig) {
        return ProductsSamplesApiFp(this.configuration).productsSamplesControllerDeleteSample(sampleId, productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sampleId 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsSamplesApi
     */
    public productsSamplesControllerGetConvertedSample(sampleId: string, productId: string, options?: AxiosRequestConfig) {
        return ProductsSamplesApiFp(this.configuration).productsSamplesControllerGetConvertedSample(sampleId, productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsSamplesApi
     */
    public productsSamplesControllerGetConvertedSamples(productId: string, options?: AxiosRequestConfig) {
        return ProductsSamplesApiFp(this.configuration).productsSamplesControllerGetConvertedSamples(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsSamplesApi
     */
    public productsSamplesControllerGetSamples(productId: string, options?: AxiosRequestConfig) {
        return ProductsSamplesApiFp(this.configuration).productsSamplesControllerGetSamples(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} measurementSetId 
     * @param {string} sampleId 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsSamplesApi
     */
    public productsSamplesControllerUpdateMeasurementSet(measurementSetId: string, sampleId: string, productId: string, options?: AxiosRequestConfig) {
        return ProductsSamplesApiFp(this.configuration).productsSamplesControllerUpdateMeasurementSet(measurementSetId, sampleId, productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sampleId 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsSamplesApi
     */
    public productsSamplesControllerUpdateSample(sampleId: string, productId: string, options?: AxiosRequestConfig) {
        return ProductsSamplesApiFp(this.configuration).productsSamplesControllerUpdateSample(sampleId, productId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductsSizeSpecsApi - axios parameter creator
 * @export
 */
export const ProductsSizeSpecsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} sizeSpecId 
         * @param {string} productId 
         * @param {BulkDeletePomsDTO} bulkDeletePomsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSizeSpecControllerBulkDeleteSpecPoms: async (sizeSpecId: string, productId: string, bulkDeletePomsDTO: BulkDeletePomsDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sizeSpecId' is not null or undefined
            assertParamExists('productsSizeSpecControllerBulkDeleteSpecPoms', 'sizeSpecId', sizeSpecId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('productsSizeSpecControllerBulkDeleteSpecPoms', 'productId', productId)
            // verify required parameter 'bulkDeletePomsDTO' is not null or undefined
            assertParamExists('productsSizeSpecControllerBulkDeleteSpecPoms', 'bulkDeletePomsDTO', bulkDeletePomsDTO)
            const localVarPath = `/products/{productId}/size-spec/{sizeSpecId}/points-of-measure`
                .replace(`{${"sizeSpecId"}}`, encodeURIComponent(String(sizeSpecId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkDeletePomsDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sizeSpecId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSizeSpecControllerClearSizeSpec: async (sizeSpecId: string, productId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sizeSpecId' is not null or undefined
            assertParamExists('productsSizeSpecControllerClearSizeSpec', 'sizeSpecId', sizeSpecId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('productsSizeSpecControllerClearSizeSpec', 'productId', productId)
            const localVarPath = `/products/{productId}/size-spec/{sizeSpecId}/clear`
                .replace(`{${"sizeSpecId"}}`, encodeURIComponent(String(sizeSpecId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sizeSpecId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSizeSpecControllerGetConvertedSpec: async (sizeSpecId: string, productId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sizeSpecId' is not null or undefined
            assertParamExists('productsSizeSpecControllerGetConvertedSpec', 'sizeSpecId', sizeSpecId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('productsSizeSpecControllerGetConvertedSpec', 'productId', productId)
            const localVarPath = `/products/{productId}/size-spec/{sizeSpecId}/converted`
                .replace(`{${"sizeSpecId"}}`, encodeURIComponent(String(sizeSpecId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sizeSpecId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSizeSpecControllerGetProductSizes: async (sizeSpecId: string, productId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sizeSpecId' is not null or undefined
            assertParamExists('productsSizeSpecControllerGetProductSizes', 'sizeSpecId', sizeSpecId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('productsSizeSpecControllerGetProductSizes', 'productId', productId)
            const localVarPath = `/products/{productId}/size-spec/{sizeSpecId}/sizes`
                .replace(`{${"sizeSpecId"}}`, encodeURIComponent(String(sizeSpecId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sizeSpecId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSizeSpecControllerPatchSizeSpec: async (sizeSpecId: string, productId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sizeSpecId' is not null or undefined
            assertParamExists('productsSizeSpecControllerPatchSizeSpec', 'sizeSpecId', sizeSpecId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('productsSizeSpecControllerPatchSizeSpec', 'productId', productId)
            const localVarPath = `/products/{productId}/size-spec/{sizeSpecId}`
                .replace(`{${"sizeSpecId"}}`, encodeURIComponent(String(sizeSpecId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sizeSpecId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSizeSpecControllerReorderSizeSpecPoms: async (sizeSpecId: string, productId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sizeSpecId' is not null or undefined
            assertParamExists('productsSizeSpecControllerReorderSizeSpecPoms', 'sizeSpecId', sizeSpecId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('productsSizeSpecControllerReorderSizeSpecPoms', 'productId', productId)
            const localVarPath = `/products/{productId}/size-spec/{sizeSpecId}/points-of-measure/reorder-poms`
                .replace(`{${"sizeSpecId"}}`, encodeURIComponent(String(sizeSpecId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sizeSpecId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSizeSpecControllerUpdateCurrentUnitOfMeasure: async (sizeSpecId: string, productId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sizeSpecId' is not null or undefined
            assertParamExists('productsSizeSpecControllerUpdateCurrentUnitOfMeasure', 'sizeSpecId', sizeSpecId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('productsSizeSpecControllerUpdateCurrentUnitOfMeasure', 'productId', productId)
            const localVarPath = `/products/{productId}/size-spec/{sizeSpecId}/current-unit-of-measure`
                .replace(`{${"sizeSpecId"}}`, encodeURIComponent(String(sizeSpecId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sizeSpecId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSizeSpecControllerUpdateSizeSpecSizes: async (sizeSpecId: string, productId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sizeSpecId' is not null or undefined
            assertParamExists('productsSizeSpecControllerUpdateSizeSpecSizes', 'sizeSpecId', sizeSpecId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('productsSizeSpecControllerUpdateSizeSpecSizes', 'productId', productId)
            const localVarPath = `/products/{productId}/size-spec/{sizeSpecId}/sizes`
                .replace(`{${"sizeSpecId"}}`, encodeURIComponent(String(sizeSpecId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductsSizeSpecsApi - functional programming interface
 * @export
 */
export const ProductsSizeSpecsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductsSizeSpecsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} sizeSpecId 
         * @param {string} productId 
         * @param {BulkDeletePomsDTO} bulkDeletePomsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsSizeSpecControllerBulkDeleteSpecPoms(sizeSpecId: string, productId: string, bulkDeletePomsDTO: BulkDeletePomsDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SizeSpec>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsSizeSpecControllerBulkDeleteSpecPoms(sizeSpecId, productId, bulkDeletePomsDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} sizeSpecId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsSizeSpecControllerClearSizeSpec(sizeSpecId: string, productId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Product>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsSizeSpecControllerClearSizeSpec(sizeSpecId, productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} sizeSpecId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsSizeSpecControllerGetConvertedSpec(sizeSpecId: string, productId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SizeSpec>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsSizeSpecControllerGetConvertedSpec(sizeSpecId, productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} sizeSpecId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsSizeSpecControllerGetProductSizes(sizeSpecId: string, productId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsSizeSpecControllerGetProductSizes(sizeSpecId, productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} sizeSpecId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsSizeSpecControllerPatchSizeSpec(sizeSpecId: string, productId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SizeSpec>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsSizeSpecControllerPatchSizeSpec(sizeSpecId, productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} sizeSpecId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsSizeSpecControllerReorderSizeSpecPoms(sizeSpecId: string, productId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SizeSpec>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsSizeSpecControllerReorderSizeSpecPoms(sizeSpecId, productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} sizeSpecId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsSizeSpecControllerUpdateCurrentUnitOfMeasure(sizeSpecId: string, productId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SizeSpec>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsSizeSpecControllerUpdateCurrentUnitOfMeasure(sizeSpecId, productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} sizeSpecId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsSizeSpecControllerUpdateSizeSpecSizes(sizeSpecId: string, productId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SizeSpec>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsSizeSpecControllerUpdateSizeSpecSizes(sizeSpecId, productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductsSizeSpecsApi - factory interface
 * @export
 */
export const ProductsSizeSpecsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductsSizeSpecsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} sizeSpecId 
         * @param {string} productId 
         * @param {BulkDeletePomsDTO} bulkDeletePomsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSizeSpecControllerBulkDeleteSpecPoms(sizeSpecId: string, productId: string, bulkDeletePomsDTO: BulkDeletePomsDTO, options?: any): AxiosPromise<SizeSpec> {
            return localVarFp.productsSizeSpecControllerBulkDeleteSpecPoms(sizeSpecId, productId, bulkDeletePomsDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sizeSpecId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSizeSpecControllerClearSizeSpec(sizeSpecId: string, productId: string, options?: any): AxiosPromise<Product> {
            return localVarFp.productsSizeSpecControllerClearSizeSpec(sizeSpecId, productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sizeSpecId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSizeSpecControllerGetConvertedSpec(sizeSpecId: string, productId: string, options?: any): AxiosPromise<SizeSpec> {
            return localVarFp.productsSizeSpecControllerGetConvertedSpec(sizeSpecId, productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sizeSpecId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSizeSpecControllerGetProductSizes(sizeSpecId: string, productId: string, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.productsSizeSpecControllerGetProductSizes(sizeSpecId, productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sizeSpecId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSizeSpecControllerPatchSizeSpec(sizeSpecId: string, productId: string, options?: any): AxiosPromise<SizeSpec> {
            return localVarFp.productsSizeSpecControllerPatchSizeSpec(sizeSpecId, productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sizeSpecId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSizeSpecControllerReorderSizeSpecPoms(sizeSpecId: string, productId: string, options?: any): AxiosPromise<SizeSpec> {
            return localVarFp.productsSizeSpecControllerReorderSizeSpecPoms(sizeSpecId, productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sizeSpecId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSizeSpecControllerUpdateCurrentUnitOfMeasure(sizeSpecId: string, productId: string, options?: any): AxiosPromise<SizeSpec> {
            return localVarFp.productsSizeSpecControllerUpdateCurrentUnitOfMeasure(sizeSpecId, productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sizeSpecId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsSizeSpecControllerUpdateSizeSpecSizes(sizeSpecId: string, productId: string, options?: any): AxiosPromise<SizeSpec> {
            return localVarFp.productsSizeSpecControllerUpdateSizeSpecSizes(sizeSpecId, productId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductsSizeSpecsApi - object-oriented interface
 * @export
 * @class ProductsSizeSpecsApi
 * @extends {BaseAPI}
 */
export class ProductsSizeSpecsApi extends BaseAPI {
    /**
     * 
     * @param {string} sizeSpecId 
     * @param {string} productId 
     * @param {BulkDeletePomsDTO} bulkDeletePomsDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsSizeSpecsApi
     */
    public productsSizeSpecControllerBulkDeleteSpecPoms(sizeSpecId: string, productId: string, bulkDeletePomsDTO: BulkDeletePomsDTO, options?: AxiosRequestConfig) {
        return ProductsSizeSpecsApiFp(this.configuration).productsSizeSpecControllerBulkDeleteSpecPoms(sizeSpecId, productId, bulkDeletePomsDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sizeSpecId 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsSizeSpecsApi
     */
    public productsSizeSpecControllerClearSizeSpec(sizeSpecId: string, productId: string, options?: AxiosRequestConfig) {
        return ProductsSizeSpecsApiFp(this.configuration).productsSizeSpecControllerClearSizeSpec(sizeSpecId, productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sizeSpecId 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsSizeSpecsApi
     */
    public productsSizeSpecControllerGetConvertedSpec(sizeSpecId: string, productId: string, options?: AxiosRequestConfig) {
        return ProductsSizeSpecsApiFp(this.configuration).productsSizeSpecControllerGetConvertedSpec(sizeSpecId, productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sizeSpecId 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsSizeSpecsApi
     */
    public productsSizeSpecControllerGetProductSizes(sizeSpecId: string, productId: string, options?: AxiosRequestConfig) {
        return ProductsSizeSpecsApiFp(this.configuration).productsSizeSpecControllerGetProductSizes(sizeSpecId, productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sizeSpecId 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsSizeSpecsApi
     */
    public productsSizeSpecControllerPatchSizeSpec(sizeSpecId: string, productId: string, options?: AxiosRequestConfig) {
        return ProductsSizeSpecsApiFp(this.configuration).productsSizeSpecControllerPatchSizeSpec(sizeSpecId, productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sizeSpecId 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsSizeSpecsApi
     */
    public productsSizeSpecControllerReorderSizeSpecPoms(sizeSpecId: string, productId: string, options?: AxiosRequestConfig) {
        return ProductsSizeSpecsApiFp(this.configuration).productsSizeSpecControllerReorderSizeSpecPoms(sizeSpecId, productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sizeSpecId 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsSizeSpecsApi
     */
    public productsSizeSpecControllerUpdateCurrentUnitOfMeasure(sizeSpecId: string, productId: string, options?: AxiosRequestConfig) {
        return ProductsSizeSpecsApiFp(this.configuration).productsSizeSpecControllerUpdateCurrentUnitOfMeasure(sizeSpecId, productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sizeSpecId 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsSizeSpecsApi
     */
    public productsSizeSpecControllerUpdateSizeSpecSizes(sizeSpecId: string, productId: string, options?: AxiosRequestConfig) {
        return ProductsSizeSpecsApiFp(this.configuration).productsSizeSpecControllerUpdateSizeSpecSizes(sizeSpecId, productId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductsVariantsApi - axios parameter creator
 * @export
 */
export const ProductsVariantsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {string} id Product Id
         * @param {CreateVariantsControllerDTO} createVariantsControllerDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreateProductVariants: async (id: string, createVariantsControllerDTO: CreateVariantsControllerDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('bulkCreateProductVariants', 'id', id)
            // verify required parameter 'createVariantsControllerDTO' is not null or undefined
            assertParamExists('bulkCreateProductVariants', 'createVariantsControllerDTO', createVariantsControllerDTO)
            const localVarPath = `/products/{id}/variants/bulk`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createVariantsControllerDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id Product Id
         * @param {CreateVariantDTO} createVariantDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductVariant: async (id: string, createVariantDTO: CreateVariantDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createProductVariant', 'id', id)
            // verify required parameter 'createVariantDTO' is not null or undefined
            assertParamExists('createProductVariant', 'createVariantDTO', createVariantDTO)
            const localVarPath = `/products/{id}/variants`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createVariantDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Product Id
         * @param {BulkEditVariantsDTO} bulkEditVariantsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productVariantsControllerBulkEditProductVariants: async (id: string, bulkEditVariantsDTO: BulkEditVariantsDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productVariantsControllerBulkEditProductVariants', 'id', id)
            // verify required parameter 'bulkEditVariantsDTO' is not null or undefined
            assertParamExists('productVariantsControllerBulkEditProductVariants', 'bulkEditVariantsDTO', bulkEditVariantsDTO)
            const localVarPath = `/products/{id}/variants/bulk`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkEditVariantsDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Product Id
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productVariantsControllerBulkeleteProductVariants: async (id: string, requestBody: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productVariantsControllerBulkeleteProductVariants', 'id', id)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('productVariantsControllerBulkeleteProductVariants', 'requestBody', requestBody)
            const localVarPath = `/products/{id}/variants/bulk`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} variantId Variant Id
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productVariantsControllerDeleteProductVariant: async (variantId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'variantId' is not null or undefined
            assertParamExists('productVariantsControllerDeleteProductVariant', 'variantId', variantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productVariantsControllerDeleteProductVariant', 'id', id)
            const localVarPath = `/products/{id}/variants/{variantId}`
                .replace(`{${"variantId"}}`, encodeURIComponent(String(variantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} variantId Variant Id
         * @param {string} id Product Id
         * @param {EditVariantDTO} editVariantDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productVariantsControllerEditProductVariant: async (variantId: string, id: string, editVariantDTO: EditVariantDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'variantId' is not null or undefined
            assertParamExists('productVariantsControllerEditProductVariant', 'variantId', variantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productVariantsControllerEditProductVariant', 'id', id)
            // verify required parameter 'editVariantDTO' is not null or undefined
            assertParamExists('productVariantsControllerEditProductVariant', 'editVariantDTO', editVariantDTO)
            const localVarPath = `/products/{id}/variants/{variantId}`
                .replace(`{${"variantId"}}`, encodeURIComponent(String(variantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editVariantDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productVariantsControllerGetProductVariants: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productVariantsControllerGetProductVariants', 'id', id)
            const localVarPath = `/products/{id}/variants`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductsVariantsApi - functional programming interface
 * @export
 */
export const ProductsVariantsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductsVariantsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {string} id Product Id
         * @param {CreateVariantsControllerDTO} createVariantsControllerDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkCreateProductVariants(id: string, createVariantsControllerDTO: CreateVariantsControllerDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Variant>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkCreateProductVariants(id, createVariantsControllerDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id Product Id
         * @param {CreateVariantDTO} createVariantDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProductVariant(id: string, createVariantDTO: CreateVariantDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Variant>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProductVariant(id, createVariantDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id Product Id
         * @param {BulkEditVariantsDTO} bulkEditVariantsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productVariantsControllerBulkEditProductVariants(id: string, bulkEditVariantsDTO: BulkEditVariantsDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Variant>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productVariantsControllerBulkEditProductVariants(id, bulkEditVariantsDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id Product Id
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productVariantsControllerBulkeleteProductVariants(id: string, requestBody: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Variant>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productVariantsControllerBulkeleteProductVariants(id, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} variantId Variant Id
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productVariantsControllerDeleteProductVariant(variantId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Variant>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productVariantsControllerDeleteProductVariant(variantId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} variantId Variant Id
         * @param {string} id Product Id
         * @param {EditVariantDTO} editVariantDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productVariantsControllerEditProductVariant(variantId: string, id: string, editVariantDTO: EditVariantDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Variant>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productVariantsControllerEditProductVariant(variantId, id, editVariantDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productVariantsControllerGetProductVariants(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Variant>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productVariantsControllerGetProductVariants(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductsVariantsApi - factory interface
 * @export
 */
export const ProductsVariantsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductsVariantsApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {string} id Product Id
         * @param {CreateVariantsControllerDTO} createVariantsControllerDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreateProductVariants(id: string, createVariantsControllerDTO: CreateVariantsControllerDTO, options?: any): AxiosPromise<Array<Variant>> {
            return localVarFp.bulkCreateProductVariants(id, createVariantsControllerDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id Product Id
         * @param {CreateVariantDTO} createVariantDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductVariant(id: string, createVariantDTO: CreateVariantDTO, options?: any): AxiosPromise<Array<Variant>> {
            return localVarFp.createProductVariant(id, createVariantDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Product Id
         * @param {BulkEditVariantsDTO} bulkEditVariantsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productVariantsControllerBulkEditProductVariants(id: string, bulkEditVariantsDTO: BulkEditVariantsDTO, options?: any): AxiosPromise<Variant> {
            return localVarFp.productVariantsControllerBulkEditProductVariants(id, bulkEditVariantsDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Product Id
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productVariantsControllerBulkeleteProductVariants(id: string, requestBody: Array<string>, options?: any): AxiosPromise<Variant> {
            return localVarFp.productVariantsControllerBulkeleteProductVariants(id, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} variantId Variant Id
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productVariantsControllerDeleteProductVariant(variantId: string, id: string, options?: any): AxiosPromise<Variant> {
            return localVarFp.productVariantsControllerDeleteProductVariant(variantId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} variantId Variant Id
         * @param {string} id Product Id
         * @param {EditVariantDTO} editVariantDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productVariantsControllerEditProductVariant(variantId: string, id: string, editVariantDTO: EditVariantDTO, options?: any): AxiosPromise<Variant> {
            return localVarFp.productVariantsControllerEditProductVariant(variantId, id, editVariantDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Product Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productVariantsControllerGetProductVariants(id: string, options?: any): AxiosPromise<Variant> {
            return localVarFp.productVariantsControllerGetProductVariants(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductsVariantsApi - object-oriented interface
 * @export
 * @class ProductsVariantsApi
 * @extends {BaseAPI}
 */
export class ProductsVariantsApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {string} id Product Id
     * @param {CreateVariantsControllerDTO} createVariantsControllerDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsVariantsApi
     */
    public bulkCreateProductVariants(id: string, createVariantsControllerDTO: CreateVariantsControllerDTO, options?: AxiosRequestConfig) {
        return ProductsVariantsApiFp(this.configuration).bulkCreateProductVariants(id, createVariantsControllerDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id Product Id
     * @param {CreateVariantDTO} createVariantDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsVariantsApi
     */
    public createProductVariant(id: string, createVariantDTO: CreateVariantDTO, options?: AxiosRequestConfig) {
        return ProductsVariantsApiFp(this.configuration).createProductVariant(id, createVariantDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Product Id
     * @param {BulkEditVariantsDTO} bulkEditVariantsDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsVariantsApi
     */
    public productVariantsControllerBulkEditProductVariants(id: string, bulkEditVariantsDTO: BulkEditVariantsDTO, options?: AxiosRequestConfig) {
        return ProductsVariantsApiFp(this.configuration).productVariantsControllerBulkEditProductVariants(id, bulkEditVariantsDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Product Id
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsVariantsApi
     */
    public productVariantsControllerBulkeleteProductVariants(id: string, requestBody: Array<string>, options?: AxiosRequestConfig) {
        return ProductsVariantsApiFp(this.configuration).productVariantsControllerBulkeleteProductVariants(id, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} variantId Variant Id
     * @param {string} id Product Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsVariantsApi
     */
    public productVariantsControllerDeleteProductVariant(variantId: string, id: string, options?: AxiosRequestConfig) {
        return ProductsVariantsApiFp(this.configuration).productVariantsControllerDeleteProductVariant(variantId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} variantId Variant Id
     * @param {string} id Product Id
     * @param {EditVariantDTO} editVariantDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsVariantsApi
     */
    public productVariantsControllerEditProductVariant(variantId: string, id: string, editVariantDTO: EditVariantDTO, options?: AxiosRequestConfig) {
        return ProductsVariantsApiFp(this.configuration).productVariantsControllerEditProductVariant(variantId, id, editVariantDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Product Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsVariantsApi
     */
    public productVariantsControllerGetProductVariants(id: string, options?: AxiosRequestConfig) {
        return ProductsVariantsApiFp(this.configuration).productVariantsControllerGetProductVariants(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ReportTemplatesApi - axios parameter creator
 * @export
 */
export const ReportTemplatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {PatchTemplateDto} patchTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTemplatesControllerUpdateComponent: async (id: string, patchTemplateDto: PatchTemplateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('reportTemplatesControllerUpdateComponent', 'id', id)
            // verify required parameter 'patchTemplateDto' is not null or undefined
            assertParamExists('reportTemplatesControllerUpdateComponent', 'patchTemplateDto', patchTemplateDto)
            const localVarPath = `/report-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportTemplatesApi - functional programming interface
 * @export
 */
export const ReportTemplatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportTemplatesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {PatchTemplateDto} patchTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportTemplatesControllerUpdateComponent(id: string, patchTemplateDto: PatchTemplateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportTemplatesControllerUpdateComponent(id, patchTemplateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReportTemplatesApi - factory interface
 * @export
 */
export const ReportTemplatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportTemplatesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {PatchTemplateDto} patchTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTemplatesControllerUpdateComponent(id: string, patchTemplateDto: PatchTemplateDto, options?: any): AxiosPromise<object> {
            return localVarFp.reportTemplatesControllerUpdateComponent(id, patchTemplateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportTemplatesApi - object-oriented interface
 * @export
 * @class ReportTemplatesApi
 * @extends {BaseAPI}
 */
export class ReportTemplatesApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {PatchTemplateDto} patchTemplateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportTemplatesApi
     */
    public reportTemplatesControllerUpdateComponent(id: string, patchTemplateDto: PatchTemplateDto, options?: AxiosRequestConfig) {
        return ReportTemplatesApiFp(this.configuration).reportTemplatesControllerUpdateComponent(id, patchTemplateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SeasonsApi - axios parameter creator
 * @export
 */
export const SeasonsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seasonsControllerQuerySeasons: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/seasons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SeasonsApi - functional programming interface
 * @export
 */
export const SeasonsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SeasonsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async seasonsControllerQuerySeasons(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Season>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.seasonsControllerQuerySeasons(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SeasonsApi - factory interface
 * @export
 */
export const SeasonsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SeasonsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seasonsControllerQuerySeasons(options?: any): AxiosPromise<Array<Season>> {
            return localVarFp.seasonsControllerQuerySeasons(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SeasonsApi - object-oriented interface
 * @export
 * @class SeasonsApi
 * @extends {BaseAPI}
 */
export class SeasonsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonsApi
     */
    public seasonsControllerQuerySeasons(options?: AxiosRequestConfig) {
        return SeasonsApiFp(this.configuration).seasonsControllerQuerySeasons(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SharedFoldersApi - axios parameter creator
 * @export
 */
export const SharedFoldersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {string} contactId contact id
         * @param {string} id shared folder id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addContact: async (contactId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('addContact', 'contactId', contactId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addContact', 'id', id)
            const localVarPath = `/shared-folders/{id}/contacts/{contactId}`
                .replace(`{${"contactId"}}`, encodeURIComponent(String(contactId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {SharedFolderDTO} sharedFolderDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFolder: async (sharedFolderDTO: SharedFolderDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sharedFolderDTO' is not null or undefined
            assertParamExists('createFolder', 'sharedFolderDTO', sharedFolderDTO)
            const localVarPath = `/shared-folders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sharedFolderDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id shared folder id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFolder: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteFolder', 'id', id)
            const localVarPath = `/shared-folders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id shared folder id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFolder: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFolder', 'id', id)
            const localVarPath = `/shared-folders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id shared folder id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFolderTechpacks: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFolderTechpacks', 'id', id)
            const localVarPath = `/shared-folders/{id}/techpacks`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id shared folder id
         * @param {PatchFolderDTO} patchFolderDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchSharedFolder: async (id: string, patchFolderDTO: PatchFolderDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchSharedFolder', 'id', id)
            // verify required parameter 'patchFolderDTO' is not null or undefined
            assertParamExists('patchSharedFolder', 'patchFolderDTO', patchFolderDTO)
            const localVarPath = `/shared-folders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchFolderDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        querySharedFolders: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/shared-folders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} contactId contact id
         * @param {string} id shared folder id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeContact: async (contactId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('removeContact', 'contactId', contactId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeContact', 'id', id)
            const localVarPath = `/shared-folders/{id}/contacts/{contactId}`
                .replace(`{${"contactId"}}`, encodeURIComponent(String(contactId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} tpId tech pack id
         * @param {string} id shared folder id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTechpack: async (tpId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tpId' is not null or undefined
            assertParamExists('removeTechpack', 'tpId', tpId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeTechpack', 'id', id)
            const localVarPath = `/shared-folders/{id}/techpacks/{tpId}`
                .replace(`{${"tpId"}}`, encodeURIComponent(String(tpId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id shared folder id
         * @param {UpdateSharedFolderDTO} updateSharedFolderDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFolder: async (id: string, updateSharedFolderDTO: UpdateSharedFolderDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateFolder', 'id', id)
            // verify required parameter 'updateSharedFolderDTO' is not null or undefined
            assertParamExists('updateFolder', 'updateSharedFolderDTO', updateSharedFolderDTO)
            const localVarPath = `/shared-folders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSharedFolderDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SharedFoldersApi - functional programming interface
 * @export
 */
export const SharedFoldersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SharedFoldersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {string} contactId contact id
         * @param {string} id shared folder id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addContact(contactId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SharedFolder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addContact(contactId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {SharedFolderDTO} sharedFolderDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFolder(sharedFolderDTO: SharedFolderDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SharedFolder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFolder(sharedFolderDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id shared folder id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFolder(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFolder(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id shared folder id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFolder(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSharedFolderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFolder(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id shared folder id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFolderTechpacks(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PopulatedSharedTechpack>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFolderTechpacks(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id shared folder id
         * @param {PatchFolderDTO} patchFolderDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchSharedFolder(id: string, patchFolderDTO: PatchFolderDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SharedFolder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchSharedFolder(id, patchFolderDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async querySharedFolders(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QueryFoldersResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.querySharedFolders(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} contactId contact id
         * @param {string} id shared folder id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeContact(contactId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SharedFolder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeContact(contactId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} tpId tech pack id
         * @param {string} id shared folder id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeTechpack(tpId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SharedFolder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeTechpack(tpId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id shared folder id
         * @param {UpdateSharedFolderDTO} updateSharedFolderDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFolder(id: string, updateSharedFolderDTO: UpdateSharedFolderDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SharedFolder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFolder(id, updateSharedFolderDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SharedFoldersApi - factory interface
 * @export
 */
export const SharedFoldersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SharedFoldersApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {string} contactId contact id
         * @param {string} id shared folder id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addContact(contactId: string, id: string, options?: any): AxiosPromise<SharedFolder> {
            return localVarFp.addContact(contactId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {SharedFolderDTO} sharedFolderDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFolder(sharedFolderDTO: SharedFolderDTO, options?: any): AxiosPromise<SharedFolder> {
            return localVarFp.createFolder(sharedFolderDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id shared folder id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFolder(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteFolder(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id shared folder id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFolder(id: string, options?: any): AxiosPromise<GetSharedFolderResponse> {
            return localVarFp.getFolder(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id shared folder id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFolderTechpacks(id: string, options?: any): AxiosPromise<Array<PopulatedSharedTechpack>> {
            return localVarFp.getFolderTechpacks(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id shared folder id
         * @param {PatchFolderDTO} patchFolderDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchSharedFolder(id: string, patchFolderDTO: PatchFolderDTO, options?: any): AxiosPromise<SharedFolder> {
            return localVarFp.patchSharedFolder(id, patchFolderDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        querySharedFolders(options?: any): AxiosPromise<Array<QueryFoldersResponse>> {
            return localVarFp.querySharedFolders(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} contactId contact id
         * @param {string} id shared folder id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeContact(contactId: string, id: string, options?: any): AxiosPromise<SharedFolder> {
            return localVarFp.removeContact(contactId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} tpId tech pack id
         * @param {string} id shared folder id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTechpack(tpId: string, id: string, options?: any): AxiosPromise<SharedFolder> {
            return localVarFp.removeTechpack(tpId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id shared folder id
         * @param {UpdateSharedFolderDTO} updateSharedFolderDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFolder(id: string, updateSharedFolderDTO: UpdateSharedFolderDTO, options?: any): AxiosPromise<SharedFolder> {
            return localVarFp.updateFolder(id, updateSharedFolderDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SharedFoldersApi - object-oriented interface
 * @export
 * @class SharedFoldersApi
 * @extends {BaseAPI}
 */
export class SharedFoldersApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {string} contactId contact id
     * @param {string} id shared folder id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SharedFoldersApi
     */
    public addContact(contactId: string, id: string, options?: AxiosRequestConfig) {
        return SharedFoldersApiFp(this.configuration).addContact(contactId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {SharedFolderDTO} sharedFolderDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SharedFoldersApi
     */
    public createFolder(sharedFolderDTO: SharedFolderDTO, options?: AxiosRequestConfig) {
        return SharedFoldersApiFp(this.configuration).createFolder(sharedFolderDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id shared folder id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SharedFoldersApi
     */
    public deleteFolder(id: string, options?: AxiosRequestConfig) {
        return SharedFoldersApiFp(this.configuration).deleteFolder(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id shared folder id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SharedFoldersApi
     */
    public getFolder(id: string, options?: AxiosRequestConfig) {
        return SharedFoldersApiFp(this.configuration).getFolder(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id shared folder id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SharedFoldersApi
     */
    public getFolderTechpacks(id: string, options?: AxiosRequestConfig) {
        return SharedFoldersApiFp(this.configuration).getFolderTechpacks(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id shared folder id
     * @param {PatchFolderDTO} patchFolderDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SharedFoldersApi
     */
    public patchSharedFolder(id: string, patchFolderDTO: PatchFolderDTO, options?: AxiosRequestConfig) {
        return SharedFoldersApiFp(this.configuration).patchSharedFolder(id, patchFolderDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SharedFoldersApi
     */
    public querySharedFolders(options?: AxiosRequestConfig) {
        return SharedFoldersApiFp(this.configuration).querySharedFolders(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} contactId contact id
     * @param {string} id shared folder id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SharedFoldersApi
     */
    public removeContact(contactId: string, id: string, options?: AxiosRequestConfig) {
        return SharedFoldersApiFp(this.configuration).removeContact(contactId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} tpId tech pack id
     * @param {string} id shared folder id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SharedFoldersApi
     */
    public removeTechpack(tpId: string, id: string, options?: AxiosRequestConfig) {
        return SharedFoldersApiFp(this.configuration).removeTechpack(tpId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id shared folder id
     * @param {UpdateSharedFolderDTO} updateSharedFolderDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SharedFoldersApi
     */
    public updateFolder(id: string, updateSharedFolderDTO: UpdateSharedFolderDTO, options?: AxiosRequestConfig) {
        return SharedFoldersApiFp(this.configuration).updateFolder(id, updateSharedFolderDTO, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SignedUrlsApi - axios parameter creator
 * @export
 */
export const SignedUrlsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateFilesSignedUrlDto} createFilesSignedUrlDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signedUrlsControllerGetSignedURL: async (createFilesSignedUrlDto: CreateFilesSignedUrlDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFilesSignedUrlDto' is not null or undefined
            assertParamExists('signedUrlsControllerGetSignedURL', 'createFilesSignedUrlDto', createFilesSignedUrlDto)
            const localVarPath = `/signed-urls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFilesSignedUrlDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SignedUrlsApi - functional programming interface
 * @export
 */
export const SignedUrlsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SignedUrlsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateFilesSignedUrlDto} createFilesSignedUrlDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signedUrlsControllerGetSignedURL(createFilesSignedUrlDto: CreateFilesSignedUrlDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signedUrlsControllerGetSignedURL(createFilesSignedUrlDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SignedUrlsApi - factory interface
 * @export
 */
export const SignedUrlsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SignedUrlsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateFilesSignedUrlDto} createFilesSignedUrlDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signedUrlsControllerGetSignedURL(createFilesSignedUrlDto: CreateFilesSignedUrlDto, options?: any): AxiosPromise<void> {
            return localVarFp.signedUrlsControllerGetSignedURL(createFilesSignedUrlDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SignedUrlsApi - object-oriented interface
 * @export
 * @class SignedUrlsApi
 * @extends {BaseAPI}
 */
export class SignedUrlsApi extends BaseAPI {
    /**
     * 
     * @param {CreateFilesSignedUrlDto} createFilesSignedUrlDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignedUrlsApi
     */
    public signedUrlsControllerGetSignedURL(createFilesSignedUrlDto: CreateFilesSignedUrlDto, options?: AxiosRequestConfig) {
        return SignedUrlsApiFp(this.configuration).signedUrlsControllerGetSignedURL(createFilesSignedUrlDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SizeSpecBlocksApi - axios parameter creator
 * @export
 */
export const SizeSpecBlocksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sizeSpecBlocksControllerBulkDelete: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/size-spec-blocks/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {BulkDeletePomsDTO} bulkDeletePomsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sizeSpecBlocksControllerBulkDeletePoms: async (id: string, bulkDeletePomsDTO: BulkDeletePomsDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sizeSpecBlocksControllerBulkDeletePoms', 'id', id)
            // verify required parameter 'bulkDeletePomsDTO' is not null or undefined
            assertParamExists('sizeSpecBlocksControllerBulkDeletePoms', 'bulkDeletePomsDTO', bulkDeletePomsDTO)
            const localVarPath = `/size-spec-blocks/{id}/points-of-measure`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkDeletePomsDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sizeSpecBlocksControllerClear: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sizeSpecBlocksControllerClear', 'id', id)
            const localVarPath = `/size-spec-blocks/{id}/clear`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sizeSpecBlocksControllerCreate: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/size-spec-blocks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sizeSpecBlocksControllerDuplicate: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sizeSpecBlocksControllerDuplicate', 'id', id)
            const localVarPath = `/size-spec-blocks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sizeSpecBlocksControllerFindOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sizeSpecBlocksControllerFindOne', 'id', id)
            const localVarPath = `/size-spec-blocks/{id}/converted`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sizeSpecBlocksControllerImportFromCsv: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sizeSpecBlocksControllerImportFromCsv', 'id', id)
            const localVarPath = `/size-spec-blocks/{id}/import-from-csv`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sizeSpecBlocksControllerReorderPoms: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sizeSpecBlocksControllerReorderPoms', 'id', id)
            const localVarPath = `/size-spec-blocks/{id}/points-of-measure/reorder-poms`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sizeSpecBlocksControllerUpdate: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sizeSpecBlocksControllerUpdate', 'id', id)
            const localVarPath = `/size-spec-blocks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sizeSpecBlocksControllerUpdateFormat: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sizeSpecBlocksControllerUpdateFormat', 'id', id)
            const localVarPath = `/size-spec-blocks/{id}/format`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sizeSpecBlocksControllerUpdateUnitOfMeasure: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sizeSpecBlocksControllerUpdateUnitOfMeasure', 'id', id)
            const localVarPath = `/size-spec-blocks/{id}/current-unit-of-measure`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SizeSpecBlocksApi - functional programming interface
 * @export
 */
export const SizeSpecBlocksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SizeSpecBlocksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sizeSpecBlocksControllerBulkDelete(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sizeSpecBlocksControllerBulkDelete(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {BulkDeletePomsDTO} bulkDeletePomsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sizeSpecBlocksControllerBulkDeletePoms(id: string, bulkDeletePomsDTO: BulkDeletePomsDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SizeSpecBlock>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sizeSpecBlocksControllerBulkDeletePoms(id, bulkDeletePomsDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sizeSpecBlocksControllerClear(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sizeSpecBlocksControllerClear(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sizeSpecBlocksControllerCreate(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sizeSpecBlocksControllerCreate(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sizeSpecBlocksControllerDuplicate(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sizeSpecBlocksControllerDuplicate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sizeSpecBlocksControllerFindOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sizeSpecBlocksControllerFindOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sizeSpecBlocksControllerImportFromCsv(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sizeSpecBlocksControllerImportFromCsv(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sizeSpecBlocksControllerReorderPoms(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SizeSpecBlock>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sizeSpecBlocksControllerReorderPoms(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sizeSpecBlocksControllerUpdate(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sizeSpecBlocksControllerUpdate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sizeSpecBlocksControllerUpdateFormat(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SizeSpecBlock>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sizeSpecBlocksControllerUpdateFormat(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sizeSpecBlocksControllerUpdateUnitOfMeasure(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sizeSpecBlocksControllerUpdateUnitOfMeasure(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SizeSpecBlocksApi - factory interface
 * @export
 */
export const SizeSpecBlocksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SizeSpecBlocksApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sizeSpecBlocksControllerBulkDelete(options?: any): AxiosPromise<string> {
            return localVarFp.sizeSpecBlocksControllerBulkDelete(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {BulkDeletePomsDTO} bulkDeletePomsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sizeSpecBlocksControllerBulkDeletePoms(id: string, bulkDeletePomsDTO: BulkDeletePomsDTO, options?: any): AxiosPromise<SizeSpecBlock> {
            return localVarFp.sizeSpecBlocksControllerBulkDeletePoms(id, bulkDeletePomsDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sizeSpecBlocksControllerClear(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.sizeSpecBlocksControllerClear(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sizeSpecBlocksControllerCreate(options?: any): AxiosPromise<void> {
            return localVarFp.sizeSpecBlocksControllerCreate(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sizeSpecBlocksControllerDuplicate(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.sizeSpecBlocksControllerDuplicate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sizeSpecBlocksControllerFindOne(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.sizeSpecBlocksControllerFindOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sizeSpecBlocksControllerImportFromCsv(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.sizeSpecBlocksControllerImportFromCsv(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sizeSpecBlocksControllerReorderPoms(id: string, options?: any): AxiosPromise<SizeSpecBlock> {
            return localVarFp.sizeSpecBlocksControllerReorderPoms(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sizeSpecBlocksControllerUpdate(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.sizeSpecBlocksControllerUpdate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sizeSpecBlocksControllerUpdateFormat(id: string, options?: any): AxiosPromise<SizeSpecBlock> {
            return localVarFp.sizeSpecBlocksControllerUpdateFormat(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sizeSpecBlocksControllerUpdateUnitOfMeasure(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.sizeSpecBlocksControllerUpdateUnitOfMeasure(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SizeSpecBlocksApi - object-oriented interface
 * @export
 * @class SizeSpecBlocksApi
 * @extends {BaseAPI}
 */
export class SizeSpecBlocksApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SizeSpecBlocksApi
     */
    public sizeSpecBlocksControllerBulkDelete(options?: AxiosRequestConfig) {
        return SizeSpecBlocksApiFp(this.configuration).sizeSpecBlocksControllerBulkDelete(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {BulkDeletePomsDTO} bulkDeletePomsDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SizeSpecBlocksApi
     */
    public sizeSpecBlocksControllerBulkDeletePoms(id: string, bulkDeletePomsDTO: BulkDeletePomsDTO, options?: AxiosRequestConfig) {
        return SizeSpecBlocksApiFp(this.configuration).sizeSpecBlocksControllerBulkDeletePoms(id, bulkDeletePomsDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SizeSpecBlocksApi
     */
    public sizeSpecBlocksControllerClear(id: string, options?: AxiosRequestConfig) {
        return SizeSpecBlocksApiFp(this.configuration).sizeSpecBlocksControllerClear(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SizeSpecBlocksApi
     */
    public sizeSpecBlocksControllerCreate(options?: AxiosRequestConfig) {
        return SizeSpecBlocksApiFp(this.configuration).sizeSpecBlocksControllerCreate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SizeSpecBlocksApi
     */
    public sizeSpecBlocksControllerDuplicate(id: string, options?: AxiosRequestConfig) {
        return SizeSpecBlocksApiFp(this.configuration).sizeSpecBlocksControllerDuplicate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SizeSpecBlocksApi
     */
    public sizeSpecBlocksControllerFindOne(id: string, options?: AxiosRequestConfig) {
        return SizeSpecBlocksApiFp(this.configuration).sizeSpecBlocksControllerFindOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SizeSpecBlocksApi
     */
    public sizeSpecBlocksControllerImportFromCsv(id: string, options?: AxiosRequestConfig) {
        return SizeSpecBlocksApiFp(this.configuration).sizeSpecBlocksControllerImportFromCsv(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SizeSpecBlocksApi
     */
    public sizeSpecBlocksControllerReorderPoms(id: string, options?: AxiosRequestConfig) {
        return SizeSpecBlocksApiFp(this.configuration).sizeSpecBlocksControllerReorderPoms(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SizeSpecBlocksApi
     */
    public sizeSpecBlocksControllerUpdate(id: string, options?: AxiosRequestConfig) {
        return SizeSpecBlocksApiFp(this.configuration).sizeSpecBlocksControllerUpdate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SizeSpecBlocksApi
     */
    public sizeSpecBlocksControllerUpdateFormat(id: string, options?: AxiosRequestConfig) {
        return SizeSpecBlocksApiFp(this.configuration).sizeSpecBlocksControllerUpdateFormat(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SizeSpecBlocksApi
     */
    public sizeSpecBlocksControllerUpdateUnitOfMeasure(id: string, options?: AxiosRequestConfig) {
        return SizeSpecBlocksApiFp(this.configuration).sizeSpecBlocksControllerUpdateUnitOfMeasure(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SizeSpecsApi - axios parameter creator
 * @export
 */
export const SizeSpecsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {ImportSizeSpecDTO} importSizeSpecDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sizeSpecsControllerImport: async (id: string, importSizeSpecDTO: ImportSizeSpecDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sizeSpecsControllerImport', 'id', id)
            // verify required parameter 'importSizeSpecDTO' is not null or undefined
            assertParamExists('sizeSpecsControllerImport', 'importSizeSpecDTO', importSizeSpecDTO)
            const localVarPath = `/size-specs/{id}/import`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importSizeSpecDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sizeSpecsControllerImportFromCsv: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sizeSpecsControllerImportFromCsv', 'id', id)
            const localVarPath = `/size-specs/{id}/import-from-csv`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SizeSpecsApi - functional programming interface
 * @export
 */
export const SizeSpecsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SizeSpecsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {ImportSizeSpecDTO} importSizeSpecDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sizeSpecsControllerImport(id: string, importSizeSpecDTO: ImportSizeSpecDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sizeSpecsControllerImport(id, importSizeSpecDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sizeSpecsControllerImportFromCsv(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sizeSpecsControllerImportFromCsv(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SizeSpecsApi - factory interface
 * @export
 */
export const SizeSpecsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SizeSpecsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {ImportSizeSpecDTO} importSizeSpecDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sizeSpecsControllerImport(id: string, importSizeSpecDTO: ImportSizeSpecDTO, options?: any): AxiosPromise<void> {
            return localVarFp.sizeSpecsControllerImport(id, importSizeSpecDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sizeSpecsControllerImportFromCsv(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.sizeSpecsControllerImportFromCsv(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SizeSpecsApi - object-oriented interface
 * @export
 * @class SizeSpecsApi
 * @extends {BaseAPI}
 */
export class SizeSpecsApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {ImportSizeSpecDTO} importSizeSpecDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SizeSpecsApi
     */
    public sizeSpecsControllerImport(id: string, importSizeSpecDTO: ImportSizeSpecDTO, options?: AxiosRequestConfig) {
        return SizeSpecsApiFp(this.configuration).sizeSpecsControllerImport(id, importSizeSpecDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SizeSpecsApi
     */
    public sizeSpecsControllerImportFromCsv(id: string, options?: AxiosRequestConfig) {
        return SizeSpecsApiFp(this.configuration).sizeSpecsControllerImportFromCsv(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SourceFilesApi - axios parameter creator
 * @export
 */
export const SourceFilesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sourceFilesControllerDeleteSourceFile: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sourceFilesControllerDeleteSourceFile', 'id', id)
            const localVarPath = `/source-files/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} versionId 
         * @param {string} id 
         * @param {PatchSourceFileVersionDTO} patchSourceFileVersionDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sourceFilesControllerUpdateComponent: async (versionId: string, id: string, patchSourceFileVersionDTO: PatchSourceFileVersionDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('sourceFilesControllerUpdateComponent', 'versionId', versionId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sourceFilesControllerUpdateComponent', 'id', id)
            // verify required parameter 'patchSourceFileVersionDTO' is not null or undefined
            assertParamExists('sourceFilesControllerUpdateComponent', 'patchSourceFileVersionDTO', patchSourceFileVersionDTO)
            const localVarPath = `/source-files/{id}/versions/{versionId}`
                .replace(`{${"versionId"}}`, encodeURIComponent(String(versionId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchSourceFileVersionDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SourceFilesApi - functional programming interface
 * @export
 */
export const SourceFilesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SourceFilesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sourceFilesControllerDeleteSourceFile(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sourceFilesControllerDeleteSourceFile(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} versionId 
         * @param {string} id 
         * @param {PatchSourceFileVersionDTO} patchSourceFileVersionDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sourceFilesControllerUpdateComponent(versionId: string, id: string, patchSourceFileVersionDTO: PatchSourceFileVersionDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sourceFilesControllerUpdateComponent(versionId, id, patchSourceFileVersionDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SourceFilesApi - factory interface
 * @export
 */
export const SourceFilesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SourceFilesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sourceFilesControllerDeleteSourceFile(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.sourceFilesControllerDeleteSourceFile(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} versionId 
         * @param {string} id 
         * @param {PatchSourceFileVersionDTO} patchSourceFileVersionDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sourceFilesControllerUpdateComponent(versionId: string, id: string, patchSourceFileVersionDTO: PatchSourceFileVersionDTO, options?: any): AxiosPromise<object> {
            return localVarFp.sourceFilesControllerUpdateComponent(versionId, id, patchSourceFileVersionDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SourceFilesApi - object-oriented interface
 * @export
 * @class SourceFilesApi
 * @extends {BaseAPI}
 */
export class SourceFilesApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SourceFilesApi
     */
    public sourceFilesControllerDeleteSourceFile(id: string, options?: AxiosRequestConfig) {
        return SourceFilesApiFp(this.configuration).sourceFilesControllerDeleteSourceFile(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} versionId 
     * @param {string} id 
     * @param {PatchSourceFileVersionDTO} patchSourceFileVersionDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SourceFilesApi
     */
    public sourceFilesControllerUpdateComponent(versionId: string, id: string, patchSourceFileVersionDTO: PatchSourceFileVersionDTO, options?: AxiosRequestConfig) {
        return SourceFilesApiFp(this.configuration).sourceFilesControllerUpdateComponent(versionId, id, patchSourceFileVersionDTO, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SwatchesApi - axios parameter creator
 * @export
 */
export const SwatchesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swatchesControllerBulkCopy: async (requestBody: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('swatchesControllerBulkCopy', 'requestBody', requestBody)
            const localVarPath = `/swatches/bulk-copy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swatchesControllerBulkDelete: async (requestBody: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('swatchesControllerBulkDelete', 'requestBody', requestBody)
            const localVarPath = `/swatches/bulk-delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swatchesControllerComponentUtilization: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('swatchesControllerComponentUtilization', 'id', id)
            const localVarPath = `/swatches/{id}/component-utilization`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swatchesControllerCopy: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('swatchesControllerCopy', 'id', id)
            const localVarPath = `/swatches/{id}/copy`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SwatchCreateDto} swatchCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swatchesControllerCreate: async (swatchCreateDto: SwatchCreateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'swatchCreateDto' is not null or undefined
            assertParamExists('swatchesControllerCreate', 'swatchCreateDto', swatchCreateDto)
            const localVarPath = `/swatches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(swatchCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swatchesControllerDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('swatchesControllerDelete', 'id', id)
            const localVarPath = `/swatches/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swatchesControllerFindAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/swatches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swatchesControllerFindOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('swatchesControllerFindOne', 'id', id)
            const localVarPath = `/swatches/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swatchesControllerProductUtilization: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('swatchesControllerProductUtilization', 'id', id)
            const localVarPath = `/swatches/{id}/product-utilization`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} paletteId Palette Id
         * @param {string} id Swatch Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swatchesControllerRemovePalette: async (paletteId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paletteId' is not null or undefined
            assertParamExists('swatchesControllerRemovePalette', 'paletteId', paletteId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('swatchesControllerRemovePalette', 'id', id)
            const localVarPath = `/swatches/{id}/palettes/{paletteId}`
                .replace(`{${"paletteId"}}`, encodeURIComponent(String(paletteId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {SwatchUpdateDto} swatchUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swatchesControllerUpdate: async (id: string, swatchUpdateDto: SwatchUpdateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('swatchesControllerUpdate', 'id', id)
            // verify required parameter 'swatchUpdateDto' is not null or undefined
            assertParamExists('swatchesControllerUpdate', 'swatchUpdateDto', swatchUpdateDto)
            const localVarPath = `/swatches/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(swatchUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SwatchesApi - functional programming interface
 * @export
 */
export const SwatchesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SwatchesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async swatchesControllerBulkCopy(requestBody: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Swatch>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.swatchesControllerBulkCopy(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async swatchesControllerBulkDelete(requestBody: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.swatchesControllerBulkDelete(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async swatchesControllerComponentUtilization(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.swatchesControllerComponentUtilization(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async swatchesControllerCopy(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Swatch>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.swatchesControllerCopy(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SwatchCreateDto} swatchCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async swatchesControllerCreate(swatchCreateDto: SwatchCreateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Swatch>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.swatchesControllerCreate(swatchCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async swatchesControllerDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.swatchesControllerDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async swatchesControllerFindAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Swatch>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.swatchesControllerFindAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async swatchesControllerFindOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Swatch>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.swatchesControllerFindOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async swatchesControllerProductUtilization(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.swatchesControllerProductUtilization(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} paletteId Palette Id
         * @param {string} id Swatch Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async swatchesControllerRemovePalette(paletteId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.swatchesControllerRemovePalette(paletteId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {SwatchUpdateDto} swatchUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async swatchesControllerUpdate(id: string, swatchUpdateDto: SwatchUpdateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Swatch>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.swatchesControllerUpdate(id, swatchUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SwatchesApi - factory interface
 * @export
 */
export const SwatchesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SwatchesApiFp(configuration)
    return {
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swatchesControllerBulkCopy(requestBody: Array<string>, options?: any): AxiosPromise<Array<Swatch>> {
            return localVarFp.swatchesControllerBulkCopy(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swatchesControllerBulkDelete(requestBody: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.swatchesControllerBulkDelete(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swatchesControllerComponentUtilization(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.swatchesControllerComponentUtilization(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swatchesControllerCopy(id: string, options?: any): AxiosPromise<Swatch> {
            return localVarFp.swatchesControllerCopy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SwatchCreateDto} swatchCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swatchesControllerCreate(swatchCreateDto: SwatchCreateDto, options?: any): AxiosPromise<Swatch> {
            return localVarFp.swatchesControllerCreate(swatchCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swatchesControllerDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.swatchesControllerDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swatchesControllerFindAll(options?: any): AxiosPromise<Array<Swatch>> {
            return localVarFp.swatchesControllerFindAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swatchesControllerFindOne(id: string, options?: any): AxiosPromise<Swatch> {
            return localVarFp.swatchesControllerFindOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swatchesControllerProductUtilization(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.swatchesControllerProductUtilization(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} paletteId Palette Id
         * @param {string} id Swatch Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swatchesControllerRemovePalette(paletteId: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.swatchesControllerRemovePalette(paletteId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {SwatchUpdateDto} swatchUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swatchesControllerUpdate(id: string, swatchUpdateDto: SwatchUpdateDto, options?: any): AxiosPromise<Swatch> {
            return localVarFp.swatchesControllerUpdate(id, swatchUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SwatchesApi - object-oriented interface
 * @export
 * @class SwatchesApi
 * @extends {BaseAPI}
 */
export class SwatchesApi extends BaseAPI {
    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SwatchesApi
     */
    public swatchesControllerBulkCopy(requestBody: Array<string>, options?: AxiosRequestConfig) {
        return SwatchesApiFp(this.configuration).swatchesControllerBulkCopy(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SwatchesApi
     */
    public swatchesControllerBulkDelete(requestBody: Array<string>, options?: AxiosRequestConfig) {
        return SwatchesApiFp(this.configuration).swatchesControllerBulkDelete(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SwatchesApi
     */
    public swatchesControllerComponentUtilization(id: string, options?: AxiosRequestConfig) {
        return SwatchesApiFp(this.configuration).swatchesControllerComponentUtilization(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SwatchesApi
     */
    public swatchesControllerCopy(id: string, options?: AxiosRequestConfig) {
        return SwatchesApiFp(this.configuration).swatchesControllerCopy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SwatchCreateDto} swatchCreateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SwatchesApi
     */
    public swatchesControllerCreate(swatchCreateDto: SwatchCreateDto, options?: AxiosRequestConfig) {
        return SwatchesApiFp(this.configuration).swatchesControllerCreate(swatchCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SwatchesApi
     */
    public swatchesControllerDelete(id: string, options?: AxiosRequestConfig) {
        return SwatchesApiFp(this.configuration).swatchesControllerDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SwatchesApi
     */
    public swatchesControllerFindAll(options?: AxiosRequestConfig) {
        return SwatchesApiFp(this.configuration).swatchesControllerFindAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SwatchesApi
     */
    public swatchesControllerFindOne(id: string, options?: AxiosRequestConfig) {
        return SwatchesApiFp(this.configuration).swatchesControllerFindOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SwatchesApi
     */
    public swatchesControllerProductUtilization(id: string, options?: AxiosRequestConfig) {
        return SwatchesApiFp(this.configuration).swatchesControllerProductUtilization(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} paletteId Palette Id
     * @param {string} id Swatch Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SwatchesApi
     */
    public swatchesControllerRemovePalette(paletteId: string, id: string, options?: AxiosRequestConfig) {
        return SwatchesApiFp(this.configuration).swatchesControllerRemovePalette(paletteId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {SwatchUpdateDto} swatchUpdateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SwatchesApi
     */
    public swatchesControllerUpdate(id: string, swatchUpdateDto: SwatchUpdateDto, options?: AxiosRequestConfig) {
        return SwatchesApiFp(this.configuration).swatchesControllerUpdate(id, swatchUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateUserDto} createUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerCreateUser: async (createUserDto: CreateUserDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUserDto' is not null or undefined
            assertParamExists('usersControllerCreateUser', 'createUserDto', createUserDto)
            const localVarPath = `/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerGetCompanyUsers: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerGetMe: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerGetUser: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('usersControllerGetUser', 'id', id)
            const localVarPath = `/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LoginDTO} loginDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerLogin: async (loginDTO: LoginDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginDTO' is not null or undefined
            assertParamExists('usersControllerLogin', 'loginDTO', loginDTO)
            const localVarPath = `/users/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerLogout: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {PatchUserDto} patchUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerPatchUser: async (id: string, patchUserDto: PatchUserDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('usersControllerPatchUser', 'id', id)
            // verify required parameter 'patchUserDto' is not null or undefined
            assertParamExists('usersControllerPatchUser', 'patchUserDto', patchUserDto)
            const localVarPath = `/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} token 
         * @param {UpdatePasswordDto} updatePasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerResetPassword: async (token: string, updatePasswordDto: UpdatePasswordDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('usersControllerResetPassword', 'token', token)
            // verify required parameter 'updatePasswordDto' is not null or undefined
            assertParamExists('usersControllerResetPassword', 'updatePasswordDto', updatePasswordDto)
            const localVarPath = `/users/{token}/reset-password`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePasswordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ResetPasswordEmailDto} resetPasswordEmailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerSendResetEmail: async (resetPasswordEmailDto: ResetPasswordEmailDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetPasswordEmailDto' is not null or undefined
            assertParamExists('usersControllerSendResetEmail', 'resetPasswordEmailDto', resetPasswordEmailDto)
            const localVarPath = `/users/send-reset-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordEmailDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {HomePageDto} homePageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerSetHomePage: async (id: string, homePageDto: HomePageDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('usersControllerSetHomePage', 'id', id)
            // verify required parameter 'homePageDto' is not null or undefined
            assertParamExists('usersControllerSetHomePage', 'homePageDto', homePageDto)
            const localVarPath = `/users/{id}/homepage`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(homePageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdatePasswordDto} updatePasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerUpdatePassword: async (id: string, updatePasswordDto: UpdatePasswordDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('usersControllerUpdatePassword', 'id', id)
            // verify required parameter 'updatePasswordDto' is not null or undefined
            assertParamExists('usersControllerUpdatePassword', 'updatePasswordDto', updatePasswordDto)
            const localVarPath = `/users/{id}/password`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePasswordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerValidateToken: async (token: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('usersControllerValidateToken', 'token', token)
            const localVarPath = `/users/{token}/validate`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateUserDto} createUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerCreateUser(createUserDto: CreateUserDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerCreateUser(createUserDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerGetCompanyUsers(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerGetCompanyUsers(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerGetMe(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerGetMe(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerGetUser(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerGetUser(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {LoginDTO} loginDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerLogin(loginDTO: LoginDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerLogin(loginDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerLogout(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerLogout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {PatchUserDto} patchUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerPatchUser(id: string, patchUserDto: PatchUserDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerPatchUser(id, patchUserDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} token 
         * @param {UpdatePasswordDto} updatePasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerResetPassword(token: string, updatePasswordDto: UpdatePasswordDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerResetPassword(token, updatePasswordDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ResetPasswordEmailDto} resetPasswordEmailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerSendResetEmail(resetPasswordEmailDto: ResetPasswordEmailDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerSendResetEmail(resetPasswordEmailDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {HomePageDto} homePageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerSetHomePage(id: string, homePageDto: HomePageDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerSetHomePage(id, homePageDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdatePasswordDto} updatePasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerUpdatePassword(id: string, updatePasswordDto: UpdatePasswordDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerUpdatePassword(id, updatePasswordDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerValidateToken(token: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerValidateToken(token, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateUserDto} createUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerCreateUser(createUserDto: CreateUserDto, options?: any): AxiosPromise<void> {
            return localVarFp.usersControllerCreateUser(createUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerGetCompanyUsers(options?: any): AxiosPromise<void> {
            return localVarFp.usersControllerGetCompanyUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerGetMe(options?: any): AxiosPromise<User> {
            return localVarFp.usersControllerGetMe(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerGetUser(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.usersControllerGetUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LoginDTO} loginDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerLogin(loginDTO: LoginDTO, options?: any): AxiosPromise<void> {
            return localVarFp.usersControllerLogin(loginDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerLogout(options?: any): AxiosPromise<void> {
            return localVarFp.usersControllerLogout(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {PatchUserDto} patchUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerPatchUser(id: string, patchUserDto: PatchUserDto, options?: any): AxiosPromise<User> {
            return localVarFp.usersControllerPatchUser(id, patchUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} token 
         * @param {UpdatePasswordDto} updatePasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerResetPassword(token: string, updatePasswordDto: UpdatePasswordDto, options?: any): AxiosPromise<void> {
            return localVarFp.usersControllerResetPassword(token, updatePasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ResetPasswordEmailDto} resetPasswordEmailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerSendResetEmail(resetPasswordEmailDto: ResetPasswordEmailDto, options?: any): AxiosPromise<void> {
            return localVarFp.usersControllerSendResetEmail(resetPasswordEmailDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {HomePageDto} homePageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerSetHomePage(id: string, homePageDto: HomePageDto, options?: any): AxiosPromise<User> {
            return localVarFp.usersControllerSetHomePage(id, homePageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdatePasswordDto} updatePasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerUpdatePassword(id: string, updatePasswordDto: UpdatePasswordDto, options?: any): AxiosPromise<void> {
            return localVarFp.usersControllerUpdatePassword(id, updatePasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerValidateToken(token: string, options?: any): AxiosPromise<void> {
            return localVarFp.usersControllerValidateToken(token, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @param {CreateUserDto} createUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerCreateUser(createUserDto: CreateUserDto, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerCreateUser(createUserDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerGetCompanyUsers(options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerGetCompanyUsers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerGetMe(options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerGetMe(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerGetUser(id: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerGetUser(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LoginDTO} loginDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerLogin(loginDTO: LoginDTO, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerLogin(loginDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerLogout(options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerLogout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {PatchUserDto} patchUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerPatchUser(id: string, patchUserDto: PatchUserDto, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerPatchUser(id, patchUserDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} token 
     * @param {UpdatePasswordDto} updatePasswordDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerResetPassword(token: string, updatePasswordDto: UpdatePasswordDto, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerResetPassword(token, updatePasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ResetPasswordEmailDto} resetPasswordEmailDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerSendResetEmail(resetPasswordEmailDto: ResetPasswordEmailDto, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerSendResetEmail(resetPasswordEmailDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {HomePageDto} homePageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerSetHomePage(id: string, homePageDto: HomePageDto, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerSetHomePage(id, homePageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdatePasswordDto} updatePasswordDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerUpdatePassword(id: string, updatePasswordDto: UpdatePasswordDto, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerUpdatePassword(id, updatePasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerValidateToken(token: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerValidateToken(token, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * YearsApi - axios parameter creator
 * @export
 */
export const YearsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yearsControllerQueryYears: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/years`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * YearsApi - functional programming interface
 * @export
 */
export const YearsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = YearsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yearsControllerQueryYears(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Year>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yearsControllerQueryYears(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * YearsApi - factory interface
 * @export
 */
export const YearsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = YearsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yearsControllerQueryYears(options?: any): AxiosPromise<Array<Year>> {
            return localVarFp.yearsControllerQueryYears(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * YearsApi - object-oriented interface
 * @export
 * @class YearsApi
 * @extends {BaseAPI}
 */
export class YearsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YearsApi
     */
    public yearsControllerQueryYears(options?: AxiosRequestConfig) {
        return YearsApiFp(this.configuration).yearsControllerQueryYears(options).then((request) => request(this.axios, this.basePath));
    }
}


